import { CITY_NAMES } from "./cities";

const locals = {
    RU: {
        pages: {
            VacancyList: {
                menuText: "Карьера",
                loading: "Загрузка...",
                loadingVacancies: "Загрузка вакансий...",
                errorPrefix: "Ошибка",
                postVacancy: "Опубликовать вакансию",
                filters: "Фильтры",
                searchPlaceholder: "Поиск по роли, навыку или категории",
                locationPlaceholder: "Локация",
                allWorkModes: "Все форматы работы",
                allEmploymentTypes: "Все типы занятости",
                tagPlaceholder: "Тег (навык/категория/сектор)",
                filterSuggestions: "Подсказки",
                filterSearching: "Поиск...",
                filterMinCharsHint: "Введите минимум 2 символа для подсказок",
                filterClear: "Очистить поле",
                favoritesOnly: "Только избранное",
                archivedOnly: "Показывать архивные",
                searchTagLabel: "Поиск",
                locationTagLabel: "Локация",
                workModeTagLabel: "Формат работы",
                employmentTagLabel: "Занятость",
                tagTagLabel: "Тег",
                filtersApplied: (count) => `${count} фильтр${count === 1 ? '' : count < 5 ? 'а' : 'ов'} применено`,
                clearAll: "Очистить все",
                resultsFound: (count) => `Найдено: ${count} ${count === 1 ? 'вакансия' : 'вакансий'}`,
                noVacanciesTitle: "По выбранным фильтрам вакансии не найдены.",
                noVacanciesSubtitle: "Попробуйте убрать часть фильтров, чтобы увидеть больше результатов.",
                viewDetails: "Подробнее",
                addToFavorites: "Добавить в избранное",
                removeFromFavorites: "Убрать из избранного",
                archivedBadge: "Архив",
                today: "Сегодня",
                yesterday: "Вчера",
                daysAgo: (days) => `${days} дн. назад`,
                weeksAgo: (weeks) => `${weeks} нед. назад`,
                validInDays: (days) => `Доступно через ${days} дн.`,
                salaryFrom: "от",
                salaryUpTo: "до",
                vacancyFallback: "Вакансия",
                workModeOnSite: "В офисе",
                workModeRemote: "Удаленно",
                workModeHybrid: "Гибрид",
                employmentFullTime: "Полная занятость",
                employmentPartTime: "Частичная занятость",
                employmentContract: "Контракт",
                employmentInternship: "Стажировка",
                page: "Страница",
                previousPage: "Назад",
                nextPage: "Вперёд",
            },
            Mentorship: {
                title: "Менторинг",
                loading: "Загрузка менторинга...",
                disabled: "Менторинг не включён в этом сообществе.",
                tryAgain: "Повторить",
                back: "Назад",
                next: "Далее",
                cancel: "Отмена",
                saveProfile: "Сохранить профиль",
                saving: "Сохранение...",
                chooseHow: "Выберите, как хотите участвовать. Вторую роль можно добавить позже.",
                wantMentor: "Хочу быть ментором",
                findMentor: "Найти ментора",
                beMentor: "Быть ментором",
                findAMentor: "Найти ментора",
                tabDiscover: "Поиск",
                tabFavorites: "Избранное",
                tabRequests: "Запросы",
                tabIncoming: "Входящие",
                tabActive: "Активные",
                tabHistory: "История",
                noHistory: "Истории пока нет.",
                complete: "Завершить",
                full: "Нет мест",
                placesLeft: (count) => (count === 1 ? "1 место" : `${count} мест`),
                capacityLabel: "Сколько менти вы можете взять?",
                capacityHelp: "Лимит активных менти. Когда мест нет, новые заявки недоступны.",
                capacityExample: "Выберите число от 1 до 20.",
                capacityRequired: "Укажите лимит менти от 1 до 20.",
                capacitySaveFailed: "Не удалось обновить лимит менти.",
                saveCapacity: "Сохранить лимит",
                timelineApplied: "Заявка",
                timelineAccepted: "Принят",
                timelineCompleted: "Завершён",
                timelineDeclined: "Отклонён",
                timelineCancelled: "Отменён",
                tabProfile: "Профиль",
                setupMentorProfile: "Настройка профиля ментора",
                setupMenteeProfile: "Настройка профиля менти",
                editProfile: "Редактирование профиля менторинга",
                stepOf: (current, total) => `Шаг ${current} из ${total}`,
                headline: "Заголовок",
                headlinePlaceholder: "Кратко опишите, что вы предлагаете или ищете",
                headlineRequired: "Укажите заголовок, чтобы продолжить.",
                headlineHelpMentor:
                    "Короткая строка на вашей карточке в поиске. Одной фразой опишите, чем можете помочь как ментор.",
                headlineHelpMentee:
                    "Короткая строка на вашей карточке. Одной фразой опишите, какую помощь ищете у ментора.",
                headlineExampleMentor:
                    "Например: «CTO, 12 лет в SaaS. Менторю по карьере, найму и масштабированию команд»",
                headlineExampleMentee:
                    "Например: «Ищу ментора по переходу в Product Management»",
                answerRequired: "Ответьте на обязательный вопрос, чтобы продолжить.",
                answerAllRequired: "Ответьте на все обязательные вопросы.",
                loadQuestionsFailed: "Не удалось загрузить вопросы.",
                saveAnswersFailed: "Не удалось сохранить ответы.",
                loadFailed: "Не удалось загрузить менторинг.",
                switchRoleFailed: "Не удалось переключить роль.",
                switchRoleAfterSaveFailed: "Профиль сохранён, но переключить роль не удалось.",
                searchMentors: "Поиск менторов (например: python, карьера)",
                bestMatch: "Лучшее совпадение",
                newest: "Сначала новые",
                search: "Искать",
                noMentors: "Менторы не найдены.",
                loadMore: "Загрузить ещё",
                loadingMore: "Загрузка...",
                addFavorite: "В избранное",
                removeFavorite: "Убрать из избранного",
                requestMentorship: "Запросить менторинг",
                requestMessagePrompt: "Добавьте сообщение к запросу (необязательно):",
                loadMentorsFailed: "Не удалось загрузить менторов.",
                loadMoreMentorsFailed: "Не удалось загрузить ещё менторов.",
                favoriteFailed: "Не удалось обновить избранное.",
                sendRequestFailed: "Не удалось отправить запрос.",
                loadMentorFailed: "Не удалось загрузить профиль ментора.",
                loadMenteeFailed: "Не удалось загрузить профиль менти.",
                noFavorites: "В избранном пока пусто.",
                loadFavoritesFailed: "Не удалось загрузить избранное.",
                removeFavoriteFailed: "Не удалось убрать из избранного.",
                loadMoreFavoritesFailed: "Не удалось загрузить ещё избранное.",
                noRequests: "Запросов пока нет.",
                loadRequestsFailed: "Не удалось загрузить запросы.",
                cancelRequestFailed: "Не удалось отменить запрос.",
                cancelRequest: "Отменить запрос",
                noIncoming: "Входящих запросов нет.",
                noActive: "Активных менторингов нет.",
                loadIncomingFailed: "Не удалось загрузить входящие запросы.",
                updateRequestFailed: "Не удалось обновить запрос.",
                accept: "Принять",
                decline: "Отклонить",
                noHeadline: "Заголовок ещё не указан",
                hideProfile: "Скрыть профиль",
                makeVisible: "Сделать видимым",
                visibilityFailed: "Не удалось изменить видимость профиля.",
                editAnswers: "Редактировать ответы",
                loadingQuestions: "Загрузка вопросов...",
                loadingMentors: "Загрузка менторов...",
                loadingFavorites: "Загрузка избранного...",
                loadingRequests: "Загрузка запросов...",
                viewProfile: "Смотреть профиль",
                hideDetails: "Скрыть",
                aboutLabel: "О себе",
                lookingForLabel: "Ищу",
                mentorProfile: "Профиль ментора",
                loadingMentor: "Загрузка профиля...",
                noProfileDetails: "Дополнительных деталей пока нет.",
                visible: "Видимый",
                hidden: "Скрытый",
                mentorFallback: "Ментор",
                matchPercent: (percent) => `${percent}% совпадение`,
            },
            VacancyDetail: {
                Common: {
                    loading: "Загрузка...",
                    vacancyFallback: "Вакансия",
                    unknownUser: "Неизвестный пользователь",
                    defaultUserInitial: "U",
                    salaryFrom: "от",
                    salaryUpTo: "до",
                    employmentFullTime: "Полная занятость",
                    employmentPartTime: "Частичная занятость",
                    employmentContract: "Контракт",
                    employmentInternship: "Стажировка",
                    workModeOnSite: "В офисе",
                    workModeRemote: "Удаленно",
                    workModeHybrid: "Гибрид",
                    filters: "Фильтры",
                },
                Detail: {
                    failedToLoadVacancy: "Не удалось загрузить вакансию",
                    externalLinkNotConfigured: "Ссылка на внешний отклик не настроена",
                    failedToSubmitApplication: "Не удалось отправить отклик",
                    applicationWithdrawn: "Отклик отозван",
                    failedToWithdrawApplication: "Не удалось отозвать отклик",
                    vacancyNotFound: "Вакансия не найдена",
                    careerMenuText: "Карьера",
                    companyLogoAlt: "Логотип компании",
                    editVacancy: "Редактировать вакансию",
                    manageQuestions: "Управлять вопросами",
                    applyNow: "Откликнуться",
                    applicationPending: "Отклик на рассмотрении",
                    applicationAccepted: "Отклик принят",
                    applicationRejected: "Отклик отклонен",
                    withdrawApplication: "Отозвать отклик",
                    applicationsPaused: "Прием откликов приостановлен",
                    applicationsOpenLater: "Отклики станут доступны позже",
                    applicationsClosed: "Прием откликов завершен",
                    jobDescription: "Описание вакансии",
                    details: "Детали",
                    posted: "Опубликовано",
                    validUntil: "Действует до",
                    requiredSkills: "Обязательные навыки",
                    preferredSkills: "Желательные навыки",
                    categories: "Категории",
                    sectors: "Сферы",
                    contactPersons: "Контактные лица",
                    creator: "Создатель",
                    responsible: "Ответственный",
                    applications: "Отклики",
                    viewAllApplications: "Посмотреть все отклики",
                },
                CreateVacancy: {
                    parseVacancyUrlRequired: "Введите URL вакансии для разбора",
                    parseVacancyNoCommunity: "Сообщество не выбрано",
                    parseVacancySuccess: "Вакансия успешно разобрана",
                    parseVacancyError:
                        "Не удалось разобрать вакансию. Попробуйте позже или заполните все поля вручную.",
                    parseVacancyEmptyData: "AI-парсер вернул пустые данные вакансии",
                    descriptionRequired: "Описание обязательно",
                    communityNotSelected: "Сообщество не выбрано",
                    failedToLoadVacancy: "Не удалось загрузить вакансию",
                    vacancyUpdatedSuccessfully: "Вакансия успешно обновлена",
                    vacancyCreatedSuccessfully: "Вакансия успешно создана",
                    failedToSaveVacancy: "Не удалось сохранить вакансию",
                    logoUploadedSuccessfully: "Логотип успешно загружен",
                    failedToUploadLogo: "Не удалось загрузить логотип",
                    photoUploadedSuccessfully: "Изображение успешно загружено",
                    failedToUploadPhoto: "Не удалось загрузить изображение",
                    vacancyDeletedSuccessfully: "Вакансия успешно удалена",
                    failedToDeleteVacancy: "Не удалось удалить вакансию",
                    responsibleAddedSuccessfully: "Ответственный успешно добавлен",
                    failedToAddResponsible: "Не удалось добавить ответственного",
                    responsibleRemovedSuccessfully: "Ответственный успешно удален",
                    failedToRemoveResponsible: "Не удалось удалить ответственного",
                    showOnVacancyPage: "Показывать на странице вакансии",
                    hiddenContactPerson: "Скрыт с публичной страницы вакансии",
                    failedToUpdateResponsibleVisibility: "Не удалось обновить видимость контактного лица",
                    careerMenuText: "Карьера",
                    editVacancy: "Редактировать вакансию",
                    createVacancy: "Создать вакансию",
                    parseVacancySectionTitle: "Разобрать вакансию",
                    vacancyUrlLabel: "URL вакансии",
                    vacancyUrlPlaceholder: "https://example.com/jobs/java-developer",
                    parsing: "Разбор...",
                    parseVacancyButton: "Разобрать вакансию",
                    parseVacancyHint: "Вставьте ссылку на страницу вакансии. Парсер заполнит название, компанию, описание, локацию, зарплату, тип занятости, теги и ссылку на отклик.",
                    improveDescriptionButton: "Улучшить описание (AI)",
                    extractFromDescriptionButton: "Заполнить теги из описания (AI)",
                    improvingDescription: "Улучшение...",
                    extractingFromDescription: "Извлечение...",
                    improveDescriptionSuccess: "Описание обновлено",
                    extractFromDescriptionSuccess: "Теги заполнены из описания",
                    descriptionAiTooShort: "Добавьте больше текста в описание (минимум 30 символов)",
                    improveDescriptionError: "Не удалось улучшить описание. Попробуйте позже.",
                    extractFromDescriptionError: "Не удалось извлечь теги из описания. Попробуйте позже.",
                    vacancyUrlFieldHelp: "HTTPS-ссылка на страницу вакансии у работодателя — по ней запускается разбор текста.",
                    titleHelp: "Короткое название роли — так вакансия отображается в списке и в карточке.",
                    organizationNameHelp: "Имя работодателя для кандидатов (не название сообщества на платформе).",
                    descriptionHelp: "Обязанности, требования, условия, стек. Можно списки и ссылки — это основной текст вакансии.",
                    locationHelp: "Город, регион или адрес. Выберите подсказку из поиска — сохранятся координаты для карты.",
                    applicationTypeHelp: "«Платформа» — отклики внутри системы. «Внешний сайт» — переход на ваш сайт с откликом.",
                    externalWebsiteUrlHelp: "Полная ссылка на страницу отклика (https://...). Нужна при типе «Внешний сайт».",
                    acceptApplicationsLabel: "Принимать отклики",
                    acceptApplicationsHelp: "Кандидаты могут отправлять отклик, когда вакансия находится в периоде валидности.",
                    applicationsPausedHint: "Прием откликов приостановлен. Кандидаты увидят, что отправка недоступна.",
                    minSalaryHelp: "Нижняя граница вилки или одна сумма. Оставьте пустым вместе с максимумом, если зарплату не публикуете.",
                    maxSalaryHelp: "Верхняя граница вилки. Можно не заполнять, если указан только минимум или зарплаты нет.",
                    currencyHelp: "Если указана хотя бы одна сумма — выберите валюту. Без зарплаты оставьте «Не указано».",
                    employmentTypeHelp: "Полный день, частичная занятость, контракт или стажировка.",
                    workModeHelp: "Офис, удалённо или гибрид — как устроена работа по месту.",
                    validPeriodHelp: "Когда вакансия видна на витрине. Поля можно не заполнять, если ограничения по датам не нужны.",
                    validFromHelp: "Дата, с которой показывать вакансию кандидатам.",
                    validToHelp: "После этой даты вакансия может скрыться из списка (по правилам витрины).",
                    tagsSectionHelp: "Навыки — конкретный стек и инструменты. Категории и сферы — более широкие метки для фильтров.",
                    requiredSkillsHelp: "Минимум, без которого кандидат не подходит (технологии, методологии, языки).",
                    preferredSkillsHelp: "Плюс к профилю: смежный стек, облака, инструменты — желательно, но не обязательно.",
                    categoriesHelp: "Направление роли, например Software Development, UX Design.",
                    sectorsHelp: "Отрасль или тип бизнеса: FinTech, Healthcare, Insurance и т.п.",
                    logoSectionHelp: "Квадратный логотип компании — в списке вакансий и в карточке.",
                    vacancyImageSectionHelp: "Широкое изображение-баннер для карточки; по желанию.",
                    basicInformation: "Основная информация",
                    titleLabel: "Название",
                    organizationNameLabel: "Название компании",
                    organizationNamePlaceholder: "Название компании или работодателя",
                    descriptionLabel: "Описание",
                    slugLabel: "Slug",
                    slugFieldHelp: "Короткий адрес в URL (латиница, дефисы). Пусто — сгенерируется из названия.",
                    slugHint: "Оставьте пустым для автогенерации из названия.",
                    locationLabel: "Локация",
                    locationPlaceholder: "Введите локацию (например, Мюнхен, Германия)",
                    searchingCity: "Поиск города...",
                    coordinatesSaved: "Координаты сохранены",
                    applicationTypeSectionTitle: "Тип отклика",
                    applicationTypeLabel: "Тип отклика",
                    applicationTypePlatform: "Платформа (обработка в системе)",
                    applicationTypeExternalWebsite: "Внешний сайт (редирект)",
                    externalWebsiteUrlLabel: "URL внешнего сайта",
                    salaryAndEmployment: "Зарплата и занятость",
                    minSalaryLabel: "Минимальная зарплата",
                    maxSalaryLabel: "Максимальная зарплата",
                    currencyLabel: "Валюта",
                    currencyNotSpecified: "Не указано",
                    salaryCurrencyRequiredWhenSalarySet:
                        "Укажите валюту, если заполнена зарплата (мин. или макс.).",
                    currencyNames: {
                        EUR: "Евро",
                        USD: "Доллар США",
                        GBP: "Фунт стерлингов",
                        CHF: "Швейцарский франк",
                        JPY: "Японская иена",
                        CNY: "Китайский юань",
                        HKD: "Гонконгский доллар",
                        SGD: "Сингапурский доллар",
                        AUD: "Австралийский доллар",
                        NZD: "Новозеландский доллар",
                        CAD: "Канадский доллар",
                        SEK: "Шведская крона",
                        NOK: "Норвежская крона",
                        DKK: "Датская крона",
                        ISK: "Исландская крона",
                        PLN: "Польский злотый",
                        CZK: "Чешская крона",
                        HUF: "Венгерский форинт",
                        RON: "Румынский лей",
                        BGN: "Болгарский лев",
                        UAH: "Украинская гривна",
                        RUB: "Российский рубль",
                        GEL: "Грузинский лари",
                        TRY: "Турецкая лира",
                        AED: "Дирхам ОАЭ",
                        SAR: "Саудовский риял",
                        ILS: "Новый израильский шекель",
                        INR: "Индийская рупия",
                        IDR: "Индонезийская рупия",
                        THB: "Тайский бат",
                        VND: "Вьетнамский донг",
                        PHP: "Филиппинское песо",
                        MYR: "Малайзийский ринггит",
                        KRW: "Южнокорейская вона",
                        BRL: "Бразильский реал",
                        MXN: "Мексиканское песо",
                        ARS: "Аргентинское песо",
                        ZAR: "Южноафриканский рэнд",
                    },
                    employmentTypeLabel: "Тип занятости",
                    workModeLabel: "Формат работы",
                    validPeriodLabel: "Период действия",
                    optional: "опционально",
                    validFromLabel: "Действует с",
                    validToLabel: "Действует до",
                    tagsSectionTitle: "Теги",
                    requiredSkillsLabel: "Обязательные навыки",
                    requiredSkillsPlaceholder: "Поиск навыков (например, Java, Spring Boot)",
                    preferredSkillsLabel: "Желательные навыки",
                    preferredSkillsPlaceholder: "Поиск навыков (например, Docker, AWS)",
                    categoriesLabel: "Категории",
                    categoriesPlaceholder: "Поиск категорий",
                    sectorsLabel: "Сферы",
                    sectorsPlaceholder: "Поиск сфер",
                    logoSectionTitle: "Логотип",
                    squareOnly: "Любой размер, итоговый логотип будет квадратным",
                    vacancyLogoPreviewAlt: "Предпросмотр логотипа вакансии",
                    logoLabel: "Логотип",
                    uploadLogo: "Загрузить логотип",
                    cropLogo: "Обрезать логотип",
                    cropLogoDescription: "Можно загрузить любое изображение — итоговый логотип будет обрезан до квадрата",
                    uploadingLogo: "Загрузка логотипа...",
                    vacancyImageSectionTitle: "Изображение вакансии",
                    vacancyImagePreviewAlt: "Предпросмотр изображения вакансии",
                    vacancyImageLabel: "Изображение вакансии",
                    uploadVacancyImage: "Загрузить изображение вакансии",
                    cropVacancyImage: "Обрезать изображение вакансии",
                    cropVacancyImageDescription: "Подкорректируйте изображение вакансии перед загрузкой",
                    uploadingImage: "Загрузка изображения...",
                    vacancyResponsibles: "Ответственные за вакансию",
                    searchParticipants: "Поиск участников",
                    searchParticipantsPlaceholder: "Введите имя, username или slug",
                    searchResults: "Результаты поиска",
                    add: "Добавить",
                    currentResponsibles: "Текущие ответственные",
                    remove: "Удалить",
                    noResponsiblesYet: "Пока нет ответственных",
                    noResponsiblesDescription: "Добавьте участников, которые могут управлять этой вакансией.",
                    delete: "Удалить",
                    cancel: "Отмена",
                    saving: "Сохранение...",
                    update: "Обновить",
                    create: "Создать",
                    deleteVacancyTitle: "Удалить вакансию",
                    deleteVacancyMessage: "Вы уверены, что хотите удалить эту вакансию?",
                    deleteVacancyWarning: "Это действие нельзя отменить.",
                    confirmDelete: "Да, удалить",
                    cancelDelete: "Отмена",
                    selectFile: "Выбрать файл",
                    rotate: "Повернуть",
                    save: "Сохранить",
                    back: "Назад",
                    clearSearch: "Очистить поиск",
                    suggestions: "Подсказки",
                    searching: "Поиск...",
                    chooseImageForLogo: "Выберите изображение для логотипа",
                    chooseImageForVacancyImage: "Выберите изображение для изображения вакансии",
                    uploadAvailableAfterCreate: "Загрузить логотип и изображение можно после создания вакансии.",
                    change: "Изменить",
                    upload: "Загрузить",
                    anyRatio: "Любой формат",
                    squareRatio: "1:1 квадрат",
                    freeCropWithSquareResult: "Можно выбрать любой формат обрезки. Итоговый логотип будет сохранен как квадрат на белом фоне.",
                },
                QuestionManager: {
                    failedToLoadVacancy: "Не удалось загрузить вакансию",
                    failedToLoadQuestions: "Не удалось загрузить вопросы",
                    failedToLoadQuestion: "Не удалось загрузить вопрос",
                    deleteQuestionConfirm: "Удалить этот вопрос?",
                    questionDeleted: "Вопрос удален",
                    failedToDeleteQuestion: "Не удалось удалить вопрос",
                    questionUpdated: "Вопрос обновлен",
                    questionCreated: "Вопрос создан",
                    failedToSaveQuestion: "Не удалось сохранить вопрос",
                    vacancyNotFound: "Вакансия не найдена",
                    backToVacancy: "Назад к вакансии",
                    pageTitle: "Менеджер вопросов вакансии",
                    newQuestion: "Новый вопрос",
                    noQuestionsYet: "Пока нет вопросов.",
                    order: "Порядок",
                    question: "Вопрос",
                    type: "Тип",
                    visible: "Видим",
                    actions: "Действия",
                    yes: "Да",
                    no: "Нет",
                    edit: "Редактировать",
                    delete: "Удалить",
                    editQuestion: "Редактировать вопрос",
                    createQuestion: "Создать вопрос",
                    questionText: "Текст вопроса",
                    questionType: "Тип вопроса",
                    required: "Обязательный",
                    answerOptions: "Варианты ответа",
                    manageAnswerOptions: "Управлять вариантами ответа",
                    cancel: "Отмена",
                    save: "Сохранить",
                    saving: "Сохранение...",
                    questionTypeTextInput: "Текстовый ввод",
                    questionTypeRadio: "Один вариант (Radio)",
                    questionTypeCheckbox: "Несколько вариантов (Checkbox)",
                    questionTypeFileUpload: "Загрузка файла",
                    questionTypeCvUpload: "Загрузка CV",
                    questionTypeCoverLetterUpload: "Загрузка сопроводительного письма",
                    questionTypeCertificateUpload: "Дипломы, сертификаты и т.д.",
                },
                Applications: {
                    failedToLoadVacancyApplications: "Не удалось загрузить отклики на вакансию",
                    failedToUpdateStatus: "Не удалось обновить статус",
                    noPendingApplications: "Нет откликов со статусом PENDING",
                    pendingApplicationsRejected: "Ожидающие отклики отклонены",
                    failedToRejectRemaining: "Не удалось отклонить оставшиеся",
                    unnamedCandidate: "Кандидат без имени",
                    attachment: "Вложение",
                    file: "Файл",
                    vacancyNotFound: "Вакансия не найдена",
                    backToVacancy: "Назад к вакансии",
                    applicationsTitle: "Отклики",
                    rejecting: "Отклонение...",
                    rejectRemaining: "Отклонить оставшиеся (ожидающие)",
                    noApplicationsYet: "Пока нет откликов.",
                    noApplicationsMatchFilters: "Нет откликов, соответствующих выбранным фильтрам.",
                    noEmailProvided: "Email не указан",
                    appliedAt: "Подано",
                    notAvailable: "н/д",
                    accept: "Принять",
                    reject: "Отклонить",
                    attachedFiles: "Прикрепленные файлы",
                    noAttachedFiles: "Нет прикрепленных файлов.",
                },
                ApplicationDetails: {
                    applicationNotFound: "Отклик не найден",
                    failedToLoadApplicationDetails: "Не удалось загрузить детали отклика",
                    document: "документ",
                    failedToDownloadFile: "Не удалось скачать файл",
                    failedToUpdateStatus: "Не удалось обновить статус",
                    unnamedCandidate: "Кандидат без имени",
                    backToApplications: "Назад к откликам",
                    applicationDetailsTitle: "Детали отклика",
                    accept: "Принять",
                    reject: "Отклонить",
                    noEmailProvided: "Email не указан",
                    about: "О себе",
                    submittedAnswers: "Отправленные ответы",
                    noAnswersSaved: "Ответы не сохранены.",
                    question: "Вопрос",
                    answer: "Ответ",
                    files: "Файлы",
                },
                Apply: {
                    failedToLoadVacancy: "Не удалось загрузить вакансию",
                    applicationSubmittedSuccessfully: "Отклик успешно отправлен",
                    failedToSubmitApplication: "Не удалось отправить отклик",
                    loading: "Загрузка...",
                    backToVacancy: "Назад к вакансии",
                },
            },
            ContactList: {
                title: "Контакты",
                menuText: "Контакты",
                olderContacts: "Показать ещё",
                nocontent:
                    "В дальнейшем тут появится информация и контактные данные подобранных Вам партнеров для встреч",
                noBookmarks: "В этой вкладке будут отображаться контактные данные и информация о людях, которых Вы добавили в закладки.",
                noInterested: "В этой вкладке будут отображаться люди, которые вызвали Ваш интерес и с которыми Вы хотели бы связаться.",
                interested: "Интересные",
                bookmarked: "Закладки",
                removeBookmark: "Удалить из закладок",
            },
            Participants: {
                title: "Участники",
                menuText: "Участники",
                nocontent:
                    "Пока тут никого нет<br/>В дальнейшем здесь появится информация и контактные данные участников сообщества",
                moreParticipants: "Больше участников",
                dislikedUsers: "Скрытые участники",
                normalSearch: "Обычный поиск",
                smartSearch: "Умный поиск",
                smartSearchSubmit: "Умный поиск",
                searchPlaceholder: "Поиск по имени или экспертизе",
                smartSearchPlaceholder: "Опишите, кого вы хотите найти",
                clearSearch: "Очистить поиск",
                searchError: "Не удалось загрузить участников",
                retry: "Повторить",
                searchEmpty: "Никого не нашли. Измените запрос и попробуйте снова.",
                backToResults: "Назад к участникам",
            },
            EventList: {
                title: "События",
                menuText: "События",
                upcoming: "Предстоящие",
                past: "Прошедшие",
                noEvents: "События пока не добавлены",
                noEventsBtn: "Добавить событие",
                dateTbc: "Дата уточняется",
                timeTbc: "Время уточняется",
                event: "Событие",
                eventTitle: "Название события",
                locationTbc: "Местоположение уточняется",
                going: "идут",
                namesAndOthers: (name1, name2, others) => `${name1}, ${name2} и ${others} других`,
                namesAndOthersSome: (name1, name2) => `${name1}, ${name2} и другие`,
                createEvent: "Создать событие",
                // Filters
                filters: "Фильтры",
                date: "Дата",
                location: "Местоположение",
                city: "Город",
                country: "Страна",
                eventType: "Тип события",
                myEvents: "Мои события",
                whereIOrganize: "Где я организатор",
                eventsICreated: "Которые я создал",
                all: "Все",
                online: "Онлайн",
                offline: "Офлайн",
                // Date filters
                startDate: "Дата начала",
                endDate: "Дата окончания",
                clearStartDate: "Очистить дату начала",
                clearEndDate: "Очистить дату окончания",
                startDateHint: "Оставьте пустым, чтобы показывать события с сегодняшнего дня",
                endDateHint: "Необязательно: Оставьте пустым для отсутствия ограничения по дате",
                // Date filter options
                allEvents: "Все события",
                today: "Сегодня",
                tomorrow: "Завтра",
                thisWeekend: "Эти выходные",
                thisWeek: "Эта неделя",
                nextWeek: "Следующая неделя",
                thisMonth: "Этот месяц",
                nextMonth: "Следующий месяц",
                // SearchableSelect
                searchCity: "Поиск города...",
                searchCountry: "Поиск страны...",
                typeToSearch: "Введите для поиска...",
                loading: "Загрузка...",
                noResultsFound: "Результаты не найдены для",
                noOptionsAvailable: "Нет доступных вариантов",
                clearSelection: "Очистить выбор",
                // Errors
                communityIdNotFound: "ID сообщества не найден",
                failedToLoadEvents: "Не удалось загрузить события",
                // Pagination and results
                showingEvents: "Показано {current} из {total} событий",
                previous: "Назад",
                next: "Далее",
                page: "Страница",
                updating: "Обновление...",
                pastEvents: "Прошлые события",
                fromToday: "с сегодня",
                total: "всего",
                eventsTotal: (total) => `События (всего ${total})`,
                noFutureEvents: "Нет будущих событий",
                noUpcomingShowingPast: "Предстоящих событий нет. Показаны недавние прошедшие.",
                loadingEvents: "Загрузка…",
                clickPreviousToSeePast: "Нажмите «Назад», чтобы увидеть прошлые события",
                noPastEvents: "Прошлых событий пока нет",
            },
            FAQ: {
                menuText: "FAQ",
            },
            Admin: {
                title: "Название сообщества",
                menuText: "Название сообщества",
                description: "Описание сообщества",
                communityCRM: "CRM сообщества",
                analytics: "Аналитика",
                noParticipants: "Пока тут никого нет",
            },
            UserAdmin: {
                title: "Админ панель",
                description: "Управление настройками сообщества и модерация участников",
                participantModeration: {
                    title: "Модерация участников",
                    searchPlaceholder: "Поиск по имени, логину или email",
                    refresh: "Обновить",
                    allStatus: "Все статусы",
                    pending: "Ожидает",
                    confirmed: "Подтвержден",
                    rejected: "Отклонен",
                    participant: "Участник",
                    status: "Статус",
                    actions: "Действия",
                    confirm: "Подтвердить",
                    reject: "Отклонить",
                    noPermission: "У вас нет прав для доступа к функциям модерации",
                    loadingParticipants: "Загрузка участников...",
                    loadingAdminPanel: "Загрузка админ панели..."
                },
                community: {
                    title: "Сообщество",
                    export: "Экспорт",
                    messageAll: "Сообщение всем",
                    searchPlaceholder: "Поиск по имени, логину или email",
                    refresh: "Обновить",
                    allStatus: "Все статусы",
                    pending: "Ожидает",
                    confirmed: "Подтвержден",
                    rejected: "Отклонен",
                    participant: "Участник",
                    status: "Статус",
                    actions: "Действия",
                    message: "Сообщение",
                    profile: "Профиль",
                    networking: "Нетворкинг",
                    delete: "Удалить",
                    active: "Активные",
                    disabled: "Отключенные",
                    deleteModal: {
                        title: "Это действие необратимо",
                        description: "больше не сможет получить доступ к платформе сообщества.\nПодтвердите, решив уравнение ниже:",
                        delete: "Удалить",
                        cancel: "Отмена"
                    },
                    noPermission: "У вас нет прав для доступа к управлению сообществом",
                    loadingParticipants: "Загрузка участников...",
                    exportSuccess: "Экспорт завершен успешно",
                    exportError: "Ошибка при экспорте",
                    messageAllSuccess: "Сообщения отправлены всем участникам",
                    messageAllError: "Ошибка при отправке сообщений"
                },
                bulkNetworking: {
                    title: "Управление нетворкингом",
                    description: "Применение правил нетворкинга к нескольким участникам одновременно.",
                    disableWithoutTelegramLabel: "Отключить нетворкинг для участников без подключенного Telegram",
                    apply: "Применить",
                    enableAll: "Включить нетворкинг для всех участников",
                    success: (count) => `Нетворкинг отключен для ${count} участников без подключенного Telegram`,
                    enableAllSuccess: (count) => `Нетворкинг включен для ${count} участников`,
                    error: "Не удалось обновить нетворкинг для участников без подключенного Telegram",
                    enableAllError: "Не удалось включить нетворкинг для всех участников"
                },
                analytics: {
                    title: "Аналитика",
                    overview: "Обзор",
                    participants: "Участники",
                    events: "События",
                    engagement: "Вовлеченность",
                    growth: "Рост",
                    activity: "Активность",
                    statistics: "Статистика",
                    charts: "Графики",
                    reports: "Отчеты",
                    export: "Экспорт",
                    refresh: "Обновить",
                    loading: "Загрузка аналитики...",
                    noData: "Нет данных для отображения",
                    noPermission: "У вас нет прав для просмотра аналитики",
                    error: "Ошибка загрузки данных",
                    mostActive: "САМЫЕ АКТИВНЫЕ",
                    mostPopular: "САМЫЕ ПОПУЛЯРНЫЕ",
                    mostPositive: "САМЫЕ ПОЗИТИВНЫЕ",
                    popularity: "Популярность",
                    meetingsParticipated: "ВСТРЕЧ УЧАСТВОВАЛ",
                    interestingMarksReceived: "ИНТЕРЕСНЫХ ОТМЕТОК ПОЛУЧЕНО",
                    averageFeedbackScore: "СРЕДНИЙ БАЛЛ ОТЗЫВОВ",
                    profiles: "Профили",
                    registrations: "Регистрации",
                    reviews: "Отзывы",
                    connects: "Связи",
                    totalOpened: "Всего открыто",
                    profilesFilledProperly: "Профили заполнены правильно",
                    onboardingsFilledProperly: "Онбординги заполнены правильно",
                    registrationsDescription: "Регистрации — сколько пользователей регистрируется в сообществе каждый день",
                    growthDescription: "Рост — общее количество пользователей в сообществе",
                    total: "всего",
                    averageScore: "средний балл",
                    perWeek: "в неделю",
                    reviewsDescription: "Отзывы — средний балл после каждой недели встреч между участниками сообщества",
                    connectsDescription: "Связи — среднее количество встреч каждую неделю между участниками сообщества",
                    activeness: "Активность",
                    communityStars: "Звезды сообщества",
                    positivity: "Позитивность",
                    activenessDescription: "Средняя активность вашего сообщества составляет",
                    connectsPerPerson: "связей на человека",
                    activenessResult: "Это не лучший результат, но мы знаем, как его улучшить.",
                    communityStarsDescription: "Познакомьтесь со звездами вашего сообщества! Они были самыми популярными в этом месяце, получив больше всего запросов на встречи.",
                    positivityDescription: "Уровень позитивности вашего сообщества =",
                    positivityResult: "Это хороший результат! Поздравляем!",
                    recommendations: "Рекомендации:",
                    activenessRecommendation: "Попросите заполнить больше информации в профилях участников сообщества. Это увеличит количество запросов на связь между участниками на платформе",
                    communityStarsRecommendation: "Рекомендуем провести 1-1 звонок с ними. Они могут стать вашими бренд-амбассадорами и делиться контентом о вашем бренде",
                    positivityRecommendation: "Во время ваших мероприятий и рассылок упоминайте, что очень важно делиться отзывами о новых связях в сообществе",
                    distributionOfMeetings: "Распределение встреч",
                    distributionOfRequests: "Распределение запросов",
                    distributionOfScoreRates: "Распределение баллов",
                    topMembers: "ТОП УЧАСТНИКОВ",
                    meetings: "встречи",
                    requests: "запросы",
                    asAvgScore: "как средний балл"
                },
                faq: {
                    title: "Управление FAQ",
                    description: "Редактируйте контент FAQ на странице /faq для каждого языка.",
                    contentLabel: "Контент FAQ",
                    saved: "FAQ сохранён",
                    saveError: "Не удалось сохранить FAQ",
                    saving: "Сохранение...",
                    save: "Сохранить FAQ",
                },
                conferenceButtons: {
                    title: "Telegram: кнопки конференции",
                    description: "Настройте дополнительные кнопки Telegram-бота для режима конференции.",
                    hint: "До 6 кнопок. Всегда заполняйте RU и EN — язык Telegram у пользователя может отличаться от языка сообщества. Поддерживаются жирный текст, курсив, ссылки и переносы строк.",
                    buttonTitle: "Кнопка {n}",
                    addButton: "Добавить кнопку",
                    removeButton: "Удалить",
                    idLabel: "ID кнопки",
                    labelField: "Название кнопки",
                    descriptionField: "Описание для /start и /info",
                    descriptionHint: "Короткая строка в приветствии и в «Информация». Формат: «Название — описание».",
                    descriptionPlaceholder: "список спикеров конференции",
                    contentField: "Текст кнопки",
                    editorHint: "Можно использовать жирный текст, ссылки и списки. Неподдерживаемые теги будут удалены при отправке.",
                    telegramLengthHint: "длина для Telegram",
                    saved: "Кнопки конференции сохранены",
                    saveError: "Не удалось сохранить кнопки конференции",
                    saving: "Сохранение...",
                    save: "Сохранить кнопки",
                },
                chats: {
                    title: "Чаты",
                    description: "Модерация заявок на знакомство и настройки интро-чатов.",
                    queue: "Очередь интро",
                    queueHint: "Одобрить или отклонить заявку, прежде чем откроется чат.",
                    conversations: "Диалоги",
                    conversationsHint: "Просмотр, блокировка и модерация существующих чатов.",
                    settings: "Настройки чатов",
                    settingsHint: "Сценарии, шаблоны интро, профиль бота и уведомления менеджера.",
                },
                notifications: {
                    title: "Уведомления",
                    individual: "Индивидуальные",
                    general: "Общие",
                    email: "Email",
                    telegram: "Telegram",
                    sms: "SMS",
                    send: "Отправить",
                    preview: "Предварительный просмотр",
                    subject: "Тема",
                    message: "Сообщение",
                    recipients: "Получатели",
                    allParticipants: "Все участники",
                    selectedParticipants: "Выбранные участники",
                    byLocation: "По местоположению",
                    byStatus: "По статусу",
                    byTags: "По тегам",
                    template: "Шаблон",
                    custom: "Пользовательский",
                    loading: "Загрузка уведомлений...",
                    sending: "Отправка...",
                    success: "Уведомления отправлены успешно",
                    error: "Ошибка при отправке уведомлений",
                    confirmSendTitle: "Отправить уведомление?",
                    confirmSendBody: "Получатели получат это сообщение. Запись появится в истории отправок.",
                    noPermission: "У вас нет прав для отправки уведомлений",
                    selectParticipant: "Выберите участника",
                    selectTemplate: "Выберите шаблон",
                    enterMessage: "Введите сообщение",
                    enterSubject: "Введите тему",
                    viewBy: "Просмотр по",
                    channelType: "Тип канала",
                    messageType: "Тип сообщения",
                    emailMessages: "Email сообщения",
                    telegramMessages: "Telegram сообщения",
                    groupChatNotifications: "Уведомления группового чата",
                    generalCommunityNotification: "Общее уведомление сообщества",
                    generalDescription: "Отправить уведомление всем участникам сообщества в свободном формате",
                    generalEventNotification: "Общее уведомление мероприятия",
                    generalEventDescription: "Отправить уведомление участникам мероприятия по статусу",
                    selectEventStatus: "Выберите статус участников",
                    confirmedAndPending: "Подтверждено + Ожидает",
                    selectEventFirst: "Сначала выберите мероприятие для выбора статуса",
                    participantsPreview: "Превью участников",
                    selectEventToPreview: "Выберите мероприятие для просмотра участников",
                    selectStatusToPreview: "Выберите статус для просмотра участников",
                    noParticipantsForStatus: "Нет участников для выбранного статуса",
                    removeParticipant: "Убрать участника из рассылки",
                    loadingParticipants: "Загрузка участников...",
                    recommendContacts: "Рекомендовать контакты",
                    recommendDescription: "Рекомендовать несколько участников всем участникам сообщества",
                    individualNotification: "Индивидуальное уведомление",
                    individualDescription: "Отправить уведомление выбранным участникам по email или Telegram. Они получат его даже если их профиль отключен. Для Telegram можно прикрепить изображение.<br/><b>Примечание:</b> Если участник отписался от канала, мы не сможем доставить уведомление.",
                    groupChatDescription: "Отправить уведомление подключенным группам в Telegram. Изображение необязательно.<br/>Для форматирования текста используйте html, <a href=\"https://core.telegram.org/bots/api#html-style\" target=\"_blank\">подробнее</a>",
                    selectedLocations: "Выбранные местоположения:",
                    titleLabel: "Заголовок",
                    textLabel: "Текст",
                    signatureLabel: "Подпись",
                    placeholderHelp: "Вы можете использовать плейсхолдеры для персонализации: <code>{firstName}</code>, <code>{lastName}</code>, <code>{fullName}</code>. Они будут автоматически заменены на данные каждого получателя.",
                    selectedParticipantsLabel: "Выбранные участники:",
                    searchByName: "Поиск по имени",
                    upToParticipants: "участников",
                    selectAtLeast: "Выберите минимум 1 участника",
                    noImageChosen: "Изображение не выбрано",
                    chooseImage: "Выбрать изображение",
                    captionLabel: "Подпись",
                    sendNotification: "Отправить уведомление",
                    all: "ВСЕ",
                    image: "Изображение",
                    caption: "Подпись",
                    signature: "Подпись",
                    saveDraft: "Сохранить черновик",
                    mailingJournal: "Журнал рассылок",
                    drafts: "Черновики",
                    sends: "Отправки",
                    openAsNew: "Открыть как новую",
                    skipped: "Пропущено",
                    sent: "Отправлено",
                    photo: "Фото",
                    characterLimit: "Превышен лимит символов",
                    telegramPhotoHint: "Необязательно: одно фото. Лимит подписи 1024 с фото, 4096 без фото.",
                    delete: "Удалить",
                    noDrafts: "Нет черновиков",
                    noSends: "Нет отправок",
                    channel: "Канал",
                    sentAt: "Дата",
                    login: "Логин",
                    fullName: "Имя",
                    searchByLogin: "Поиск по логину",
                    previous: "Назад",
                    next: "Далее",
                    cancel: "Отмена",
                    deleteDraftTitle: "Удалить черновик?",
                    deleteDraftConsequences: "Черновик исчезнет из журнала. Уже отправленные копии останутся. Неиспользуемые картинки этого черновика могут быть удалены из хранилища. Отменить нельзя.",
                    deleteSendTitle: "Удалить запись отправки?",
                    deleteSendConsequences: "Исчезнут снимок этой рассылки и список получателей. Сообщения, которые уже ушли, не отзовутся. Неиспользуемые картинки этой отправки могут быть удалены из хранилища. Отменить нельзя."
                }
            },
            welcome: {
                title: "Начните общение с участниками сообщества",
                description:
                    "Алгоритм подберет для вас сообщества согласно вашим интересам и запросам, после чего отправит вам на почту предложение об онлайн-встрече 1:1",
                button: "Начать общение",
                about: {
                    mainLink: "Главная",
                    aboutLink: "О сервисе",
                    politicsLink: "Политика конфиденциальности",
                    launchLink: "Запустить своё комьюнити",
                    contactUs: "Напишите нам",
                    runBy: "Работает на",
                    rightsReserved: "Все права защищены",
                    volee: "Это приложение",
                    description1:
                        " – комьюнити платформа для создания и управления онлайн сообществами.",
                    description2:
                        "Находите новые контакты для развития себя и своего дела.",
                },
                shortLanding: {
                    iconBlockTitle: "Сообщество поможет вам",
                    howItWorks: "Как это работает",
                    community: "Community"
                }
            },
            Auth: {
                email: "Электронная почта",
                password: "Пароль",
                passwordHint: "Не менее 8 символов",
                repeatedPassword: "Повторите пароль",
                emailPlaceholder: "Введите ваш email",
                passwordPlaceholder: "********",
                successText: "Отлично! 👍👍👍",
                googleButtonText: "Продолжить с Google",
                orContinueWith: "или продолжить с",
                or: "или",
                shortAuthButton: "Присоединиться"
            },
            login: {
                title: "Рады видеть снова",
                subtitle: "Войдите, чтобы продолжить",
                button: "Войти",
                accountQuestion: "У вас нет аккаунта? ",
                link: "Зарегистрироваться",
                successText: "Отлично! 👍👍👍",
                recoveryQuestion: "Забыли пароль? ",
                recovery: "Восстановить",
                communityMismatchError: "Вы уже зарегистрированы в другом сообществе.",
                telegramNotLinkedError: "Телеграм-аккаунт не привязан. Войдите по email, чтобы продолжить.",
                openCommunityLink: "Открыть ваше сообщество",
            },
            Registration: {
                title: "Начнём",
                subtitle: "Создайте свой профиль",
                button: "Зарегистрироваться",
                accountQuestion: "Уже есть аккаунт? ",
                link: "Войти",
                agreePolicy: [
                    "Я принимаю условия ",
                    " и даю своё согласие на обработку моих персональных данных на условиях, определенных ",
                ],
                termsOfUse: "Пользовательского соглашения",
                privacyPolicy: "Политикой конфиденциальности",
                error: {
                    "Duplicate email": "Эта почта уже зарегистрирована",
                },
            },
            Recovery: {
                title: "Найдём",
                button: "Восстановить",
                accountQuestion: "Вспомнили? ",
                link: "Войти",
                successText: "Отлично! 👍👍👍",
            },
            ConfirmRecovery: {
                title: "Новый пароль",
                button: "Восстановить",
                accountQuestion: "Передумали? ",
                link: "Войти",
                successText: "Отлично! Теперь вы можете залогиниться",
            },
            OneTimeCode: {
                title: "Отправили код на почту",
                subtitle: "Укажите его, чтобы подтвердить вход с ",
                button: "Подтвердить",
                label: "Введите код",
                resendAfter: (time) => `Повторить можно через 00:${time}`,
                resend: "Отправить ещё раз",
                invalidCode: "Неверный код",
                rateLimitResend: (seconds) => `Слишком много запросов на отправку кода. Попробуйте через ${seconds} сек.`,
                rateLimitValidate: (seconds) => `Слишком много попыток ввода кода. Попробуйте через ${seconds} сек.`,
                validateBlocked: (seconds) => `Проверка кода временно заблокирована. Повторите попытку через ${seconds} сек.`,
                sendCode: "Отправить код",
                changeEmail: "Изменить email",
                changeEmailDescr: "Введите другой email, чтобы получить код",
            },
            MyCommunities: {
                title: "Главная",
                menuText: "Сообщество",
                description:
                    "Здесь вы можете найти новых пратнёров или клиентов, поделиться опытом и обсудить проблемы предпринимательства во времена COVID",
                nocontent:
                    "Обратитесь к комьюнити-менеджеру, чтобы получить ссылку на сообщество",
                nocontentBtn: "Перезагрузить",
                successText: "Ваш новый запрос успешно сохранен",
                successSubtitle: "Вы получите еще больше полезных рекомендаций",
                successButton: "Хорошо",
                changeSearchForText: "Изменить критерии поиска",
                changeSearchForButton: "Сохранить",
                searchForPlaceholder: "Введите свой запрос сообществу",
                lastMeetingsTitle: "Как прошла ваша встреча",
                lastMeetingsScore: "Оценка",
                lastMeetingsNote: "Заметки о встрече (по желанию)",
                lastMeetingsNoMeeting: "Не получилось встретиться",
                lastMeetingsSumbit: "Отправить",
                lastMeetingsPopupTitle: "Спасибо за ваш ответ",
                criteriaTitle: (longVersion) =>
                    `${longVersion ? "Кого вы ищете? " : ""}Чтобы найти релевантных людей для вас и вашего дела, напишите свой запрос сообществу${longVersion ? " тут" : ""}`,
                criteriaTip:
                    "The list below will change some time after you change your request",
                members: "участников",
                mapShowParticipants: "Участники",
                mapShowEvents: "События",
                mapShowEventTitles: "Названия событий",
                toggleActiveText: {
                    firstPart: "Уведомления о мероприятиях и встречах.",
                    secondPart: "Также можно найти нужных людей на странице",
                    link: "Участники",
                    discordSecondPart: "Присоединяйся к нашему",
                    discordLink: "Discord сообществу",
                },
                toggleDisabledText: {
                    firstPart:
                        "Начните получать новые контакты из сообщества на почту",
                    or: " или ",
                },
                recommended: "Рекомендованные контакты",
                recommendationsLoading: "Поиск наиболее релевантных участников...",
                noRecommendations: "Вы посмотрели все рекомендованные контакты. Скоро появятся новые рекомендации",
                noRecommendationsBtn: "Все участники",
                moreContacts: "Больше контактов",
                interestedSuccessTitle: "Сообщение отправлено",
                interestedSuccessContent: (likedName) => `Пожалуйста, дождитесь ответа от ${likedName}, чтобы договориться о встрече`,
                notInterestedSuccessTitle: "Спасибо за ваш ответ",
                notInterestedSuccessContent: "Контакт скрыт из рекомендаций",
                outOfCredits: "Кредиты закончились",
                bookmarked: "Добавлено в <a href='/contacts/bookmarks'>закладки</a>",
                unbookmarked: "Удалено из закладок",
                tryAgainIn: (timeLeft) => `Попробуйте снова через ${timeLeft}`,
                recommendedTab: "Рекомендации",
                requestsTab: "Запросы",
                myRequest: "Мой Запрос",
            },
            Onboarding: {
                profileFormTitle: "Анкета участника",
                aboutYouTitle: "О Себе",
                linkedInTitle: "Профиль LinkedIn",
                linkedInDescription: "Укажите ссылку на ваш LinkedIn, чтобы автоматически заполнить данные и упростить процесс регистрации",
                locationTitle: "Местоположение",
                locationForDescription: "Знание местоположения поможет соединить вас с теми, кто действительно имеет значение",
                searchForTitle: "Ваш запрос",
                searchForDescription:
                    "Напишите свой запрос сообществу. Например: “Я ищу IT предпринимателей для обмена опытом”. Ваши рекомендации обновятся соответственно запросу.",
                contactsTitle: "Контакты",
                socialNetworkTitle: "Социальные сети",
                yourPhotoTitle: "Ваша фотография",
                searchForButtonText: "Нет особых пожеланий",
                searchForDefaultText: "Нет особых пожеланий",
                buddy: {
                    survey: "Great start! A couple of questions and we will find the best contact in the community that meets your business needs.",
                    aboutYou:
                        "Tell the community about your business to get support and new opportunities.",
                    searchFor:
                        "It would help us to find the right people for you and your business.",
                    contacts:
                        "Specify social networks so that community members can contact you there.",
                },
            },
            LastStep: {
                activeIndexText: "Последний шаг",
                nextButtonText: "Пропустить",
                stepTitle: "Подтверждение почты",
                resendRecoveryEmail: "Отправить снова",
                resendSuccessText: (minutes, seconds) =>
                    `Электронное письмо с подтверждением почты успешно отправлено. Отправить снова будет возможно через ${minutes}:${seconds}`,
            },
            AccountDeleted: {
                activeIndexText: "Аккаунт удалён",
                nextButtonText: "Продолжить",
                text: (communityName) =>
                    `Ваш аккаунт удалён из ${communityName}, но вы всегда можете присоединиться к комьюнити.`,
            },
            Confirmed: {
                activeIndexText: "Подтвердили",
                nextButtonText: "Перейти",
                stepTitle: "Вы успешно подтвердили почту",
                text: "Поздравляем! Вы успешно подтвердили вашу почту, через 5 секунд произойдёт переход на страницу с вашими сообществами.",
            },
            EventDetail: {
                CreateEvent: {
                    createEventTitle: "Создать событие",
                    editEventTitle: "Редактировать событие",
                    title: "Название",
                    description: "Описание",
                    titleTranslations: "Переводы названия",
                    descriptionTranslations: "Переводы описания",
                    slug: "URL Slug",
                    slugPlaceholder: "url-slug-события",
                    slugAvailable: "Slug доступен",
                    slugTaken: "Slug уже занят",
                    slugInvalidFormat: "Slug может содержать только строчные латинские буквы (a-z), цифры (0-9) и дефисы (-)",
                    slugHelp: "Это будет использоваться в URL события. Разрешены только буквы, цифры и дефисы.",
                    date: "Дата",
                    startDate: "Дата начала",
                    startTime: "Время начала",
                    endDate: "Дата окончания",
                    endTime: "Время окончания",
                    endDateOptional: "Оставьте пустым, если в тот же день",
                    timeZone: "Часовой пояс",
                    locationSection: "Локация",
                    addressLine: "Адрес",
                    latitude: "Широта",
                    longitude: "Долгота",
                    googleMapsLink: "Ссылка на Google Карты",
                    country: "Страна",
                    region: "Регион/Штат",
                    city: "Город",
                    postalCode: "Почтовый индекс",
                    locationVisibility: "Видимость адреса",
                    typeAndPayment: "Тип и Оплата",
                    eventType: "Тип события",
                    onlineMeetingLink: "Ссылка на онлайн встречу",
                    paid: "Платно",
                    price: "Цена",
                    paymentLink: "Ссылка на оплату",
                    participationAndVisibility: "Участие и Видимость",
                    visibility: "Видимость",
                    linkOnly: "Только по ссылке",
                    linkOnlyHint: "Событие не видно в ленте, поиске и на карте. Участники находят его по ссылке. Организаторы и подтверждённые участники видят его в списке.",
                    approvalRequired: "Требуется подтверждение",
                    approvalRequiredHint: "Участникам нужно подтверждение, чтобы присоединиться к событию",
                    organizerMessagesCustom: "Свой набор статусов",
                    organizerMessagesCustomHint: "Пустой набор скрывает кнопки «Написать» только на этом событии",
                    organizerMessagesInherit: "Как в сообществе",
                    enableOnboarding: "Включить онбординг",
                    enableOnboardingHint: "Участники проходят онбординг перед событием",
                    enableLiveInteraction: "Вопросы и опросы",
                    enableLiveInteractionHint: "Вопросы и опросы во время события",
                    presentAccess: "Доступ к проектору",
                    presentAccessPublic: "Без входа",
                    presentAccessAuthenticated: "Только со входом",
                    questionPremoderation: "Премодерация вопросов",
                    questionPremoderationHint: "Новые вопросы ждут Approve, пока зал их не увидит",
                    showPostJoinMessage: "Сообщение после регистрации",
                    showPostJoinMessageHint: "Показать приветственное сообщение один раз после присоединения к событию",
                    postJoinMessageLabel: "Текст сообщения",
                    postJoinMessageHint: "Сообщение показывается участнику один раз после регистрации на событие",
                    postJoinMessageRequired: "Заполните текст сообщения для всех языков комьюнити",
                    maxParticipants: "Макс. участников",
                    hideParticipantsUntilDate: "Скрывать участников до даты",
                    hideParticipantsUntilDateHint: "Участники не будут видеть друг друга до указанной даты. Организаторы всегда видят полный список.",
                    participantsVisibleDate: "Показать участников с (дата)",
                    participantsVisibleTime: "Показать участников с (время)",
                    participantsVisibleDateRequired: "Укажите дату открытия списка участников",
                    participantsVisibleTimeRequired: "Укажите время открытия списка участников",
                    maxPhotosAmount: "Макс. количество фотографий",
                    photoVisibility: "Видимость фотографий",
                    photoVisibilityAll: "Все (все могут видеть)",
                    photoVisibilityOnlyAuthenticated: "Только аутентифицированные пользователи",
                    photoVisibilityOnlyRegistered: "Только зарегистрированные на событии",
                    maxPhotosForUnauthenticatedUsers: "Макс. фотографий для неаутентифицированных",
                    maxPhotosForUnauthenticatedUsersHint: "Если установлено 0, неаутентифицированные пользователи увидят только сообщение о входе и никаких фотографий.",
                    organizerContact: "Контакт организатора",
                    create: "Создать",
                    saveChanges: "Сохранить изменения",
                    saving: "Сохраняем…",

                    // Additional translations for form sections and fields
                    basicInformation: "Основная информация",
                    dateAndTime: "Дата и время",
                    titlePlaceholder: "Введите название события",
                    descriptionPlaceholder: "Введите описание события",
                    endTimeOptional: "Время окончания (необязательно)",
                    addressLinePlaceholder: "Улица и номер дома",
                    cityPlaceholder: "Введите город",
                    regionPlaceholder: "Введите регион/штат",
                    countryPlaceholder: "Введите страну",
                    postalCodePlaceholder: "Введите почтовый индекс",
                    organizerContactPlaceholder: "Email или телефон",

                    // Event type options
                    eventTypeOnline: "Онлайн",
                    eventTypeOffline: "Офлайн",

                    // Visibility options
                    visibilityPublic: "Публичное",
                    visibilityPrivate: "Приватное",

                    // Location visibility options
                    locationVisibilityPublic: "Публичное",
                    locationVisibilityPrivate: "Приватное",

                    // Location visibility enum options
                    locationVisibilityFull: "Полный адрес",
                    locationVisibilityNoAddressLine: "Без улицы (только индекс, город, страна)",
                    locationVisibilityCountryAndCity: "Страна + город",
                    locationVisibilityCityOnly: "Только город",
                    locationVisibilityCountryOnly: "Только страна",
                    locationVisibilityAddressOnly: "Только улица",
                    locationVisibilityRegionAndCity: "Регион + город",
                    locationVisibilityPostalAndCity: "Почтовый индекс + город",
                    locationVisibilityNone: "Ничего не показываем",
                    extractCoordinates: "Получить координаты",
                    coordinatesExtracted: "Координаты получены из ссылки",
                    coordinateExtractionError: "Ошибка получения координат",

                    // Event responsibles section
                    eventResponsibles: "Организаторы события",
                    searchParticipants: "Поиск участников",
                    searchParticipantsPlaceholder: "Введите для поиска…",
                    removeConfirmTitle: "Удалить организатора?",
                    removeConfirmDescription: "Участник больше не сможет управлять этим событием.",
                    searchResults: "Результаты поиска",
                    currentResponsibles: "Текущие организаторы",
                    noResponsiblesYet: "Пока нет организаторов",
                    noResponsiblesDescription: "Найдите и добавьте участников для управления этим событием",
                    add: "Добавить",
                    remove: "Удалить",

                    // Event image section
                    eventCoverImage: "Обложка события",
                    noImageYet: "Пока нет изображения",
                    noImageDescription: "Вы можете загрузить обложку после сохранения события",

                    // Error messages
                    pleaseFillRequiredFields: "Пожалуйста, заполните обязательные поля",

                    // Loading states
                    loading: "Загрузка...",
                    creatingEvent: "Создание события...",
                    updatingEvent: "Обновление события...",

                    // Form validation
                    invalidLatitude: "Неверная широта",
                    invalidLongitude: "Неверная долгота",
                    invalidPrice: "Неверная цена",
                    invalidMaxParticipants: "Неверное количество участников",
                    invalidDate: "Неверная дата",
                    invalidTime: "Неверное время",
                    endTimeBeforeStartTime: "Время окончания должно быть после времени начала",

                    // Required field messages
                    cityRequired: "Город обязателен",
                    countryRequired: "Страна обязательна",
                    priceRequired: "Цена обязательна и должна быть больше 0 для платных событий",
                    paymentLinkRequired: "Ссылка на оплату обязательна для платных событий",

                    // Success messages
                    eventCreatedSuccessfully: "Событие успешно создано!",
                    eventUpdatedSuccessfully: "Событие успешно обновлено!",
                    eventDeletedSuccessfully: "Событие успешно удалено!",
                    deleteEvent: "Удалить событие",
                    deleteEventConfirmation: "Вы уверены, что хотите удалить это событие?",
                    deleteEventWarning: "Это действие нельзя отменить.",
                    confirmDelete: "Да, удалить",
                    cancelDelete: "Отмена",

                    // Event Image Upload
                    changePhoto: "Изменить фото",
                    uploadPhoto: "Загрузить фото",
                    uploadPhotoDescription: "Выберите изображение для события",
                    selectFile: "Выбрать файл",
                    cancel: "Отмена",
                    cropImage: "Обрезка изображения",
                    cropImageDescription: "Отрегулируйте размер и сохраните",
                    rotate: "Повернуть",
                    save: "Сохранить",
                    back: "Назад",

                    // Additional required field messages
                    titleRequired: "Название обязательно",
                    descriptionRequired: "Описание обязательно",
                    dateRequired: "Дата обязательна",
                    timeRequired: "Время обязательно",
                    endDateRequired: "Дата окончания обязательна",
                    endTimeRequired: "Время окончания обязательно",
                    timeZoneRequired: "Часовой пояс обязателен",
                    organizerContactRequired: "Контакт организатора обязателен",
                    onlineMeetingLinkRequired: "Ссылка на онлайн встречу обязательна для онлайн событий",

                    // Google Maps integration
                    parseFromGoogleMaps: "Получить координаты из Google Maps",
                    coordinatesFromLink: "Координаты получены из ссылки",
                    invalidGoogleMapsLink: "Неверная ссылка на Google Maps",

                    // Location parsing
                    locationParsed: "Местоположение распознано",
                    locationParseError: "Ошибка распознавания местоположения",

                    // Responsibles management
                    noParticipantsFound: "Участники не найдены",
                    searchForParticipants: "Поиск участников",
                    addAsResponsible: "Добавить как организатора",
                    removeFromResponsibles: "Удалить из организаторов",
                    responsibleAdded: "Организатор добавлен",
                    responsibleRemoved: "Организатор удален",
                    errorAddingResponsible: "Ошибка добавления организатора",
                    errorRemovingResponsible: "Ошибка удаления организатора",

                    // Image upload
                    uploadImage: "Загрузить изображение",
                    changeImage: "Изменить изображение",
                    removeImage: "Удалить изображение",
                    imageUploaded: "Изображение загружено",
                    imageUploadError: "Ошибка загрузки изображения",
                    imageRemoved: "Изображение удалено",

                    // Time zone related
                    selectTimeZone: "Выберите часовой пояс",
                    currentTimeZone: "Текущий часовой пояс",
                    timeZoneHelp: "Выберите часовой пояс, в котором будет проходить событие",

                    // Form sections help text
                    basicInformationHelp: "Основная информация о событии",
                    dateTimeHelp: "Дата и время проведения события",
                    locationHelp: "Местоположение события",
                    typePaymentHelp: "Тип события и информация об оплате",
                    participationVisibilityHelp: "Настройки участия и видимости события",
                },
                ParticipationButton: {
                    eventHasEnded: "Событие завершилось",
                    loadingStatus: "Загрузка статуса...",
                    youAreGoing: "Вы идёте",
                    cancelling: "Отменяем...",
                    cancelParticipation: "Отменить участие",
                    errorLoadingStatus: "Ошибка загрузки статуса",
                    joining: "Присоединяемся...",
                    joinAgain: "Присоединиться снова",
                    askToJoin: "Присоединиться",
                    startOnboarding: "Начать онбординг",
                    continueOnboarding: "Продолжить онбординг",
                    completeOnboarding: "Завершить онбординг",
                    pending: "Ожидание подтверждения",
                    rejected: "Отклонено",
                    joinOnline: "Присоединиться онлайн",
                    payToJoin: "Оплатить участие",
                    payToRegister: "Оплатить регистрацию",
                    loginToPayAndJoin: "Войти для оплаты участия",
                    paymentNote: "Статус оплаты может обновляться с задержкой. Обратитесь к организаторам мероприятия, если у вас есть вопросы.",
                },
                aboutEvent: "О событии",
                EventDescription: {},
                EventPhotosGallery: {
                    title: "Фотографии события",
                    hidden: "Скрыто",
                    closePreview: "Закрыть (Esc)",
                    previousPhoto: "Предыдущее (←)",
                    nextPhoto: "Следующее (→)",
                    guestSeeAllMessage: "Чтобы увидеть все фотографии события, пожалуйста, <a href=\"/login\">войдите</a> или <a href=\"/registration\">зарегистрируйтесь</a>.",
                    onlyRegisteredMessage: "Извините, только зарегистрированные участники события могут видеть фотографии этого события.",
                },
                dateTbc: "Дата уточняется",
                dayTbc: "День уточняется",
                eventDetails: "Детали события",
                hostName: "Имя хоста",
                hostOfTheEvent: "Хост события",
                locationTbc: "Местоположение уточняется",
                exactLocationAfterJoining: "Точное местоположение будет доступно после присоединения",
                viewOnGoogleMaps: "Посмотреть на Google Картах",
                joinOnline: "Присоединиться онлайн",
                addToCalendar: "Добавить в календарь",
                dateTimeTbc: "Дата и время уточняются",
                eventTitle: "Название события",
                participants: "Участники",
                participantCount: (count) => {
                    const n = Math.abs(count) % 100;
                    const n1 = n % 10;
                    if (n > 10 && n < 20) return `${count} участников`;
                    if (n1 === 1) return `${count} участник`;
                    if (n1 >= 2 && n1 <= 4) return `${count} участника`;
                    return `${count} участников`;
                },
                noConfirmedParticipants: "Подтвержденных участников пока нет.",
                participantsVisibleAfter: (dateStr) => `Список участников будет доступен после ${dateStr}`,
                noParticipants: "Участников пока нет",
                eventResponsibles: "Организаторы",
                noEventResponsibles: "Организаторы не назначены.",
                eventNotFound: "Событие не найдено",
                locationAlt: "Местоположение",
                eventAlt: "Изображение события",
                online: "Онлайн",
                paid: "ПЛАТНО",
                filterByStatus: "Фильтр по статусу",
                exportCSV: "Экспорт Excel",
                notificationsTitle: "Рассылки",
                liveInteraction: "Live Interaction",
                manageLive: "Manage Live",
                liveNowJoin: "Сейчас в эфире — присоединиться",
                liveNowSubtitle: "Q&A и опросы",
                enableLiveInteraction: "Live Interaction",
                enableLiveInteractionHint: "Вопросы и опросы во время события",
                presentAccess: "Доступ к проектору",
                presentAccessPublic: "Без входа",
                presentAccessAuthenticated: "Только со входом",
                questionPremoderation: "Премодерация вопросов",
                questionPremoderationHint: "Новые вопросы ждут Approve, пока зал их не увидит",
                notificationsForbiddenTitle: "Нет доступа",
                notificationsForbidden: "У вас нет права отправлять рассылки по этому событию",
                emailNotification: "Email-рассылка",
                telegramNotification: "Telegram-рассылка",
                loadingEvent: "Загрузка события...",
                normalSearch: "Обычный поиск",
                smartSearch: "Умный поиск",
                smartSearchSubmit: "Умный поиск",
                searchPlaceholder: "Поиск по имени или экспертизе",
                smartSearchPlaceholder: "Опишите, кого вы хотите найти",
                clearSearch: "Очистить поиск",
                searchError: "Не удалось загрузить участников",
                retry: "Повторить",
                searchEmpty: "Никого не нашли",
                searchResultsTitle: "Результаты поиска",
                participant: "Участник",
                // Status translations for filters
                CONFIRMED: "Подтверждено",
                PENDING: "Ожидает",
                REJECTED: "Отклонено",
                CANCELLED: "Отменено",
                confirmAction: "Подтвердить",
                rejectAction: "Отклонить",
                writeMessage: "Написать",
                localTime: "Ваше местное время",
                editEvent: "Редактировать событие",
                manageQuestions: "Управление вопросами",
                postJoinMessage: {
                    close: "Закрыть",
                },
                onboardingStats: {
                    title: "Статистика онбординга",
                    loading: "Загрузка статистики...",
                    error: "Ошибка загрузки статистики",
                    close: "Закрыть",
                    totalParticipants: "Всего участников",
                    completedParticipants: "Завершили онбординг",
                    completionRate: "Процент завершения",
                    averageCompletionTime: "Среднее время завершения",
                    questionStats: "Статистика по вопросам",
                    noData: "Данные недоступны",
                    retry: "Повторить"
                },
                participantsReport: {
                    title: "Отчет по участникам",
                    loading: "Загрузка участников...",
                    error: "Ошибка загрузки участников",
                    close: "Закрыть",
                    search: "Поиск участников...",
                    all: "Все",
                    completed: "Завершили",
                    pending: "В процессе",
                    name: "Имя",
                    login: "Логин",
                    company: "Компания",
                    status: "Статус",
                    answers: "Ответы",
                    answersCount: "Количество ответов",
                    lastAnswer: "Последний ответ",
                    viewAnswers: "Посмотреть ответы",
                    export: "Экспорт CSV",
                    noData: "Участники не найдены",
                    retry: "Повторить",
                    about: "О себе",
                    lookingFor: "Ищу",
                    utmSource: "Источник",
                    utmMedium: "Формат",
                    utmContent: "Пост"
                },
                utmLinkGenerator: {
                    title: "Конструктор ссылки с метками",
                    sourceLabel: "utm_source (источник)",
                    sourceHint:
                        "Откуда пришли: telegram, linkedin, email. В посте Telegram укажите telegram. В Mini App источник telegram может определиться автоматически, но в ссылке для канала лучше указать явно.",
                    mediumLabel: "utm_medium (формат)",
                    mediumHint: "Как опубликовали: channel, post, newsletter, story. Необязательно.",
                    contentLabel: "utm_content (вариант поста)",
                    contentHint: "Если в одном канале несколько постов: announce, reminder-24h. Необязательно.",
                    latinHint: "Только латиница, цифры и дефис; пробелы заменяются на «-».",
                    generatedLink: "Готовая ссылка",
                    copy: "Скопировать",
                    copied: "Ссылка скопирована",
                    close: "Закрыть",
                    sourceRequired: "Укажите utm_source (например, telegram)",
                },
                participantAnswers: {
                    title: "Ответы участника",
                    loading: "Загрузка ответов...",
                    error: "Ошибка загрузки ответов",
                    close: "Закрыть",
                    question: "Вопрос",
                    answer: "Ответ",
                    answeredAt: "Ответ дан",
                    noAnswers: "Ответы не найдены",
                    retry: "Повторить",
                    participant: "Участник"
                },
            },
            EventPhotosManager: {
                title: "Управление фотографиями",
                backToEvent: "Назад к событию",
                event: "Событие",
                photosUploaded: "фотографий загружено",
                slotsAvailable: "слотов доступно",
                uploadPhotos: "Загрузить фотографии",
                uploading: "Загружаем...",
                selectUpTo: "Выберите до",
                photo: "фото",
                maximumReached: "Достигнут максимум фотографий",
                selectAll: "Выбрать все",
                deselectAll: "Снять выделение",
                selected: "выбрано",
                makeVisible: "Сделать видимым",
                hide: "Скрыть",
                deleteSelected: "Удалить выбранные",
                noPhotos: "Фотографии еще не загружены",
                noPhotosDescription: "Нажмите \"Загрузить фотографии\" чтобы добавить фотографии к этому событию",
                hidePhoto: "Скрыть фотографию",
                showPhoto: "Показать фотографию",
                deletePhoto: "Удалить фотографию",
                delete: "Удалить",
                hidden: "Скрыто",
                confirmDelete: "Вы уверены, что хотите удалить эту фотографию?",
                confirmDeleteMultiple: "Вы уверены, что хотите удалить",
                photos: "фотографий",
                deleteSuccess: "Фотография успешно удалена",
                deleteMultipleSuccess: "фотографий успешно удалено",
                deleteError: "Не удалось удалить фотографию",
                deleteMultipleError: "Не удалось удалить фотографии",
                uploadSuccess: "фотографий успешно загружено",
                uploadError: "Не удалось загрузить фотографии",
                uploadLimitError: "Вы можете загрузить только",
                morePhotos: "еще фотографий. Максимум",
                visibilityToggleSuccess: "Фотография",
                madeVisible: "сделана видимой",
                hiddenStatus: "скрыта",
                visibilityToggleError: "Не удалось изменить видимость",
                visibilityToggleMultipleSuccess: "фотографий успешно",
                loadError: "Не удалось загрузить фотографии",
                eventLoadError: "Не удалось загрузить данные события",
                pleaseSelectPhotos: "Пожалуйста, выберите фотографии для удаления",
                pleaseSelectPhotosVisibility: "Пожалуйста, выберите фотографии для изменения видимости",
                dragDropTitle: "Перетащите фотографии сюда",
                dragDropSubtitle: "или нажмите кнопку ниже",
                dropHere: "Отпустите фотографии здесь",
                dropOnlyImages: "Пожалуйста, перетащите только изображения",
                closePreview: "Закрыть (Esc)",
                previousPhoto: "Предыдущее (←)",
                nextPhoto: "Следующее (→)",
            },
            EventQuestionManager: {
                title: "Управление вопросами",
                backToEvent: "Назад к событию",
                newQuestion: "Новый вопрос",
                questionsList: "Список вопросов",
                noQuestions: "Вопросы не найдены",
                createFirstQuestion: "Создайте первый вопрос для начала работы с онбордингом события",
                createFirstQuestionButton: "Создать первый вопрос",
                order: "Порядок",
                questionText: "Текст вопроса",
                type: "Тип",
                visible: "Видимый",
                actions: "Действия",
                view: "Просмотр",
                edit: "Редактировать",
                delete: "Удалить",
                confirmDelete: "Вы уверены, что хотите удалить этот вопрос?",
                deleteSuccess: "Вопрос успешно удален",
                deleteError: "Не удалось удалить вопрос",
                createQuestion: "Создать вопрос",
                editQuestion: "Редактировать вопрос",
                questionTextPlaceholder: "Введите ваш вопрос...",
                questionOrder: "Порядок",
                translationKey: "Ключ перевода",
                translationKeyPlaceholder: "Нажмите 'Сгенерировать' для создания уникального ключа...",
                isVisible: "Видимый для участников",
                isRequired: "Обязательный вопрос",
                save: "Сохранить",
                cancel: "Отмена",
                saving: "Сохранение...",
                createSuccess: "Вопрос успешно создан",
                updateSuccess: "Вопрос успешно обновлен",
                saveError: "Не удалось сохранить вопрос",
                generateTranslationKey: "Сгенерировать ключ",
                translationKeyGenerated: "Ключ перевода сгенерирован",
                translationKeyHint: "💡 Автоматически генерируемый UUID для управления переводами. Это помогает организовать переводы по сообществам и предотвращает конфликты.",
                translations: "Переводы",
                englishTranslation: "Английский",
                russianTranslation: "Русский",
                englishPlaceholder: "Введите английский перевод...",
                russianPlaceholder: "Введите русский перевод...",
                translationHelp: "Введите переводы для обоих языков. Они будут сохранены автоматически, когда вы закончите печатать.",
                enterTranslationKey: "Введите ключ перевода выше для управления переводами",
                // Answer Management
                answersTab: "Ответы",
                viewAnswers: "Просмотр ответов",
                noAnswers: "Ответы не найдены",
                noAnswersForQuestion: "На этот вопрос пока нет ответов",
                participant: "Участник",
                answer: "Ответ",
                answeredAt: "Дата ответа",
                viewAnswer: "Просмотр ответа",
                deleteAnswer: "Удалить ответ",
                confirmDeleteAnswer: "Вы уверены, что хотите удалить этот ответ?",
                deleteAnswerSuccess: "Ответ успешно удален",
                deleteAnswerError: "Не удалось удалить ответ",
                answerDetails: "Детали ответа",
                question: "Вопрос",
                answerText: "Текст ответа",
                answerType: "Тип ответа",
                close: "Закрыть",
                // Additional UI strings
                updateQuestionDetails: "Обновить детали вопроса и настройки",
                addNewQuestion: "Добавить новый вопрос в онбординг события",
                manageOnboardingQuestions: "Управление вопросами онбординга для",
                questionsConfigured: "вопросов настроено",
                questionConfigured: "вопрос настроен",
                clickActionsToManage: "Нажмите на действия для управления",
                viewAndManageResponses: "Просмотр и управление ответами участников",
                createQuestionsFirst: "Сначала создайте вопросы для просмотра ответов участников",
                // Answer Options Management
                answerOptions: "Варианты ответов",
                answerOptionText: "Текст варианта ответа",
                answerOptionOrder: "Порядок",
                answerOptionVisible: "Видимый",
                answerOptionActive: "Активный",
                answerOptionGroup: "Группа",
                answerOptionCategory: "Категория",
                answerOptionType: "Тип варианта ответа",
                predefined: "Предопределенный",
                text: "Текст",
                pleaseSpecify: "Пожалуйста, уточните...",
                removeAnswerOption: "Удалить вариант ответа",
                noAnswerOptions: "Нет вариантов ответа",
                addFirstAnswerOption: "Добавить первый вариант ответа",
                addQuestionTextFirst: "Сначала добавьте текст вопроса, чтобы включить варианты ответов",
                textQuestionNoAnswers: "Текстовые вопросы не требуют предопределенных вариантов ответов",
                answerOptionsHelp: "Добавьте варианты ответов для вопросов типа RADIO и CHECKBOX",
                answerOptionsWillAppear: "Варианты ответов для этого типа вопроса можно будет добавить после сохранения",
                manageAnswerOptions: "Управление вариантами ответов",
                unsavedChanges: "У вас есть несохраненные изменения. Вы уверены, что хотите закрыть?",
                newAnswer: "Новый ответ",
                editAnswerOption: "Редактировать вариант ответа",
                addAnswerOption: "Добавить вариант ответа",
                configureAnswerOption: "Настройте детали варианта ответа и переводы",
                answerOptionTextRequired: "Текст варианта ответа обязателен",
                answerOptionUpdated: "Вариант ответа успешно обновлен",
                answerOptionCreated: "Вариант ответа успешно создан",
                answerOptionsUpdated: "Варианты ответов успешно обновлены",
                answerOptionTextPlaceholder: "Введите текст варианта ответа",
                categoryPlaceholder: "Необязательная категория",
                update: "Обновить",
                create: "Создать",
                answers: "Ответы",
                noKey: "Нет ключа",
                key: "Ключ",
                // Breadcrumb translations
                events: "События",
            },
            Event: {
                title: "Сообщество",
                menuText: "Сообщество",
            },
            Notifications: {
                title: "Уведомления",
                menuText: "Уведомления",
            },
            Profile: {
                title: "Профиль",
                menuText: "Профиль",
                editProfile: "Редактировать профиль",
                tabMainInfo: "Основное",
                tabNotifications: "Уведомления",
                tabAppearance: "Оформление",
                appearanceAuto: "Авто",
                appearanceLight: "Всегда светлая",
                appearanceDark: "Всегда тёмная",
                appearanceError: "Не удалось сохранить оформление. Попробуйте ещё раз.",
                successText: "Изменения сохранены",
                invitedBy: "Приглашение от ",
                createdAt: "В сообществе с ",
                fillProfileWarning: "Чтобы получать более качественные контакты, заполните ",
                privacySettingsLabel: "Настройки приватности",
                contactTypesToHideLabel: "Скрыть следующие типы контактов",
                privacyOptions: {
                    NONE: "Показывать всем",
                    PRIVATE: "Скрыть все контакты",
                    CUSTOM: "Скрыть выборочно",
                },
                languageSettings: {
                    title: "Настройки языка",
                    description: "Выберите предпочитаемый язык для этого сообщества",
                    successMessage: "Языковые настройки обновлены",
                    note: "Этот параметр применяется только к данному сообществу. Вы можете иметь разные языковые настройки для разных сообществ."
                },
                moderationBanner: {
                    thankYou: "Благодарим за регистрацию!",
                    underModeration: "Ваш профиль находится на модерации. Мы сообщим вам о результате проверки в ближайшее время.",
                    contactModerators: "По всем вопросам можно писать:"
                },
                rejectionBanner: {
                    title: "Профиль временно отключен",
                    intro: "Ваш профиль был временно отключен модератором и отправлен на дополнительную проверку. Это может быть связано как с недостаточным количеством информации в профиле, так и с другими причинами модерации.",
                    checklistIntro: "Чтобы ускорить активацию, рекомендуем проверить и при необходимости дополнить профиль:",
                    checklistItems: [
                        "Указать актуальные имя и фамилию",
                        "Заполнить поле «Компания и позиция»",
                        "Подробно заполнить раздел «О себе»: чем вы занимаетесь, ваш опыт, интересы, какие контакты / возможности вы ищете в сообществе",
                    ],
                    photoRecommendation: "Также рекомендуется добавить фото профиля (повышает доверие внутри сообщества).",
                    afterUpdate: "После обновления профиль будет повторно рассмотрен модератором.",
                    contactModerators: "Если у вас есть вопросы — напишите модератору:",
                },
                contactTypes: {
                    EMAIL: "Электронная почта",
                    PHONE: "Телефон",
                    FACEBOOK: "Facebook",
                    INSTAGRAM: "Instagram",
                    LINKEDIN: "LinkedIn",
                    VK: "VK",
                    MAX: "MAX",
                    TELEGRAM: "Telegram",
                    GITHUB: "GitHub",
                    TWITTER: "Twitter",
                    SLACK: "Slack",
                    DISCORD: "Discord",
                    CALENDLY: "Calendly",
                },
                form: {
                    title: "Профиль",
                    firstName: {
                        label: "Имя",
                        placeholder: "Иван",
                    },
                    lastName: {
                        label: "Фамилия",
                        placeholder: "Иванов",
                    },
                    phone: {
                        label: "Телефон",
                        placeholder: "+79991234567",
                    },
                    company: {
                        label: "Компания, должность",
                        placeholder: "Яндекс, дизайнер",
                    },
                    about: {
                        label: "О себе",
                        placeholder:
                            "Расскажите о себе, своих компетенциях, навыках, хобби",
                    },
                    lookingFor: {
                        label: "Кого вы ищете?",
                        textareaLabel: "Напишите текст запроса",
                        placeholder: "В поиске специалиста с опытом работы в области...",
                        examples: [
                            "Ищу работу в сфере",
                            "Ищу бизнес-партнёров для реализации",
                            "Ищу единомышленников, увлеченных"
                        ],
                        options: [
                            "Я ищу...",
                            "Помогу с...",
                            "Нужна помощь с...",
                            "Ищу новые знакомства ",
                            "Открыт к любым предложениям ",
                            "Свой вариант"
                        ],
                    },
                    location: {
                        label: "Город",
                        placeholder: "Найти город",
                        question: "Показывать другим участникам",
                        tip: "Участники будут видеть ваш город. Вы\u00a0всегда можете изменить этот параметр в Профиле",
                        autodetectError: "Не удалось определить местоположение. Введите вручную.",
                        autodetectButtonLabel: "Определить",
                    },
                    goal: {
                        label: "Какая у вас цель?",
                    },
                    contact: {
                        placeholder: "Ссылка на профиль, https://...",
                    },
                    email: {
                        label: "Email",
                        placeholder: "example@mail.com",
                    },
                    telegram: {
                        label: "Telegram",
                        placeholder: "@username",
                    },
                    instagram: {
                        label: "Instagram",
                        placeholder: "https://instagram.com/username",
                    },
                    linkedin: {
                        label: "LinkedIn",
                        placeholder: "https://www.linkedin.com/in/your-username",
                        tip: "Оставьте пустым, чтобы пропустить этот шаг",
                        profileUrl: "<a href='https://www.linkedin.com/in/edit/contact-info/' target='_blank'>Найти свой Linkedin профиль</a>",
                        errorTip: "Ссылка должна начинаться с 'https://www.linkedin.com/in/' и следом ваше имя пользователя",
                        loadingTitle: "Загружаем LinkedIn профиль",
                        errorTitle: "Не удалось загрузить профиль LinkedIn",
                        errorRetryButton: "Попробовать снова",
                        errorManuallyButton: "Я заполню вручную"
                    },
                    facebook: {
                        label: "Facebook",
                        placeholder: "https://facebook.com/username",
                    },
                    github: {
                        label: "GitHub",
                        placeholder: "https://github.com/username",
                    },
                    twitter: {
                        label: "Twitter",
                        placeholder: "https://x.com/username",
                    },
                    slack: {
                        label: "Slack",
                        placeholder: "",
                    },
                    vk: {
                        label: "VK",
                        placeholder: "https://vk.com/username",
                    },
                    max: {
                        label: "MAX",
                        placeholder: "https://max.ru/username",
                    },
                    calendly: {
                        label: "Calendly",
                        placeholder: "https://calendly.com/username",
                    },
                    socialTip2: (num, socials) =>
                        `Укажите как минимум ${num} из соц. сетей ${socials.join(
                            " или "
                        )}`,
                    unsavedChanges: "Есть несохраненные изменения",
                    additionalSocialTip: "По желанию",
                    connectBot: "Подключить бота",
                    botConnected: "Бот подключен",
                    confirmBot: "Подтвердите, пожалуйста, бота",
                    telegramTip: "Если хотите получать уведомления в Telegram, пожалуйста, подключите бота.",
                    linkedInConnection: "Подключение LinkedIn",
                    linkedInConnectionHeader: "Вы будете перенаправлены на страницу сообщества в LinkedIn. После этого, пожалуйста, нажмите кнопку 'Установить\u00a0контакт', чтобы завершить процесс",
                    linkedInConnectionNote: "Обратите внимание, что кнопка 'Установить\u00a0контакт' может находится в двух разных местах (см. фото). Если вы уже выполнили подключение ранее или кнопку не удалось найти, просто пропустите этот шаг.",
                    linkedInConnectionBtn: "Перейти на LinkedIn",
                    avatar: "Изменить фото",
                    removeAvatar: "Удалить фото",
                    removeAvatarConfirmation: "Уверены?",
                    save: "Сохранить",
                    updateAvatarModal: {
                        titleFileUpload: "Загрузите новую фотографию",
                        descriptionFileUpload:
                            "Фотография поможет другим пользователям узнать вас и подтвердить, что вы вошли в свою учетную запись. Мы поддерживаем файлы в формате JPG или PNG.",
                        selectFile: "Загрузить фото",
                        cancel: "Отмена",
                        error: "Ошибка загрузки. Попробуйте загрузить другое фото",
                        titleCropper: "Изменение фото профиля",
                        descriptionCropper:
                            "Выберите область, которая будет показана в профиле. Поверните изображение, чтобы правильно его расположить.",
                        save: "Сохранить",
                        back: "Назад",
                        rotate: "Повернуть",
                    },
                    deleteAvatarModal: {
                        title: "Внимание",
                        description: "Вы уверены, что хотите удалить фото?",
                        delete: "Удалить",
                        cancel: "Отмена",
                    },
                    deleteModal: {
                        title: "Удалить аккаунт?",
                        description:
                            "Это действие необратимо. Подтвердите вводом пароля",
                        delete: "Удалить аккаунт",
                        cancel: "Отмена",
                    },
                    error: {
                        avatar: "Ошибка загрузки. Попробуйте загрузить другое фото",
                        exists: (field) => `Необходимо ввести ${field}`,
                        minMaxChars: (field, min, max) =>
                            `${field} может быть от ${min} до ${max} символов`,
                        maxChars: (max) => `Нужно указать до ${max} символов`,
                        emailNotExists:
                            "К сожалению, что-то пошло не так. Пожалуйста, пройдите авторизацию снова.",
                        contactNotConnectedTitle: (contact) =>
                            `${contact} не подключен`,
                        contactNotConnectedContent: (contact) =>
                            `Перейдите в профиль, чтобы подключить ${contact}`,
                        socialNetworkRequired: (socialNetwork) =>
                            `Необходимо ввести ссылку на профиль ${socialNetwork}`,
                        socialNetworkFormat: (socialNetwork) =>
                            `Неверный формат ссылки на профиль ${socialNetwork}`,
                        socialNetworkExists: (socialNetwork) =>
                            `Этот контакт ${socialNetwork} уже существует`,
                        requiredContacts: (
                            requiredContactsMin,
                            requiredContacts
                        ) =>
                            `Нужно ввести хотя бы ${requiredContactsMin} соц. сеть ${requiredContacts.join(
                                " или "
                            )}`,
                        roleInCommunity: "Не забудьте заполнить обязательные поля *",
                    },
                    hideSocialSettings: "Скрыть настройки соц. сетей",
                    showSocialSettings: "Настройки соц. сетей",
                    hideNotificationSettings: "Скрыть настройки уведомлений",
                    showNotificationSettings: "Настройки уведомлений",
                    notificationTip: "Выберите каналы для уведомлений",
                    chatNotifications: {
                        title: "Напоминания о непрочитанных чатах",
                        tip: "Напоминания о непрочитанных чатах",
                        hint: "Как часто напоминать о чатах, которые вы ещё не прочитали.",
                        email: "Email",
                        telegram: "Telegram",
                        newMessages: "Новые сообщения",
                        pushScope: "Push",
                        digestMode: "Напоминания о непрочитанном",
                        everyMessage: "Каждое сообщение",
                        introOnly: "Только интро",
                        instant: "Сразу",
                        daily: "1 раз в день",
                        weekly: "1 раз в неделю",
                        periodic: "Раз в 3 часа",
                        off: "Выкл"
                    },
                    matchmakingTitle: "Знакомства 1-на-1",
                    matchmakingLabel: "Включить знакомства 1-на-1",
                    matchmakingHint: "Если выключено, вы не участвуете в знакомствах 1-на-1 и не будете получать уведомления по выбранным каналам."
                },

            },
            Questions: {
                nocontent:
                    "Обратитесь к комьюнити-менеджеру, чтобы получить ссылку на сообщество",
                nocontentBtn: "Перезагрузить",
                back: "Назад",
                next: "Далее",
                close: "Закрыть",
                skipToProfile: "Пропустить вопросы — перейти к профилю (только события)",
                skipToProfileConfirm: "Если вы пропустите онбординг, вы не сможете участвовать в нетворкинге и заводить новые знакомства. Вам будет доступен только функционал событий и FAQ. Продолжить?",
            },
            Contacts: {
                title: "Контакты",
                menuText: "Контакты",
            },
            EventOnlyOnboardingModal: {
                message: "Чтобы просматривать контакты, получать рекомендации, участвовать в нетворкинге и заводить новых друзей и связи необходимо закончить онбординг. Без этого вам доступны:",
                eventsLink: "События",
                faqLink: "FAQ",
                profileLink: "Профиль",
                button: "Перейти к вопросам",
            },
            AdminNotifications: {
                messages: {
                    general: {
                        subject: (communityTitle) => `Новое сообщение из ${communityTitle}`,
                        signature: (communityTitle) => `<b>Ваш комьюнити менеджер,<br/>${communityTitle}</b>`
                    },
                    recommend: {
                        subject: (communityTitle) => `Интересные участники в ${communityTitle}`,
                        text: (communityUrl) => `Сегодняшнюю рассылку мы решили посвятить теме: <b>TOPIC</b>.<br/><br/>Рассказываем вам об интересных профилях участников на платформе <a href="${communityUrl}" target="_blank">${communityUrl}</a>, на которые вы можете откликнуться:`,
                        signature: (communityTitle, communityUrl, membersCount) => `Чтобы участвовать в нетворкинге и мероприятиях, используем ссылку <a href="${communityUrl}" target="_blank">${communityUrl}</a>, где уже зарегистрировались ${membersCount} участников🤝<br/><br/><b>Ваш комьюнити менеджер,<br/>${communityTitle}</b>`
                    },
                    individual: {
                        subject: (communityTitle) => `Новое сообщение из ${communityTitle}`,
                        title: () => `Привет, `,
                        signature: (communityTitle) => `<b>Ваш комьюнити менеджер,<br/>${communityTitle}</b>`
                    }
                }
            },
            Chats: {
                title: "Чаты",
                menuText: "Чаты",
                searchPlaceholder: "Поиск",
                noSearchResults: "Чаты не найдены",
                newChat: "Новый чат",
                createChat: "Создать чат",
                noChatsYet: "Чатов пока нет",
                emptyHint: "Запросите интро в профиле участника — диалог появится здесь после одобрения.",
                createFirstChat: "Создайте свой первый чат",
                selectChat: "Выберите чат, чтобы начать общение",
                selectChatDescription: "Выберите чат из боковой панели для просмотра сообщений",
                loadMore: "Загрузить ещё",
                limitedConnectivity: "Ограниченное соединение",
                noMessagesYet: "Сообщений пока нет",
                startConversation: "Начните разговор, отправив первое сообщение",
                typePlaceholder: "Введите сообщение...",
                peerDeletedBanner: "Этот участник удалён. Вы больше не можете отправлять ему сообщения.",
                startChat: "Начать чат",
                startChatWith: (name) => `Начать чат с ${name}`,
                requestIntro: "Запросить интро",
                openChat: "Открыть чат",
                requestSent: "Заявка отправлена",
                requestSentHint: "Модератор скоро её рассмотрит.",
                alreadyRequested: "Интро уже запрошено",
                alreadyRequestedHint: "Заявка для этой пары уже ожидает рассмотрения.",
                muteForever: "Выключить уведомления",
                unmuteNotifications: "Включить уведомления",
                hideChat: "Скрыть",
                hideConfirmTitle: "Скрыть чат?",
                hideConfirm: "История будет удалена только у вас.",
                leaveIntro: "Покинуть интро",
                leaveIntroTitle: "Покинуть интро?",
                leaveIntroConfirm: "Вы больше не увидите этот чат.",
                leftIntro: (name) => `${name} больше не в интро`,
                block: "Заблокировать",
                back: "Назад",
                close: "Закрыть",
                andYou: "и вы",
                connectionTitle: (a, b) => `Знакомство: ${a} и ${b}`,
                actions: "Действия",
                copy: "Копировать",
                reply: "Ответить",
                edit: "Изменить",
                edited: "изменено",
                originalDeleted: "Исходное сообщение удалено",
                deleteMessage: "Удалить",
                deleteConfirmTitle: "Удалить сообщение?",
                cancel: "Отмена",
                messageDeleted: "Сообщение удалено",
                today: "Сегодня",
                yesterday: "Вчера",
                pin: "Закрепить",
                unpin: "Открепить",
                pinned: "Закреплён",
                sending: "Отправляется",
                sent: "Отправлено",
                read: "Прочитано",
                reactions: "Реакции",
                insertEmoji: "Вставить эмодзи",
                moreReactions: "Ещё реакции",
                emojiSmileys: "Смайлы",
                emojiGestures: "Жесты",
                emojiHearts: "Сердца",
                emojiNature: "Природа",
                emojiObjects: "Предметы",
                member: "Участник",
                personal: "Личный",
                personalChats: "Личные",
                intro: "Интро",
                all: "Все",
                write: "Написать",
                messagePlaceholder: "Сообщение",
                isTyping: (name) => `${name} печатает...`
            },
            ManageChats: {
                menuText: "Очередь интро",
                queueTitle: "Очередь интро",
                conversations: "Диалоги",
                settings: "Настройки",
                bulkApprove: "Одобрить все",
                showArchived: "Показать архив",
                archive: "В архив",
                unarchive: "Вернуть",
                archivedBadge: "Архив",
                cooldownDays: "Дней паузы",
                organizerMessages: "Сообщения с организаторами",
                participantWritesOrganizer: "Участник пишет организатору",
                organizerWritesParticipant: "Организатор пишет участнику",
                approve: "Одобрить",
                reject: "Отклонить",
                rejectComment: "Комментарий к отклонению",
                queueEmpty: "Нет заявок в очереди. Connect появляется здесь, только если в настройках чатов включён сценарий REQUEST и согласование — MODERATOR (не AUTO). Глобальный шаблон задаёт текст после одобрения, а не саму очередь.",
                queueEmptyArchived: "В архиве нет заявок.",
                requesterMessagePlaceholder: "Сообщение участника",
                icebreakerPlaceholder: "Icebreaker",
                translateIcebreaker: "Перевести",
                translatingIcebreaker: "Перевод…",
                introLangBadge: "Интро {lang}",
                previewIntro: "Предпросмотр",
                previewingIntro: "Генерирую предпросмотр…",
                previewIntroError: "Не удалось показать предпросмотр",
                search: "Поиск по имени или email",
                previous: "Назад",
                next: "Далее",
                pageOf: "Страница {current} из {total}",
                clearFilter: "Сбросить",
                scenarios: "Сценарии",
                templates: "Шаблоны",
                bot: "Бот",
                notifications: "Уведомления",
                digestDaily: "1 раз в день",
                digestWeekly: "1 раз в неделю",
                botPhoto: "фото",
                uploadBotPhoto: "Загрузить фото",
                cropBotPhoto: "Обрезать фото",
                cropBotPhotoHint: "Выберите область для фото бота. Изображение можно повернуть.",
                changePhoto: "Изменить",
                uploadPhoto: "Загрузить",
                chooseBotPhoto: "Выберите изображение для фото бота",
                selectFile: "Выбрать файл",
                cancel: "Отмена",
                rotate: "Повернуть",
                savePhoto: "Сохранить",
                back: "Назад",
                anyRatio: "Любое соотношение",
                squareRatio: "1:1 квадрат",
                firstName: "Имя",
                lastName: "Фамилия",
                enabled: "Включен",
                enabledHint: "Если выключен, интро пишет модератор.",
                saveBot: "Сохранить бота",
                botCardHint: "Это имя и фото видят участники в интро-чатах.",
                firstNameRequired: "Укажите имя",
                lastNameRequired: "Укажите фамилию",
                templatesEmpty: "Шаблонов интро пока нет. Создайте один, чтобы задать первое сообщение бота.",
                addTemplate: "Создать шаблон",
                templateHint: "Этот текст — первое сообщение бота в интро-чате. Нажмите тег, чтобы вставить.",
                introTemplates: "Сообщение интро",
                acceptedTemplates: "Уведомление об одобрении",
                rejectedTemplates: "Уведомление об отклонении",
                acceptedHint: "Email, Telegram, колокольчик и web push, когда модератор одобряет запрос. Тема используется для письма.",
                rejectedHint: "Email, Telegram, колокольчик и web push, когда модератор отклоняет запрос. Тема используется для письма.",
                acceptedEmpty: "Шаблонов одобрения пока нет. Создайте один, чтобы уведомить автора запроса.",
                rejectedEmpty: "Шаблонов отклонения пока нет. Создайте один, чтобы уведомить автора запроса.",
                templateSubject: "Тема письма",
                templateSubjectPlaceholder: "Тема email",
                saveTemplate: "Сохранить",
                saved: "Изменения сохранены",
                saveError: "Не удалось сохранить",
                previewTemplate: "Предпросмотр",
                previewing: "Генерирую предпросмотр…",
                templateBody: "Текст",
                tagGroupAlways: "Всегда заполняются",
                tagGroupOptional: "Могут быть пустыми — ставьте на отдельную строку",
                previewFor: "Сгенерировано для",
                previewAnd: "и",
                previewAiUsed: "использован ИИ",
                aiTitle: "ИИ для шаблонов интро",
                aiHint: "Заполняет рекомендации, общие интересы и icebreaker, если в паре матчинга нет готового текста.",
                aiEnabled: "Включен",
                aiProvider: "Провайдер",
                aiModel: "Модель",
                aiTemperature: "Temperature",
                aiMaxTokens: "Max tokens",
                saveAi: "Сохранить настройки ИИ",
                help: {
                    exampleLabel: "Пример",
                    overview: {
                        title: "Чаты для менеджера",
                        description: "Здесь вы модерируете запросы на знакомство и настраиваете, как сообщество открывает диалоги. Участник не пишет другому напрямую: сначала создаётся запрос на интро, и только после одобрения (вами или автоматически) открывается чат.",
                        example: "Анна нажимает «Познакомить» в профиле Бориса. Если сценарий REQUEST в режиме MODERATOR_BOT, запрос появляется в очереди. После «Одобрить» бот пишет первое сообщение, и у обоих открывается чат. В режиме MODERATOR в чат входите вы и пишете интро сами.",
                        tip: "Начните с очереди интро, затем проверьте сценарии. Шаблоны, бот и уведомления нужны, когда очередь уже понятна.",
                        sections: [
                            {
                                title: "Очередь интро",
                                summary: "Входящие запросы, которые ждут вашего решения.",
                                bullets: [
                                    "Одобрить — открывает чат и шлёт уведомление ACCEPTED.",
                                    "Отклонить — чат не открывается, автору уходит REJECTED, пара на паузе несколько дней."
                                ]
                            },
                            {
                                title: "Диалоги",
                                summary: "Уже открытые чаты сообщества.",
                                bullets: [
                                    "Lock — участники больше не пишут.",
                                    "Delete — диалог исчезает из списков."
                                ]
                            },
                            {
                                title: "Настройки",
                                summary: "Сценарии, шаблоны, профиль бота и ваши уведомления о новых запросах.",
                                bullets: [
                                    "Сценарии решают, какие интро вообще возможны и нужна ли модерация.",
                                    "Шаблоны — текст бота и писем об одобрении или отклонении."
                                ]
                            }
                        ]
                    },
                    queueSection: {
                        title: "Очередь интро",
                        description: "Список запросов со статусом PENDING. Пока запрос здесь, чата ещё нет. Каждая карточка — пара участников, сценарий (REQUEST, MATCH или EVENT) и причина.",
                        example: "«Анна · Борис · REQUEST · профиль». Вы читаете черновик ИИ, нажимаете «Одобрить». В MODERATOR_BOT чат открывается с первым сообщением бота; в MODERATOR — вы становитесь третьим в чате.",
                        tip: "Клавиши: j / k — следующая и предыдущая карточка, a — одобрить, r — отклонить.",
                        sections: [
                            {
                                title: "Откуда берутся запросы",
                                summary: "Три сценария пишут в одну очередь, если approval = MODERATOR или MODERATOR_BOT.",
                                bullets: [
                                    "REQUEST — участник нажал «Познакомить» в профиле.",
                                    "MATCH — система создала пару в раунде матчинга.",
                                    "EVENT — оба подтвердили участие в одном событии."
                                ]
                            },
                            {
                                title: "Что происходит после решения",
                                summary: "Одобрение открывает DIRECT-чат. Отклонение включает паузу (обычно 7 дней) на повторный запрос этой пары.",
                                bullets: [
                                    "AUTO в настройках сценария пропускает очередь целиком."
                                ]
                            }
                        ]
                    },
                    conversationsSection: {
                        title: "Диалоги",
                        description: "Все чаты сообщества, которые уже открыты. Здесь можно найти пару по имени, заблокировать переписку или удалить диалог.",
                        example: "Спор в чате после интро. Lock — участники не отправляют сообщения. Unlock — снова можно писать. Delete — диалог пропадает у всех.",
                        tip: "LOCKED чат нельзя открыть заново через «Познакомить»: система считает, что диалог существует, но закрыт.",
                        sections: [
                            {
                                title: "Статусы",
                                summary: "ACTIVE — обычный чат. LOCKED — только чтение. DELETED — скрыт и не показывается в этом списке.",
                                bullets: [
                                    "blocked рядом со статусом значит, что один участник заблокировал другого."
                                ]
                            }
                        ]
                    },
                    settingsSection: {
                        title: "Настройки чатов",
                        description: "Четыре вкладки: сценарии (когда создавать интро и нужна ли модерация), шаблоны (тексты), бот (имя и фото в чате) и уведомления менеджера.",
                        example: "Вы включаете MATCH в AUTO — после раунда матчинга чаты открываются сами, без очереди. REQUEST оставляете MODERATOR_BOT, чтобы вручную фильтровать запросы, а интро писал бот.",
                        tip: "Если бот выключен, AUTO и MODERATOR_BOT недоступны: системе некому написать первое сообщение. Запрос уходит в очередь как MODERATOR.",
                        sections: [
                            {
                                title: "Порядок настройки",
                                summary: "Сначала сценарии, потом бот, затем шаблоны, в конце уведомления.",
                                bullets: [
                                    "Без включённого сценария кнопки интро у участников не работают.",
                                    "Шаблоны подставляют имя, ссылку на профиль и теги из матчинга."
                                ]
                            }
                        ]
                    },
                    approveAll: {
                        title: "Одобрить все",
                        description: "Одобряет каждый PENDING-запрос, который сейчас виден в очереди. Для каждого открывается чат и уходит уведомление ACCEPTED.",
                        example: "После раунда матчинга в очереди 12 пар MATCH. «Одобрить все» открывает 12 чатов сразу.",
                        tip: "Действие необратимо. Если сомневаетесь в части пар — одобряйте по одной."
                    },
                    rowScenario: {
                        title: "Сценарий запроса",
                        description: "Откуда взялся запрос: REQUEST (кнопка в профиле), MATCH (пара матчинга), EVENT (общее событие).",
                        example: "Карточка «Анна · Борис · EVENT · Demo Day» — оба подтвердили Demo Day, сценарий EVENT в режиме MODERATOR.",
                        tip: "Сценарий задаётся при создании и не меняется. Меняется только approval в настройках — для следующих запросов."
                    },
                    rowReason: {
                        title: "Причина",
                        description: "Короткий контекст, почему система или участник создали запрос. Для MATCH это обычно «match», для EVENT — название события, для REQUEST — откуда нажали.",
                        example: "«shared event» или «Demo Day 12 мая». Этот текст может попасть в шаблон как {reason}.",
                        tip: "Пустая причина не ошибка: не у всех сценариев есть человекочитаемый повод."
                    },
                    requesterMessage: {
                        title: "Сообщение участника",
                        description: "Текст, который участник написал при запросе интро. Можно поправить перед одобрением — в шаблон INTRO подставится уже отредактированный текст как {requestMessageA}.",
                        example: "Было «привет давай знакомиться». Выправляете на «Привет, хочу познакомиться» и нажимаете «Одобрить».",
                        tip: "Правка сохраняется только при одобрении. Отклонение исходный текст не меняет."
                    },
                    icebreaker: {
                        title: "Icebreaker",
                        description: "Вопрос для начала разговора. Он попадёт в шаблон INTRO как {icebreaker}. Если в сообществе несколько языков, заполните каждый. «Перевести» дописывает пустые языки по тексту, который вы уже ввели. При одобрении в чат уйдёт версия на языке интро.",
                        example: "Правите английский вопрос, нажимаете «Перевести», затем «Одобрить». Если язык интро — английский, в чат уйдёт английская формулировка.",
                        tip: "Если у пары разные языки, берётся язык сообщества по умолчанию."
                    },
                    introLang: {
                        title: "Язык интро",
                        description: "Язык шаблона INTRO и icebreaker, которые уйдут в чат этой паре. Если у обоих один поддерживаемый язык — он. Иначе язык сообщества по умолчанию. Правка второго языка в карточке этот бейдж не меняет.",
                        example: "Оба говорят по-русски в двуязычном сообществе — бейдж «Интро RU», в чат уйдёт русская версия.",
                        tip: "Бейдж считается при создании запроса по языкам участников, а не по тому, какую колонку вы сейчас редактируете."
                    },
                    previewIntro: {
                        title: "Предпросмотр",
                        description: "Показывает первое сообщение бота для этой пары: текущий шаблон INTRO с именами, причиной и несохранёнными правками сообщения и icebreaker. Ничего не сохраняется, пока вы не нажмёте «Одобрить».",
                        example: "Меняете icebreaker и сообщение участника, жмёте «Предпросмотр» — в модалке видите HTML, как в чате.",
                        tip: "Курсивный черновик ИИ на карточке может отличаться. Предпросмотр — точный вид текущих правок."
                    },
                    aiSuggestion: {
                        title: "Подсказка ИИ",
                        description: "Короткий фрагмент, который система собрала для пары: общие интересы или рекомендация, если icebreaker нет. Это не сообщение в чат, а подсказка вам перед решением.",
                        example: "«Оба пишут на Python и ищут co-founder». Вы решаете, достаточно ли этого, чтобы одобрить.",
                        tip: "Если строки нет — ИИ не смог собрать текст или выключен. Решение всё равно можно принять."
                    },
                    aiDraft: {
                        title: "Черновик интро",
                        description: "Предпросмотр первого сообщения бота для этой пары: шаблон с подставленными именами и тегами. После одобрения похожий текст уйдёт в чат.",
                        example: "«Анна, познакомься с Борисом — вы оба на Demo Day. Общий интерес: climate tech.»",
                        tip: "Чтобы поменять тон навсегда, правьте шаблон INTRO во вкладке «Шаблоны», а не одну карточку."
                    },
                    approve: {
                        title: "Одобрить",
                        description: "Открывает чат между парой, пишет первое сообщение бота (если бот включён) и отправляет автору уведомление ACCEPTED — email, Telegram, колокольчик и web push по шаблону.",
                        example: "Нажимаете «Одобрить» на «Анна · Борис». У обоих в «Чаты» появляется диалог с сообщением бота.",
                        tip: "Если чат этой пары уже есть, запрос всё равно помечается одобренным, новый чат не дублируется."
                    },
                    reject: {
                        title: "Отклонить",
                        description: "Чат не открывается. Автор получает уведомление REJECTED. Пара уходит на паузу (по умолчанию 7 дней) — повторный запрос этой же пары будет недоступен до конца паузы. Система спросит комментарий: он подставляется в шаблон как {comment}.",
                        example: "Отклоняете запрос и пишете «Уже знакомы офлайн». Анна получает письмо с этим комментарием.",
                        tip: "Пауза общая на пару, не на одного человека. Другие участники по-прежнему могут запрашивать интро с каждым из них."
                    },
                    shortcuts: {
                        title: "Клавиши очереди",
                        description: "Пока фокус не в поле ввода: j — следующая карточка, k — предыдущая, a — одобрить выбранную, r — отклонить выбранную. Выбранная карточка подсвечена рамкой.",
                        example: "Открыли очередь, нажали j дважды, затем a — одобрили третий запрос, не целясь мышкой.",
                        tip: "Клавиши не работают, если курсор в input или textarea — чтобы случайно не одобрить, пока печатаете комментарий."
                    },
                    search: {
                        title: "Поиск диалогов",
                        description: "Фильтрует список по названию чата и отображаемым именам участников. Регистр не важен.",
                        example: "Вводите «анна» — остаются чаты, где в именах есть Анна.",
                        tip: "Поиск только по уже загруженному списку, без запроса на сервер."
                    },
                    conversationStatus: {
                        title: "Статус диалога",
                        description: "ACTIVE — участники пишут. LOCKED — отправка запрещена, история видна. Рядом может быть «blocked», если один заблокировал другого.",
                        example: "«Анна · Борис · LOCKED · blocked» — чат закрыт модератором, плюс блокировка.",
                        tip: "DELETED в этот список не попадает."
                    },
                    lock: {
                        title: "Lock и Unlock",
                        description: "Lock запрещает новые сообщения. Unlock возвращает статус ACTIVE. На участниках это выглядит как замороженный чат, история не стирается.",
                        example: "Жалоба на тон. Lock на время разбора, затем Unlock, если решили не удалять.",
                        tip: "Пока чат LOCKED, «Познакомить» для этой пары недоступно: система видит существующий закрытый диалог."
                    },
                    deleteConversation: {
                        title: "Удалить диалог",
                        description: "Помечает чат удалённым. Он пропадает из списков участников и из этой таблицы. Восстановления из интерфейса нет.",
                        example: "Спам-чат после ошибочного интро. Delete — оба больше его не видят.",
                        tip: "Если нужно только остановить переписку, достаточно Lock. Delete — когда чат не должен существовать."
                    },
                    scenariosTab: {
                        title: "Сценарии",
                        description: "Три способа создать интро. Выключатель — можно ли создавать такие запросы. AUTO, MODERATOR или MODERATOR_BOT — открывать чат сразу, класть в очередь с вашим интро или в очередь с интро бота.",
                        example: "REQUEST = вкл + MODERATOR_BOT, MATCH = вкл + AUTO, EVENT = выкл. Участники просят интро вручную, матчинг открывает чаты сам, события интро не создают.",
                        tip: "AUTO и MODERATOR_BOT работают только при включённом боте. Иначе система не создаёт запрос: некому написать первое сообщение.",
                        sections: [
                            {
                                title: "REQUEST",
                                summary: "Участник нажимает «Познакомить» в профиле другого.",
                                bullets: [
                                    "Самый частый ручной сценарий.",
                                    "Обычно оставляют MODERATOR, чтобы отсекать случайные запросы."
                                ]
                            },
                            {
                                title: "MATCH",
                                summary: "Раунд матчинга создал пару — система сама ставит интро.",
                                bullets: [
                                    "Удобно AUTO, если вы доверяете порогу матчинга.",
                                    "MODERATOR, если хотите просмотреть пары и сами написать интро.",
                                    "MODERATOR_BOT, если хотите просмотреть пары, а интро напишет бот."
                                ]
                            },
                            {
                                title: "EVENT",
                                summary: "Оба подтвердили участие в одном событии — интро с каждым другим подтверждённым участником.",
                                bullets: [
                                    "На большом событии очередь быстро растёт — чаще AUTO или выключатель.",
                                    "Причина в карточке — название события."
                                ]
                            }
                        ]
                    },
                    scenarioEnabled: {
                        title: "Сценарий включён",
                        description: "Выключенный сценарий не создаёт запросы. Кнопка «Познакомить» для REQUEST скрыта или недоступна. MATCH и EVENT тоже не ставят интро.",
                        example: "Выключаете EVENT перед конференцией на 400 человек, чтобы не получить сотни карточек.",
                        tip: "Выключение не трогает уже открытые чаты и текущую очередь."
                    },
                    scenarioApproval: {
                        title: "AUTO, MODERATOR или MODERATOR_BOT",
                        description: "AUTO — чат открывается сразу, очередь не используется, интро пишет бот. MODERATOR — запрос ждёт в очереди; после одобрения вы входите в чат третьим и пишете интро. MODERATOR_BOT — тоже очередь, но после одобрения интро пишет бот, вас в чате нет.",
                        example: "MATCH = AUTO: после «Find matches» чаты появляются у пар сами. REQUEST = MODERATOR_BOT: ручные запросы копятся в очереди, интро пишет бот.",
                        tip: "Смена режима действует на новые запросы. Карточки, которые уже в очереди, остаются, пока вы их не разберёте."
                    },
                    templatesTab: {
                        title: "Шаблоны",
                        description: "Три вида текста. INTRO — первое сообщение бота в чате. ACCEPTED и REJECTED — уведомления автору запроса (email, Telegram, колокольчик, web push). Тема письма нужна только для ACCEPTED и REJECTED.",
                        example: "INTRO: «{firstNameA}, познакомься с {firstNameB}». ACCEPTED subject: «Ваш запрос одобрен». REJECTED: «Пока не можем познакомить с {firstNameB}».",
                        tip: "Теги в фигурных скобках подставляются при отправке. Необязательные теги на отдельной строке скрываются, если значение пустое.",
                        sections: [
                            {
                                title: "INTRO",
                                summary: "Пишет бот первым сообщением, когда чат открылся.",
                                bullets: [
                                    "Видят оба участника в чате.",
                                    "Сюда ставят {recommendationA}, {commonInterests}, {icebreaker}."
                                ]
                            },
                            {
                                title: "ACCEPTED и REJECTED",
                                summary: "Уходят только автору запроса после вашего решения.",
                                bullets: [
                                    "Тема — для email.",
                                    "{comment} — ваш текст из окна отклонения."
                                ]
                            },
                            {
                                title: "ИИ",
                                summary: "Карточка сверху заполняет пустые теги матчинга, если в паре нет готового текста.",
                                bullets: [
                                    "Выключенный ИИ оставляет теги пустыми — строки с ними пропадают."
                                ]
                            }
                        ]
                    },
                    aiEnabled: {
                        title: "ИИ для шаблонов",
                        description: "Когда включён, система просит модель заполнить рекомендацию, общие интересы и icebreaker, если у пары матчинга нет готового текста. Результат подставляется в теги INTRO и показывается в очереди как подсказка.",
                        example: "Пара без сохранённых интересов. ИИ пишет icebreaker про общий город — тег {icebreaker} в шаблоне заполняется.",
                        tip: "Выключите, если не хотите внешних вызовов модели. Шаблоны продолжат работать на профильных тегах."
                    },
                    aiProvider: {
                        title: "Провайдер ИИ",
                        description: "Какой подключенный провайдер вызывать. Список приходит с сервера. Смена провайдера подставляет его модель по умолчанию.",
                        example: "Выбираете OpenAI — в поле модели появляется gpt-4o-mini, пока не зададите свою.",
                        tip: "Провайдер должен быть настроен на стороне сервера. Пустой список значит, что ИИ в этом окружении недоступен."
                    },
                    aiModel: {
                        title: "Модель",
                        description: "Имя модели у выбранного провайдера. Можно оставить значение по умолчанию или указать другое, которое прокси принимает.",
                        example: "gpt-4o-mini для коротких icebreaker, более крупная модель — если рекомендации получаются слишком общими.",
                        tip: "Неверное имя модели ломает только заполнение ИИ-тегов, не создание интро."
                    },
                    aiTemperature: {
                        title: "Temperature",
                        description: "Случайность ответа от 0 до 2. Ниже — короче и предсказуемее. Выше — разнообразнее, легче уйти от фактов профиля.",
                        example: "0.3 для деловых интро. 0.8, если icebreaker слишком шаблонные.",
                        tip: "Для подстановки в шаблон обычно хватает 0.2–0.5."
                    },
                    aiMaxTokens: {
                        title: "Max tokens",
                        description: "Потолок длины ответа модели (от 50 до 2000). Это не длина вашего шаблона, а сколько текста ИИ может сгенерировать для тегов.",
                        example: "400 — несколько предложений на рекомендацию и icebreaker. 100 — одна короткая фраза.",
                        tip: "Слишком большой лимит дороже и не нужен: в чат попадёт только то, что вставлено тегами."
                    },
                    templateIntro: {
                        title: "Сообщение интро",
                        description: "Первое сообщение в чате после одобрения или AUTO. В AUTO и MODERATOR_BOT его пишет бот; в MODERATOR — вы. Оба участника видят этот текст. Делайте отдельную версию на каждый язык сообщества.",
                        example: "«Привет, {firstNameA} и {firstNameB}! Вы в {communityName}. {icebreaker}»",
                        tip: "Необязательные теги ставьте на свою строку — пустое значение уберёт всю строку, а не оставит «{icebreaker}»."
                    },
                    templateAccepted: {
                        title: "Уведомление об одобрении",
                        description: "Email, Telegram, колокольчик и web push автору, когда вы нажали «Одобрить». Тема используется в письме. В чат этот текст не пишется — там INTRO.",
                        example: "Тема: «Вас познакомили с {firstNameB}». Текст: «Откройте чаты — диалог уже ждёт.»",
                        tip: "Пишите коротко: это письмо «можно писать», а не само знакомство."
                    },
                    templateRejected: {
                        title: "Уведомление об отклонении",
                        description: "Сообщение автору, когда запрос отклонён. {comment} — текст из окна отклонения. Чат не создаётся.",
                        example: "«Пока не можем познакомить с {firstNameB}. {comment} Попробуйте позже или напишите другим участникам.»",
                        tip: "Без шаблона REJECTED автор может не понять, почему чат не появился."
                    },
                    templateLanguage: {
                        title: "Язык шаблона",
                        description: "Код языка этого варианта (EN, RU, …). Система берёт шаблон языка участника, иначе запасной. Список — языки сообщества.",
                        example: "Два INTRO: RU и EN. Участник с RU в профиле получит русское первое сообщение.",
                        tip: "Не делайте два шаблона одного kind на один язык — сохранится путаница, какой активен."
                    },
                    templateSubject: {
                        title: "Тема письма",
                        description: "Тема email для ACCEPTED и REJECTED. В Telegram, колокольчике и web push не показывается. В INTRO поля темы нет — бот пишет только тело в чат.",
                        example: "«{communityName}: запрос на знакомство одобрен»",
                        tip: "Теги в теме работают так же, как в тексте."
                    },
                    templateBody: {
                        title: "Текст шаблона",
                        description: "Тело сообщения. Нажмите тег внизу, чтобы вставить плейсхолдер в редактор. При отправке теги заменяются данными пары.",
                        example: "«{firstNameA}, познакомься с {firstNameB} из {companyB}. {commonInterests}»",
                        tip: "Сохраните шаблон, затем Preview — так видно подстановку, а не сырые {теги}."
                    },
                    tagsAlways: {
                        title: "Теги, которые всегда заполняются",
                        description: "Имена, ссылки на профили, название сообщества, имя менеджера. Их можно ставить в любой строке — пустыми они не будут (если данные в профиле есть).",
                        example: "{firstNameA} — автор или первый в паре, {firstNameB} — второй. {profileUrlA} — ссылка на анкету.",
                        tip: "В ACCEPTED/REJECTED набор короче: нет рекомендаций и icebreaker, зато есть {comment} и {profileCardB} — карточка участника B (аватар и about до 255 символов)."
                    },
                    tagsOptional: {
                        title: "Необязательные теги",
                        description: "Рекомендации, интересы, icebreaker, компании, причина. Могут быть пустыми. Поставьте такой тег на отдельную строку: если значения нет, строка скрывается целиком.",
                        example: "Строка только с {icebreaker}. Нет текста от ИИ — участники не увидят пустую строку и не увидят «{icebreaker}».",
                        tip: "Не смешивайте необязательный тег с обычным текстом в одной строке: при пустом значении пропадёт и соседний текст."
                    },
                    templatePreview: {
                        title: "Предпросмотр",
                        description: "Рендерит шаблон на двух случайных участниках сообщества: подставляет теги, при необходимости вызывает ИИ. Ничего не сохраняет и никому не отправляет.",
                        example: "Preview INTRO → «Сгенерировано для Анны и Бориса · OpenAI / gpt-4o-mini · использован ИИ» и готовый HTML.",
                        tip: "Если участников меньше двух, предпросмотр может повторить одного человека или подставить заглушку — это нормально для проверки вёрстки."
                    },
                    botTab: {
                        title: "Бот сообщества",
                        description: "Имя и фото, которые участники видят у первого сообщения интро. Если бот выключен, AUTO и MODERATOR_BOT недоступны, а в MODERATOR модератор становится тем, кто «ведёт» интро.",
                        example: "Имя «Joinee Bot», квадратное фото логотипа сообщества. В чате первое сообщение приходит от этого профиля.",
                        tip: "Включите бота до того, как ставить сценарии в AUTO или MODERATOR_BOT."
                    },
                    botPhoto: {
                        title: "Фото бота",
                        description: "Круглый аватар, который виден в ленте чата рядом с интро. Загрузите изображение — в чате оно обрежется по кругу.",
                        example: "Логотип сообщества на светлом фоне — его узнают в списке чатов.",
                        tip: "Без фото показывается стандартная заглушка. На смысл интро это не влияет."
                    },
                    botName: {
                        title: "Имя бота",
                        description: "Имя отправителя интро. Участники видят его в шапке сообщения.",
                        example: "«Мария из Community» — в чате так и отобразится.",
                        tip: "Это не аккаунт живого менеджера. Личные ответы вы пишете своим профилем, если сами в чате."
                    },
                    botEnabled: {
                        title: "Бот включён",
                        description: "Включён — бот пишет INTRO и может работать с AUTO и MODERATOR_BOT. Выключен — такие запросы не создаются (некому написать первое сообщение), ручные запросы в MODERATOR по-прежнему можно одобрять.",
                        example: "Выключаете бота на время смены шаблонов. MATCH+AUTO перестаёт создавать интро, пока снова не включите.",
                        tip: "Проверьте этот выключатель, если очередь пустая, а матчинг только что отработал."
                    },
                    notificationsTab: {
                        title: "Уведомления менеджера",
                        description: "Как вам сообщать о новых запросах в очереди. Это не настройки участников (у них свои в профиле). Режим INSTANT / DIGEST / OFF плюс каналы Email и Telegram.",
                        example: "DIGEST + Telegram, 1 раз в день: приходит «в очереди 8 запросов», без письма на каждый.",
                        tip: "Telegram сработает, только если у вашего участника привязан Telegram и канал разрешён.",
                        sections: [
                            {
                                title: "Зачем это отдельно",
                                summary: "Участники получают ACCEPTED/REJECTED и напоминания о непрочитанных. Здесь — только менеджер и очередь.",
                                bullets: [
                                    "INSTANT — сразу при появлении PENDING.",
                                    "DIGEST — пачкой раз в день или неделю, сколько сейчас ждёт.",
                                    "OFF — только бейдж в админке."
                                ]
                            }
                        ]
                    },
                    requestEmailMode: {
                        title: "INSTANT, DIGEST или OFF",
                        description: "Как часто писать менеджеру про очередь интро.",
                        example: "INSTANT: каждый новый MATCH сразу в Telegram. DIGEST: сводка «12 запросов ждут» раз в день или неделю. OFF: смотрите очередь сами.",
                        tip: "DIGEST уходит не чаще выбранного периода, даже если джоб крутится каждые 5 минут.",
                        sections: [
                            {
                                title: "INSTANT",
                                summary: "Сразу после создания PENDING-запроса: «Новый запрос на интро ждёт проверки».",
                                bullets: [
                                    "Удобно, когда запросов мало.",
                                    "На большом событии будет шум."
                                ]
                            },
                            {
                                title: "DIGEST",
                                summary: "Периодическая сводка, сколько PENDING сейчас в очереди.",
                                bullets: [
                                    "Одно сообщение вместо десятка.",
                                    "Не приходит, если очередь пуста."
                                ]
                            },
                            {
                                title: "OFF",
                                summary: "Писем и Telegram про очередь нет.",
                                bullets: [
                                    "Остаётся счётчик в админке и сама очередь."
                                ]
                            }
                        ]
                    },
                    digestPeriod: {
                        title: "Как часто слать DIGEST",
                        description: "Интервал сводки по очереди интро: раз в день или раз в неделю. Появляется, только если выбран DIGEST.",
                        example: "DIGEST + 1 раз в день + Telegram: не чаще одного сообщения в сутки, пока в очереди есть заявки.",
                        tip: "Если очередь пустая, сообщение не уходит и период не сдвигается."
                    },
                    notifEmail: {
                        title: "Email менеджера",
                        description: "Слать ли INSTANT/DIGEST на email вашего участника. Тема вроде «New intro request» или «Intro queue».",
                        example: "Email вкл, Telegram выкл, INSTANT — каждое новое PENDING приходит письмом.",
                        tip: "Нужен подтверждённый email. Выключатель не меняет письма участникам про ACCEPTED/REJECTED."
                    },
                    notifTelegram: {
                        title: "Telegram менеджера",
                        description: "Тот же INSTANT или DIGEST, но в Telegram, если бот сообщества к вам привязан.",
                        example: "DIGEST + Telegram: «8 intro requests are waiting for review».",
                        tip: "Если сообщения нет — проверьте привязку Telegram в профиле и что режим не OFF."
                    },
                    unreadReminders: {
                        title: "Напоминания о непрочитанных чатах",
                        description: "Как вам сообщать о чатах, которые вы ещё не открыли. Push — мгновенный сигнал в браузере. Email и Telegram — куда слать напоминание и полный текст. «Напоминания о непрочитанном» — как часто слать счётчик.",
                        example: "Борис написал, пока вас не было. Push = «Каждое сообщение» — сразу всплывающее уведомление. Если чат так и не открыт, при «Новые сообщения» через 5 минут придёт письмо с текстом.",
                        tip: "Это ваши настройки участника. Они не меняют письма менеджеру про очередь интро."
                    },
                    chatNotifEmail: {
                        title: "Email",
                        description: "Слать ли на почту полный текст нового сообщения и напоминания о непрочитанных чатах.",
                        example: "«Новые сообщения» вкл + Email: если чат не открыт, через 5 минут придёт письмо с текстом Бориса.",
                        tip: "Нужен подтверждённый email. Выключатель не отключает браузерный push."
                    },
                    chatNotifTelegram: {
                        title: "Telegram",
                        description: "Те же напоминания о непрочитанном, но в Telegram, если бот сообщества к вам привязан.",
                        example: "«1 раз в день» + Telegram: раз в сутки приходит сообщение вроде «У вас 3 непрочитанных чата».",
                        tip: "Если сообщения нет — привяжите Telegram в профиле и не ставьте напоминания в «Выкл»."
                    },
                    chatMessageCopy: {
                        title: "Новые сообщения",
                        description: "Присылать полный текст нового сообщения на Email и Telegram, если вы не открыли чат примерно за 5 минут. Это не счётчик непрочитанных.",
                        example: "Борис написал «Привет». Если чат не открыт, через 5 минут придёт письмо с этим текстом и кнопкой «Посмотреть сообщение».",
                        tip: "Открыли чат раньше — письма не будет. Нужны включённые Email или Telegram выше."
                    },
                    chatPushScope: {
                        title: "Push",
                        description: "Сигнал в браузере или в приложении, когда пришло новое сообщение, а этот чат у вас не открыт. Не зависит от Email и Telegram.",
                        example: "«Каждое сообщение»: каждый ответ Бориса даёт ping. «Только интро»: ping при открытии чата, на обычные реплики — нет. «Выкл»: push нет.",
                        tip: "Push срабатывает даже если напоминания выключены. Email и Telegram он не использует.",
                        sections: [
                            {
                                title: "Каждое сообщение",
                                summary: "Ping на любое новое сообщение в чате, который сейчас не открыт."
                            },
                            {
                                title: "Только интро",
                                summary: "Ping, когда открывается новый чат после интро. Обычные сообщения в уже открытом чате push не дают."
                            },
                            {
                                title: "Выкл",
                                summary: "Браузерный и in-app push выключены. Напоминания на Email и Telegram живут отдельно."
                            }
                        ]
                    },
                    chatUnreadDigest: {
                        title: "Напоминания о непрочитанном",
                        description: "Как часто слать письмо или Telegram со счётчиком непрочитанных чатов. «1 раз в день» и «1 раз в неделю» — пачкой. «Выкл» — счётчик не слать. Полный текст нового сообщения настраивается отдельно.",
                        example: "«1 раз в день» + Email: три непрочитанных чата — одно письмо за день, не три.",
                        tip: "Как только вы открыли чат, напоминание отменяется. Push настраивается отдельно выше.",
                        sections: [
                            {
                                title: "1 раз в день / неделю",
                                summary: "Одно сообщение со счётчиком непрочитанных за выбранный период."
                            },
                            {
                                title: "Выкл",
                                summary: "Писем и Telegram со счётчиком непрочитанного нет. Push и полные новые сообщения живут отдельно."
                            }
                        ]
                    }
                }
            },
            AdminSettings: {
                menuText: 'Настройки',
            }
        },
        errors: {
            emailFormat: "Неверный формат эл. почты",
            serverError: "Ошибка на стороне сервера",
            repeatedPassword: "Пароли не совпали",
            passwordLength:
                "Длина пароля должна быть не менее 8 и не более 128 символов.",
            errorTitle: "Ошибка",
            tryAgainLater: "Пожалуйста, попробуйте позже",
            code: "Не обнаружен код восстановления из запроса. Пройдите по ссылке ещё раз.",
            policy: "Необходимо согласиться с политикой конфиденциальности",
            1005: "Аккаунт не найден",
            1011: "Неверный логин или пароль",
            1014: "Неверный пароль",
        },
        warnings: {
            emailNotConfirmed: (email, communityName, senderEmail) =>
                `Поздравляем!<br><br>
                Теперь вы можете находить интересных для вас участников сообщества <span>${communityName}</span> и назначать им встречи.<br><br>
                На вашу почту <span>${email}</span> пришло сообщение от <span>${senderEmail || "community@volee.space"
                }</span>.<br><br>
                Осталось всего лишь подтвердить email в письме, которое мы вам уже отправили.
                Если не увидели письмо - проверьте в папке "спам" или "промоакции".`,
        },
        components: {
            EventOnboarding: {
                title: "Онбординг события",
                loading: "Загрузка вопросов...",
                retry: "Повторить",
                noQuestions: "Вопросы для онбординга отсутствуют.",
                continue: "Продолжить",
                progress: "Вопрос",
                of: "из",
                answered: "отвечено",
                textPlaceholder: "Введите ваш ответ...",
                previous: "Назад",
                next: "Далее",
                cancel: "Отмена",
                submitting: "Отправка...",
                complete: "Завершить онбординг",
                key: "Ключ",
                questionConfigured: "вопрос настроен",
                questionsConfigured: "вопросов настроено",
                clickActionsToManage: "Нажмите действия для управления",
                manageOnboardingQuestions: "Управление вопросами онбординга для",
                resuming: "Возобновление онбординга...",
                question: "Вопрос",
                completeText: "Завершить",
                saving: "Сохранение...",
                requiredQuestion: "Обязательный вопрос",
                requiredQuestionError: "Этот вопрос обязателен. Пожалуйста, ответьте на него перед продолжением.",
                saveError: "Не удалось сохранить ответ. Пожалуйста, попробуйте снова.",
                answerOptionsWillAppear: "Варианты ответов для этого типа вопроса можно будет добавить после сохранения",
                addNewQuestion: "Добавить новый вопрос в онбординг события",
                updateQuestionDetails: "Обновить детали вопроса и настройки"
            },
            loader: {
                text: "Загрузка...",
            },
            logout: {
                alreadyMember: "Уже участник?",
                out: "Выйти",
                in: "Войти",
            },
            participant: {
                matchingDate: "Дата подбора",
                online: "онлайн",
                successText: "Изменения сохранены",
                lookingFor: "В поисках",
                editProfile: "Редактировать профиль",
                about: "О себе",
                activeNow: "В сети",
                activeMinutesAgo: (n) => `Был(а) ${n} мин назад`,
                activeHoursAgo: (n) => `Был(а) ${n} ч назад`,
                activeDaysAgo: (n) => `Был(а) ${n} дн. назад`,
                tags: "Тэги",
                contacts: "Контакты",
                companyLabel: "Компания, должность",
                noCompany: "Компания не указана",
                noLocation: "Город скрыт",
                relevanceLabel: "Рeлевантность",
                relevanceCalculating: "Считаем совпадение",
                sharedEventUpcoming: (name, event) =>
                    `Вы вместе пойдёте на событие «${event}» с ${name}`,
                sharedEventPast: (name, event) =>
                    `Вы вместе были на событии «${event}» с ${name}`,
                relevanceTooltip:
                    "Уровень релевантности рассчитан на основе ваших интересов и запросов. Если уровень высок, то рекомендуем познакомиться с участником сообщества",
                bottomNoteText:
                    "Поле для Вашей заметки по итогам встречи с партнером. Эта заметка видна только Вам.",
                choiceSaved: "Ваш выбор сохранён",
                whyNotInterested: (fullName) =>
                    `Почему Вам не релевантен ${fullName}?`,
                notInterested: "Не интересен",
                alreadyKnow: "Уже знакомы",
                other: "Другое",
                clickHereIf: "Нажмите, если",
                connectFirst: "Хотите увидеть этот контакт?",
                connectFirstHint: "Сначала нажмите «Связаться», чтобы открыть его.",
                interested: "Связаться",
                pending: "Ожидает",
                cancelRequest: "Отменить заявку",
                cancelRequestConfirm: "Отменить эту заявку?",
                keepRequest: "Оставить",
                rejectedByModerator: "Отклонено модератором",
                remainingDays: (n) => `Connect снова через ${n} дн.`,
                openChat: "Открыть чат",
                interestedMap: {
                    introMessage: (firstName, lastName) =>
                        `Скоро познакомим вас c ${firstName} ${lastName}`,
                    introInputLabel: "Вашe приветственное сообщение (по желанию)",
                    done: "Готово",
                    cancel: "Отмена",
                    privacyWarning: "Пользователь скрыл свои контакты. Если вы хотите связаться с ним, отправьте ваше интро-сообщение модератору на <a href='mailto:community@joinee.io'>community@joinee.io</a>",
                },
                introMessageMap: {
                    introMessage: (firstName, lastName) =>
                        `Ваш контакт на этой неделе ${firstName} ${lastName}
                    <p>Чтобы договориться о встрече, напишите партнеру и выберите удобный и доступный способ связи. Мы сообщим ему о Вашем намерении встретиться</p>`,
                    defaultMessage: (firstName, fromName) =>
                        `Привет, ${firstName}!\n\nЯ ${fromName}, Matching бот считает, что мы можем быть друг другу полезны и предлагает нам познакомиться. Расскажи, какими проектами сейчас занимаешься ты?\n\nВот мои контакты:\n\n`,
                    introInputLabel: "Приветственное сообщение",
                    done: "Отправить",
                    cancel: "Пропустить",
                    introSuccessTitle: "Сообщение отправлено",
                },
                cancel: "Отмена",
                no: "Нет",
                fillProfile: (url) => `Заполните <a href='/${url}'>профиль</a> для просмотра контактов`,
                whyDisabled: "Почему это недоступно?",
                connectBlockedTitle: "Сначала заполните профиль",
                connectBlockedBody: (name, fields) => fields
                    ? `Чтобы связаться с ${name}, сначала заполните: ${fields}.`
                    : `Чтобы связаться с ${name}, сначала заполните профиль.`,
                connectBlockedAction: "Заполнить профиль",
                profileFieldLabels: {
                    FIRST_NAME: "имя",
                    LAST_NAME: "фамилию",
                    COMPANY: "компанию",
                    ABOUT: "о себе",
                    COMMUNICATION_CHANNELS: "каналы связи",
                    CONTACTS: "контакты",
                    AVATAR: "фото",
                    LOCATION: "местоположение",
                },
                createdAt: "Создан",
                invitedBy: "Приглашение от",
                report: "Пожаловаться",
                messageAlreadySent: "Вы уже отправили Интро этому человеку",
                profileLinkCopied: "Ссылка на профиль скопирована",
                copied: "Скопировано",
                buttonTitles: {
                    connect: "Связаться",
                    message: "Сообщение",
                    bookmark: "Закладки",
                    share: "Поделиться",
                    editOnboarding: "Изменить ответы анкеты",
                }
            },
            ParticipantAvatars: {
                noParticipantsRegistered: "Нет участников",
                participantAlt: "Участник",
            },
            search: {
                placeholder: "Найти человека или экспертизу",
                showAllCities: "Показать все города",
                cityNames: CITY_NAMES.RU
            },
            commandSearch: {
                search: "Поиск",
                placeholder: (name) => `Поиск ${name}...`,
                hint: ({ members = true, events = true, jobs = true } = {}) => {
                    const parts = [
                        members && "участники",
                        events && "события",
                        jobs && "вакансии",
                    ].filter(Boolean);
                    return parts.length
                        ? `Введите запрос: ${parts.join(", ")}`
                        : "Введите запрос";
                },
                searching: "Поиск...",
                noResults: (query) => `Ничего не найдено по запросу «${query}».`,
                membersError: "Не удалось загрузить участников. Попробуйте ещё раз.",
                members: "Участники",
                events: "События",
                career: "Карьера",
                palette: "Палитра навигации",
                press: "Нажмите",
                toClose: "чтобы закрыть",
            },
            question: {
                prompt: (strs, num) =>
                    `Можно выбрать ${num === 1
                        ? "один вариант"
                        : num % 10 === 1 && num % 100 !== 11
                            ? `до ${num} варианта`
                            : `до ${num} вариантов`
                    }`,
                promptInput: "Введите ваш ответ (до 256 символов)",
                promptSelect: "Выберите один вариант",
                promptYearInput: "Выберите год",
                promptInputPlaceholder: "Введите ваш ответ",
                searchPlaceholder: "Искать варианты",
                enterYourOption: "Введите свой вариант",
                nocontent: (hasCustomAnswer) =>
                    "Варианты не найдены" + (hasCustomAnswer ? ".<br/>Уточните ваш запрос или введите свой вариант" : ""),
            },
            note: {
                save: "Сохранить",
                cancel: "Отмена",
                more: "ещё",
                less: "свернуть",
            },
            header: {
                donate: "Сказать \"Спасибо\"",
                support: "Сказать \"Спасибо\"",
                viewProfile: "Смотреть профиль",
                settings: "Настройки",
                adminPanel: "Админка сообщества",
                adminBadge: "Админ",
                navigation: "Навигация",
                logOut: "Выйти",
                signOut: "Выйти",
                supportText: "Спасибо за поддержку нашего сообщества! Ваш вклад помогает нам поддерживать и развивать платформу.",
                invite: "Пригласить",
                copy: "Копировать",
                copied: "Скопировано",
                invitationTitle: "Отправьте другу ссылку-приглашение в сообщество",
            },
            notifications: {
                notifications: "Уведомления",
                options: "Опции",
                settings: "Настройки",
                selectAll: "Выбрать все",
                deselectAll: "Отменить выбор",
                dismiss: "Удалить",
                new: "Новые",
                previously: "Ранее",
                confirmEmail: "Пожалуйста, подтвердите почту",
                confirmEmailUrl: "Подтвердить",
                fillProfile: "Пожалуйста, продолжите заполнение вашего профиля",
                fillProfileUrl: "Заполнить",
                grantPermissions: "Включите уведомления, чтобы моментально узнавать о подобранных контактах",
                grantPermissionsUrl: "Включить уведомления",
                grantPermissionsTitle: "Будьте в курсе событий!",
                nocontent: "Пока новых уведомлений нет",
                rateMeeting: "Оценить",
                close: "Закрыть"
            },
            tour: {
                controls: {
                    back: "Назад",
                    close: "Закрыть",
                    last: "Завершить",
                    next: "Далее",
                    open: "Открыть диалог",
                    skip: "Пропустить"
                },
                communityCard: "Добро пожаловать в Сообщество! Давайте быстро покажем вам, как пользоваться системой.",
                searchForInput: "Оставьте запрос на конкретную экспертизу здесь. Наш алгоритм использует Ваш запрос для подбора рекомендаций.",
                settingButton: "Для изменения ответов в анкете используйте эту кнопку. Для дополнительных настроек посетите страницу Профиль.",
                networkButton: "Управляйте участием во встречах. Включите, чтобы еженедельно получать рекомендации контактов.",
                requestsTab: "Узнайте, кого сейчас ищут другие пользователи на вкладке Запросы.",
                interestedButtons: "Нажмите 'Связаться', чтобы мгновенно отправить сообщение или 'X', чтобы скрыть рекомендацию."
            },
            requests: {
                title: "Запросы",
                allRequests: "Все запросы",
                nocontent: "Пока в сообществе нет запросов, соответствующих вашим интересам, но скоро они появятся",
                answerOnRequest: ["Ответить", "на запрос"],
                match: "Совпадение",
                answerDefaultText: (firstName, communityTitle) => `\nПривет ${firstName},\nОтвечаю на твой запрос в ${communityTitle}!\n\nВот как я могу с этим помочь:\n\n`,
            },

        },
        months: [
            "января",
            "февраля",
            "марта",
            "апреля",
            "мая",
            "июня",
            "июля",
            "августа",
            "сентября",
            "октября",
            "ноября",
            "декабря",
        ],
    },
    EN: {
        pages: {
            VacancyDetail: {
                Common: {
                    loading: "Loading...",
                    vacancyFallback: "Vacancy",
                    unknownUser: "Unknown user",
                    defaultUserInitial: "U",
                    salaryFrom: "from",
                    salaryUpTo: "up to",
                    employmentFullTime: "Full-time",
                    employmentPartTime: "Part-time",
                    employmentContract: "Contract",
                    employmentInternship: "Internship",
                    workModeOnSite: "On-site",
                    workModeRemote: "Remote",
                    workModeHybrid: "Hybrid",
                    filters: "Filters",
                },
                Detail: {
                    failedToLoadVacancy: "Failed to load vacancy",
                    externalLinkNotConfigured: "External application link is not configured",
                    failedToSubmitApplication: "Failed to submit application",
                    applicationWithdrawn: "Application withdrawn",
                    failedToWithdrawApplication: "Failed to withdraw application",
                    vacancyNotFound: "Vacancy not found",
                    careerMenuText: "Career",
                    companyLogoAlt: "Company logo",
                    editVacancy: "Edit Vacancy",
                    manageQuestions: "Manage Questions",
                    applyNow: "Apply Now",
                    applicationPending: "Application Pending",
                    applicationAccepted: "Application Accepted",
                    applicationRejected: "Application Rejected",
                    withdrawApplication: "Withdraw Application",
                    applicationsPaused: "Applications are paused",
                    applicationsOpenLater: "Applications will open later",
                    applicationsClosed: "Applications are closed",
                    jobDescription: "Job Description",
                    details: "Details",
                    posted: "Posted",
                    validUntil: "Valid Until",
                    requiredSkills: "Required Skills",
                    preferredSkills: "Preferred Skills",
                    categories: "Categories",
                    sectors: "Sectors",
                    contactPersons: "Contact persons",
                    creator: "Creator",
                    responsible: "Responsible",
                    applications: "Applications",
                    viewAllApplications: "View all applications",
                },
                CreateVacancy: {
                    parseVacancyUrlRequired: "Please enter a vacancy URL to parse",
                    parseVacancyNoCommunity: "Community is not selected",
                    parseVacancySuccess: "Vacancy parsed successfully",
                    parseVacancyError:
                        "We couldn't parse this vacancy. Please try again later or fill in the fields manually.",
                    parseVacancyEmptyData: "AI parser returned empty vacancy data",
                    descriptionRequired: "Description is required",
                    communityNotSelected: "Community is not selected",
                    failedToLoadVacancy: "Failed to load vacancy",
                    vacancyUpdatedSuccessfully: "Vacancy updated successfully",
                    vacancyCreatedSuccessfully: "Vacancy created successfully",
                    failedToSaveVacancy: "Failed to save vacancy",
                    logoUploadedSuccessfully: "Logo uploaded successfully",
                    failedToUploadLogo: "Failed to upload logo",
                    photoUploadedSuccessfully: "Photo uploaded successfully",
                    failedToUploadPhoto: "Failed to upload photo",
                    vacancyDeletedSuccessfully: "Vacancy deleted successfully",
                    failedToDeleteVacancy: "Failed to delete vacancy",
                    responsibleAddedSuccessfully: "Responsible added successfully",
                    failedToAddResponsible: "Failed to add responsible",
                    responsibleRemovedSuccessfully: "Responsible removed successfully",
                    failedToRemoveResponsible: "Failed to remove responsible",
                    showOnVacancyPage: "Show on vacancy page",
                    hiddenContactPerson: "Hidden from public vacancy page",
                    failedToUpdateResponsibleVisibility: "Failed to update contact person visibility",
                    careerMenuText: "Career",
                    editVacancy: "Edit Vacancy",
                    createVacancy: "Create Vacancy",
                    parseVacancySectionTitle: "Parse Vacancy",
                    vacancyUrlLabel: "Vacancy URL",
                    vacancyUrlPlaceholder: "https://example.com/jobs/java-developer",
                    parsing: "Parsing...",
                    parseVacancyButton: "Parse vacancy",
                    parseVacancyHint: "Paste a vacancy page URL. The parser will fill title, organization name, description, location, salary, employment data, tags, and application URL.",
                    improveDescriptionButton: "Improve description (AI)",
                    extractFromDescriptionButton: "Fill tags from description (AI)",
                    improvingDescription: "Improving...",
                    extractingFromDescription: "Extracting...",
                    improveDescriptionSuccess: "Description updated",
                    extractFromDescriptionSuccess: "Tags filled from description",
                    descriptionAiTooShort: "Add more text to the description (at least 30 characters)",
                    improveDescriptionError: "Could not improve the description. Please try again later.",
                    extractFromDescriptionError: "Could not extract tags from the description. Please try again later.",
                    vacancyUrlFieldHelp: "HTTPS link to the employer's job posting page — the parser reads this page.",
                    titleHelp: "Short job title as candidates see it in the list and on the vacancy page.",
                    organizationNameHelp: "Employer name shown to candidates (not your community name on the platform).",
                    descriptionHelp: "Responsibilities, requirements, conditions, stack. Lists and links are fine — main vacancy text.",
                    locationHelp: "City, region, or address. Pick a search suggestion to save coordinates for the map.",
                    applicationTypeHelp: "Platform — applications in the system. External website — redirect to your apply page.",
                    externalWebsiteUrlHelp: "Full apply URL (https://...). Required when application type is external.",
                    acceptApplicationsLabel: "Accept applications",
                    acceptApplicationsHelp: "Candidates can apply while the vacancy is within its validity period.",
                    applicationsPausedHint: "Applications are paused. Candidates will see that submissions are unavailable.",
                    minSalaryHelp: "Lower bound or a single amount. Leave empty with max if you do not publish a salary.",
                    maxSalaryHelp: "Upper bound. Leave empty if you only show a minimum or no salary range.",
                    currencyHelp: "If either salary field has a value, pick a currency. With no salary, use Not specified.",
                    employmentTypeHelp: "Full-time, part-time, contract, or internship.",
                    workModeHelp: "On-site, remote, or hybrid — how location-based work is organized.",
                    validPeriodHelp: "When the vacancy is visible on the career page. Leave blank if you do not need date limits.",
                    validFromHelp: "First day the vacancy is shown to candidates.",
                    validToHelp: "Last day shown; after this the listing may hide the vacancy (per storefront rules).",
                    tagsSectionHelp: "Skills are concrete stack and tools. Categories and sectors are broader labels for filters.",
                    requiredSkillsHelp: "Minimum must-haves: technologies, methods, languages without which the role is not a fit.",
                    preferredSkillsHelp: "Nice-to-have: adjacent stack, cloud, tools — helpful but optional.",
                    categoriesHelp: "Role family, e.g. Software Development, UX Design.",
                    sectorsHelp: "Industry or business type: FinTech, Healthcare, Insurance, etc.",
                    logoSectionHelp: "Square employer logo for the vacancy list and card.",
                    vacancyImageSectionHelp: "Wide banner image for the card header; optional.",
                    basicInformation: "Basic Information",
                    titleLabel: "Title",
                    organizationNameLabel: "Organization name",
                    organizationNamePlaceholder: "Company or employer name",
                    descriptionLabel: "Description",
                    slugLabel: "Slug",
                    slugFieldHelp: "Short URL segment (Latin, hyphens). Leave empty to auto-generate from title.",
                    slugHint: "Leave empty to auto-generate from title.",
                    locationLabel: "Location",
                    locationPlaceholder: "Enter location (e.g., Munich, Germany)",
                    searchingCity: "Searching city...",
                    coordinatesSaved: "Coordinates saved",
                    applicationTypeSectionTitle: "Application Type",
                    applicationTypeLabel: "Application Type",
                    applicationTypePlatform: "Platform (manage in system)",
                    applicationTypeExternalWebsite: "External Website (redirect)",
                    externalWebsiteUrlLabel: "External Website URL",
                    salaryAndEmployment: "Salary & Employment",
                    minSalaryLabel: "Min Salary",
                    maxSalaryLabel: "Max Salary",
                    currencyLabel: "Currency",
                    currencyNotSpecified: "Not specified",
                    salaryCurrencyRequiredWhenSalarySet:
                        "Select a currency when you enter a minimum or maximum salary.",
                    currencyNames: {
                        EUR: "Euro",
                        USD: "US Dollar",
                        GBP: "British Pound",
                        CHF: "Swiss Franc",
                        JPY: "Japanese Yen",
                        CNY: "Chinese Yuan",
                        HKD: "Hong Kong Dollar",
                        SGD: "Singapore Dollar",
                        AUD: "Australian Dollar",
                        NZD: "New Zealand Dollar",
                        CAD: "Canadian Dollar",
                        SEK: "Swedish Krona",
                        NOK: "Norwegian Krone",
                        DKK: "Danish Krone",
                        ISK: "Icelandic Króna",
                        PLN: "Polish Złoty",
                        CZK: "Czech Koruna",
                        HUF: "Hungarian Forint",
                        RON: "Romanian Leu",
                        BGN: "Bulgarian Lev",
                        UAH: "Ukrainian Hryvnia",
                        RUB: "Russian Ruble",
                        GEL: "Georgian Lari",
                        TRY: "Turkish Lira",
                        AED: "UAE Dirham",
                        SAR: "Saudi Riyal",
                        ILS: "Israeli Shekel",
                        INR: "Indian Rupee",
                        IDR: "Indonesian Rupiah",
                        THB: "Thai Baht",
                        VND: "Vietnamese Đồng",
                        PHP: "Philippine Peso",
                        MYR: "Malaysian Ringgit",
                        KRW: "South Korean Won",
                        BRL: "Brazilian Real",
                        MXN: "Mexican Peso",
                        ARS: "Argentine Peso",
                        ZAR: "South African Rand",
                    },
                    employmentTypeLabel: "Employment Type",
                    workModeLabel: "Work Mode",
                    validPeriodLabel: "Valid period",
                    optional: "optional",
                    validFromLabel: "Valid From",
                    validToLabel: "Valid To",
                    tagsSectionTitle: "Tags",
                    requiredSkillsLabel: "Required skills",
                    requiredSkillsPlaceholder: "Search skills (e.g. Java, Spring Boot)",
                    preferredSkillsLabel: "Preferred skills",
                    preferredSkillsPlaceholder: "Search skills (e.g. Docker, AWS)",
                    categoriesLabel: "Categories",
                    categoriesPlaceholder: "Search categories",
                    sectorsLabel: "Sectors",
                    sectorsPlaceholder: "Search sectors",
                    logoSectionTitle: "Logo",
                    squareOnly: "Any size is allowed, final logo will be square",
                    vacancyLogoPreviewAlt: "Vacancy logo preview",
                    logoLabel: "Logo",
                    uploadLogo: "Upload Logo",
                    cropLogo: "Crop Logo",
                    cropLogoDescription: "You can upload any image size — final logo will be cropped to a square",
                    uploadingLogo: "Uploading logo...",
                    vacancyImageSectionTitle: "Vacancy image",
                    vacancyImagePreviewAlt: "Vacancy image preview",
                    vacancyImageLabel: "Vacancy Image",
                    uploadVacancyImage: "Upload Vacancy Image",
                    cropVacancyImage: "Crop Vacancy Image",
                    cropVacancyImageDescription: "Adjust vacancy image before upload",
                    uploadingImage: "Uploading image...",
                    vacancyResponsibles: "Vacancy Responsibles",
                    searchParticipants: "Search participants",
                    searchParticipantsPlaceholder: "Type name, username or slug",
                    searchResults: "Search results",
                    add: "Add",
                    currentResponsibles: "Current responsibles",
                    remove: "Remove",
                    noResponsiblesYet: "No responsibles yet",
                    noResponsiblesDescription: "Add participants who can manage this vacancy.",
                    delete: "Delete",
                    cancel: "Cancel",
                    saving: "Saving...",
                    update: "Update",
                    create: "Create",
                    deleteVacancyTitle: "Delete Vacancy",
                    deleteVacancyMessage: "Are you sure you want to delete this vacancy?",
                    deleteVacancyWarning: "This action cannot be undone.",
                    confirmDelete: "Yes, Delete",
                    cancelDelete: "Cancel",
                    selectFile: "Select File",
                    rotate: "Rotate",
                    save: "Save",
                    back: "Back",
                    clearSearch: "Clear search",
                    suggestions: "Suggestions",
                    searching: "Searching...",
                    chooseImageForLogo: "Choose image for logo",
                    chooseImageForVacancyImage: "Choose image for vacancy image",
                    uploadAvailableAfterCreate: "You can upload logo and image after creating the vacancy.",
                    change: "Change",
                    upload: "Upload",
                    anyRatio: "Any ratio",
                    squareRatio: "1:1 square",
                    freeCropWithSquareResult: "Choose any crop ratio. Final logo will be exported as a square on white background.",
                },
                QuestionManager: {
                    failedToLoadVacancy: "Failed to load vacancy",
                    failedToLoadQuestions: "Failed to load questions",
                    failedToLoadQuestion: "Failed to load question",
                    deleteQuestionConfirm: "Delete this question?",
                    questionDeleted: "Question deleted",
                    failedToDeleteQuestion: "Failed to delete question",
                    questionUpdated: "Question updated",
                    questionCreated: "Question created",
                    failedToSaveQuestion: "Failed to save question",
                    vacancyNotFound: "Vacancy not found",
                    backToVacancy: "Back to vacancy",
                    pageTitle: "Vacancy Question Manager",
                    newQuestion: "New Question",
                    noQuestionsYet: "No questions yet.",
                    order: "Order",
                    question: "Question",
                    type: "Type",
                    visible: "Visible",
                    actions: "Actions",
                    yes: "Yes",
                    no: "No",
                    edit: "Edit",
                    delete: "Delete",
                    editQuestion: "Edit Question",
                    createQuestion: "Create Question",
                    questionText: "Question Text",
                    questionType: "Question Type",
                    required: "Required",
                    answerOptions: "Answer options",
                    manageAnswerOptions: "Manage Answer Options",
                    cancel: "Cancel",
                    save: "Save",
                    saving: "Saving...",
                    questionTypeTextInput: "Text Input",
                    questionTypeRadio: "Single Choice (Radio)",
                    questionTypeCheckbox: "Multiple Choice (Checkbox)",
                    questionTypeFileUpload: "File Upload",
                    questionTypeCvUpload: "CV Upload",
                    questionTypeCoverLetterUpload: "Cover Letter Upload",
                    questionTypeCertificateUpload: "Diplomas, certificates, etc",
                },
                Applications: {
                    failedToLoadVacancyApplications: "Failed to load vacancy applications",
                    failedToUpdateStatus: "Failed to update status",
                    noPendingApplications: "No pending applications",
                    pendingApplicationsRejected: "Pending applications rejected",
                    failedToRejectRemaining: "Failed to reject remaining",
                    unnamedCandidate: "Unnamed candidate",
                    attachment: "Attachment",
                    file: "File",
                    vacancyNotFound: "Vacancy not found",
                    backToVacancy: "Back to vacancy",
                    applicationsTitle: "Applications",
                    rejecting: "Rejecting...",
                    rejectRemaining: "Reject remaining (pending)",
                    noApplicationsYet: "No applications yet.",
                    noApplicationsMatchFilters: "No applications match selected filters.",
                    noEmailProvided: "No email provided",
                    appliedAt: "Applied at",
                    notAvailable: "n/a",
                    accept: "Accept",
                    reject: "Reject",
                    attachedFiles: "Attached files",
                    noAttachedFiles: "No attached files.",
                },
                ApplicationDetails: {
                    applicationNotFound: "Application not found",
                    failedToLoadApplicationDetails: "Failed to load application details",
                    document: "document",
                    failedToDownloadFile: "Failed to download file",
                    failedToUpdateStatus: "Failed to update status",
                    unnamedCandidate: "Unnamed candidate",
                    backToApplications: "Back to applications",
                    applicationDetailsTitle: "Application details",
                    accept: "Accept",
                    reject: "Reject",
                    noEmailProvided: "No email provided",
                    about: "About",
                    submittedAnswers: "Submitted answers",
                    noAnswersSaved: "No answers saved.",
                    question: "Question",
                    answer: "Answer",
                    files: "Files",
                },
                Apply: {
                    failedToLoadVacancy: "Failed to load vacancy",
                    applicationSubmittedSuccessfully: "Application submitted successfully",
                    failedToSubmitApplication: "Failed to submit application",
                    loading: "Loading...",
                    backToVacancy: "Back to vacancy",
                },
            },
            VacancyList: {
                menuText: "Career",
                loading: "Loading...",
                loadingVacancies: "Loading vacancies...",
                errorPrefix: "Error",
                postVacancy: "Post Vacancy",
                filters: "Filters",
                searchPlaceholder: "Search role, skill or category",
                locationPlaceholder: "Location",
                allWorkModes: "All work modes",
                allEmploymentTypes: "All employment types",
                tagPlaceholder: "Tag (skill/category/sector)",
                filterSuggestions: "Suggestions",
                filterSearching: "Searching...",
                filterMinCharsHint: "Type at least 2 characters for suggestions",
                filterClear: "Clear field",
                favoritesOnly: "Favorites only",
                archivedOnly: "Show archived vacancies",
                searchTagLabel: "Search",
                locationTagLabel: "Location",
                workModeTagLabel: "Work mode",
                employmentTagLabel: "Employment",
                tagTagLabel: "Tag",
                filtersApplied: (count) => `${count} filter${count === 1 ? '' : 's'} applied`,
                clearAll: "Clear all",
                resultsFound: (count) => `${count} ${count === 1 ? 'vacancy' : 'vacancies'} found`,
                noVacanciesTitle: "No vacancies match selected filters.",
                noVacanciesSubtitle: "Try removing some filters to see more results.",
                viewDetails: "View details",
                addToFavorites: "Add to favorites",
                removeFromFavorites: "Remove from favorites",
                archivedBadge: "Archived",
                today: "Today",
                yesterday: "Yesterday",
                daysAgo: (days) => `${days} days ago`,
                weeksAgo: (weeks) => `${weeks} weeks ago`,
                validInDays: (days) => `Valid in ${days} days`,
                salaryFrom: "from",
                salaryUpTo: "up to",
                vacancyFallback: "Vacancy",
                workModeOnSite: "On-site",
                workModeRemote: "Remote",
                workModeHybrid: "Hybrid",
                employmentFullTime: "Full-time",
                employmentPartTime: "Part-time",
                employmentContract: "Contract",
                employmentInternship: "Internship",
                page: "Page",
                previousPage: "Previous",
                nextPage: "Next",
            },
            Mentorship: {
                title: "Mentorship",
                loading: "Loading mentorship...",
                disabled: "Mentorship is not enabled for this community.",
                tryAgain: "Try again",
                back: "Back",
                next: "Next",
                cancel: "Cancel",
                saveProfile: "Save profile",
                saving: "Saving...",
                chooseHow: "Choose how you want to participate. You can add the other role later.",
                wantMentor: "I want to be a Mentor",
                findMentor: "Find a Mentor",
                beMentor: "Be a mentor",
                findAMentor: "Find a mentor",
                tabDiscover: "Discover",
                tabFavorites: "Favorites",
                tabRequests: "Requests",
                tabIncoming: "Incoming",
                tabActive: "Active",
                tabHistory: "History",
                noHistory: "No history yet.",
                complete: "Complete",
                full: "Full",
                placesLeft: (count) => (count === 1 ? "1 place left" : `${count} places left`),
                capacityLabel: "How many mentees can you take?",
                capacityHelp: "Set your active mentee limit. When full, new mentees cannot apply.",
                capacityExample: "Choose a number from 1 to 20.",
                capacityRequired: "Please choose how many mentees you can take (1-20).",
                capacitySaveFailed: "Failed to update capacity.",
                saveCapacity: "Save capacity",
                timelineApplied: "Applied",
                timelineAccepted: "Accepted",
                timelineCompleted: "Completed",
                timelineDeclined: "Declined",
                timelineCancelled: "Cancelled",
                tabProfile: "Profile",
                setupMentorProfile: "Set up your mentor profile",
                setupMenteeProfile: "Set up your mentee profile",
                editProfile: "Edit mentorship profile",
                stepOf: (current, total) => `Step ${current} of ${total}`,
                headline: "Headline",
                headlinePlaceholder: "Describe what you offer or seek",
                headlineRequired: "Please enter a headline before continuing.",
                headlineHelpMentor:
                    "A short line on your card in search. In one sentence, describe how you can help as a mentor.",
                headlineHelpMentee:
                    "A short line on your card. In one sentence, describe what help you are looking for from a mentor.",
                headlineExampleMentor:
                    "Example: “CTO, 12 years in SaaS. I mentor on career growth, hiring, and scaling teams”",
                headlineExampleMentee:
                    "Example: “Looking for a mentor to switch into Product Management”",
                answerRequired: "Please answer this required question before continuing.",
                answerAllRequired: "Please answer all required questions.",
                loadQuestionsFailed: "Failed to load questions.",
                saveAnswersFailed: "Failed to save your answers.",
                loadFailed: "Failed to load mentorship.",
                switchRoleFailed: "Failed to switch mentorship role.",
                switchRoleAfterSaveFailed: "Profile was saved, but role switching failed.",
                searchMentors: "Search mentors (e.g. python, career growth)",
                bestMatch: "Best match",
                newest: "Newest",
                search: "Search",
                noMentors: "No mentors found.",
                loadMore: "Load more",
                loadingMore: "Loading...",
                addFavorite: "Add favorite",
                removeFavorite: "Remove favorite",
                requestMentorship: "Request mentorship",
                requestMessagePrompt: "Add a message to your mentorship request (optional):",
                loadMentorsFailed: "Failed to load mentors.",
                loadMoreMentorsFailed: "Failed to load more mentors.",
                favoriteFailed: "Failed to update favorite.",
                sendRequestFailed: "Failed to send request.",
                loadMentorFailed: "Failed to load mentor profile.",
                loadMenteeFailed: "Failed to load mentee profile.",
                noFavorites: "No favorites yet.",
                loadFavoritesFailed: "Failed to load favorites.",
                removeFavoriteFailed: "Failed to remove favorite.",
                loadMoreFavoritesFailed: "Failed to load more favorites.",
                noRequests: "No requests yet.",
                loadRequestsFailed: "Failed to load requests.",
                cancelRequestFailed: "Failed to cancel request.",
                cancelRequest: "Cancel request",
                noIncoming: "No incoming requests.",
                noActive: "No active mentorships.",
                loadIncomingFailed: "Failed to load incoming requests.",
                updateRequestFailed: "Failed to update request.",
                accept: "Accept",
                decline: "Decline",
                noHeadline: "No headline yet",
                hideProfile: "Hide profile",
                makeVisible: "Make visible",
                visibilityFailed: "Failed to update profile visibility.",
                editAnswers: "Edit answers",
                loadingQuestions: "Loading questions...",
                loadingMentors: "Loading mentors...",
                loadingFavorites: "Loading favorites...",
                loadingRequests: "Loading requests...",
                viewProfile: "View profile",
                hideDetails: "Hide",
                aboutLabel: "About",
                lookingForLabel: "Looking for",
                mentorProfile: "Mentor profile",
                loadingMentor: "Loading profile...",
                noProfileDetails: "No additional details yet.",
                visible: "Visible",
                hidden: "Hidden",
                mentorFallback: "Mentor",
                matchPercent: (percent) => `${percent}% match`,
            },
            ContactList: {
                title: "Matches",
                menuText: "My matches",
                olderContacts: "Load more",
                nocontent:
                    "In the future, information and contact details of the partners you have selected for meetings will appear here",
                noBookmarks: "In this tab, you will find contact information and details about the individuals you have bookmarked.",
                noInterested: "In this tab, you will find individuals who have sparked your interest and whom you wish to connect with.",
                interested: "Interested",
                bookmarked: "Bookmarks",
                removeBookmark: "Remove bookmark",
            },
            Participants: {
                title: "Members",
                menuText: "All members",
                nocontent:
                    "In the future, information and contact details of the partners you have selected for meetings will appear here",
                moreParticipants: "More participants",
                dislikedUsers: "Disliked users",
                normalSearch: "Normal Search",
                smartSearch: "Smart Search",
                smartSearchSubmit: "Smart Search",
                searchPlaceholder: "Search by name or expertise",
                smartSearchPlaceholder: "Describe who you want to find",
                clearSearch: "Clear search",
                searchError: "Could not load members",
                retry: "Retry",
                searchEmpty: "No people matched. Change the query and try again.",
                backToResults: "Back to participants",
            },
            EventList: {
                title: "Events",
                menuText: "Events",
                upcoming: "Upcoming",
                past: "Past",
                noEvents: "No events yet",
                noEventsBtn: "Add event",
                dateTbc: "Date TBC",
                timeTbc: "Time TBC",
                event: "Event",
                eventTitle: "Event Title",
                locationTbc: "Location TBC",
                going: "going",
                namesAndOthers: (name1, name2, others) => `${name1}, ${name2} and ${others} others`,
                namesAndOthersSome: (name1, name2) => `${name1}, ${name2} and others`,
                createEvent: "Create event",
                // Filters
                filters: "Filters",
                date: "Date",
                location: "Location",
                city: "City",
                country: "Country",
                eventType: "Event Type",
                myEvents: "My events",
                whereIOrganize: "Where I am an organizer",
                eventsICreated: "Events I created",
                all: "All",
                online: "Online",
                offline: "Offline",
                // Date filters
                startDate: "Start Date",
                endDate: "End Date",
                clearStartDate: "Clear start date",
                clearEndDate: "Clear end date",
                startDateHint: "Leave empty to show events from today",
                endDateHint: "Optional: Leave empty for no end date limit",
                // Date filter options
                allEvents: "All events",
                today: "Today",
                tomorrow: "Tomorrow",
                thisWeekend: "This weekend",
                thisWeek: "This week",
                nextWeek: "Next week",
                thisMonth: "This month",
                nextMonth: "Next month",
                // SearchableSelect
                searchCity: "Search city...",
                searchCountry: "Search country...",
                typeToSearch: "Type to search...",
                loading: "Loading...",
                noResultsFound: "No results found for",
                noOptionsAvailable: "No options available",
                clearSelection: "Clear selection",
                // Errors
                communityIdNotFound: "Community ID not found",
                failedToLoadEvents: "Failed to load events",
                // Pagination and results
                showingEvents: "Showing {current} of {total} events",
                previous: "Previous",
                next: "Next",
                page: "Page",
                updating: "Updating...",
                pastEvents: "Past events",
                fromToday: "from today",
                total: "total",
                eventsTotal: (total) => `Events (total ${total})`,
                noFutureEvents: "No future events yet",
                noUpcomingShowingPast: "No upcoming events. Showing recent past events.",
                loadingEvents: "Loading…",
                clickPreviousToSeePast: "Click previous to see past events",
                noPastEvents: "No past events yet",
            },
            FAQ: {
                menuText: "FAQ",
            },
            Admin: {
                title: "Admin area",
                menuText: "Admin area",
                description: "Description",
                communityCRM: "Community CRM",
                analytics: "Analytics",
                noParticipants: "No participants in community yet",
            },
            UserAdmin: {
                title: "Admin Panel",
                description: "Manage community settings and moderate participants",
                participantModeration: {
                    title: "Participant Moderation",
                    searchPlaceholder: "Search by name, username, or email",
                    refresh: "Refresh",
                    allStatus: "All Status",
                    pending: "Pending",
                    confirmed: "Confirmed",
                    rejected: "Rejected",
                    participant: "Participant",
                    status: "Status",
                    actions: "Actions",
                    confirm: "Confirm",
                    reject: "Reject",
                    noPermission: "You don't have permission to access moderation features",
                    loadingParticipants: "Loading participants...",
                    loadingAdminPanel: "Loading admin panel..."
                },
                community: {
                    title: "Community",
                    export: "Export",
                    messageAll: "Message All",
                    searchPlaceholder: "Search by name, username, or email",
                    refresh: "Refresh",
                    allStatus: "All Status",
                    pending: "Pending",
                    confirmed: "Confirmed",
                    rejected: "Rejected",
                    participant: "Participant",
                    status: "Status",
                    actions: "Actions",
                    message: "Message",
                    profile: "Profile",
                    networking: "Networking",
                    delete: "Delete",
                    active: "Active",
                    disabled: "Disabled",
                    deleteModal: {
                        title: "This action is irreversible",
                        description: "will no longer be able to access the community platform.\nConfirm by solving the equation below:",
                        delete: "Delete",
                        cancel: "Cancel"
                    },
                    noPermission: "You don't have permission to access community management",
                    loadingParticipants: "Loading participants...",
                    exportSuccess: "Export completed successfully",
                    exportError: "Error during export",
                    messageAllSuccess: "Messages sent to all participants",
                    messageAllError: "Error sending messages"
                },
                bulkNetworking: {
                    title: "Networking management",
                    description: "Apply networking rules to multiple members at once.",
                    disableWithoutTelegramLabel: "Disable networking for members without connected Telegram",
                    apply: "Apply",
                    enableAll: "Enable networking for all participants",
                    success: (count) => `Networking disabled for ${count} members without connected Telegram`,
                    enableAllSuccess: (count) => `Networking enabled for ${count} participants`,
                    error: "Failed to update networking for members without connected Telegram",
                    enableAllError: "Failed to enable networking for all participants"
                },
                analytics: {
                    title: "Analytics",
                    overview: "Overview",
                    participants: "Participants",
                    events: "Events",
                    engagement: "Engagement",
                    growth: "Growth",
                    activity: "Activity",
                    statistics: "Statistics",
                    charts: "Charts",
                    reports: "Reports",
                    export: "Export",
                    refresh: "Refresh",
                    loading: "Loading analytics...",
                    noData: "No data to display",
                    noPermission: "You don't have permission to view analytics",
                    error: "Error loading data",
                    mostActive: "MOST ACTIVE",
                    mostPopular: "MOST POPULAR",
                    mostPositive: "MOST POSITIVE",
                    popularity: "Popularity",
                    meetingsParticipated: "MEETINGS PARTICIPATED",
                    interestingMarksReceived: "INTERESTING MARKS RECEIVED",
                    averageFeedbackScore: "AVERAGE FEEDBACK SCORE",
                    profiles: "Profiles",
                    registrations: "Registrations",
                    reviews: "Reviews",
                    connects: "Connects",
                    totalOpened: "Total Opened",
                    profilesFilledProperly: "Profiles filled properly",
                    onboardingsFilledProperly: "Onboardings filled properly",
                    registrationsDescription: "Registrations — how many users register in the community every day",
                    growthDescription: "Growth — the total amount of users in the community",
                    total: "total",
                    averageScore: "average score",
                    perWeek: "per week",
                    reviewsDescription: "Reviews — average score rate after each week of meetings between community members",
                    connectsDescription: "Connects — the average number of meetings each week between community members",
                    activeness: "Activeness",
                    communityStars: "Community Stars",
                    positivity: "Positivity",
                    activenessDescription: "The average activity of your community is",
                    connectsPerPerson: "connects per person",
                    activenessResult: "It's not the best result, but we know how to improve it.",
                    communityStarsDescription: "Meet the stars of your community! They were the most popular this month, receiving the most meeting requests.",
                    positivityDescription: "The positivity rate of your community =",
                    positivityResult: "It's good result! Congrats!",
                    recommendations: "Recommendations:",
                    activenessRecommendation: "Ask to fill in more information in the profiles of community members. This will increase the number of requests to connect among members on the platform",
                    communityStarsRecommendation: "We recommend to make 1-1 call with them. They could be your brand advocates and share the content about your brand",
                    positivityRecommendation: "During your events and mailing lists mention that it is very important to share feedback about new connections in the community",
                    distributionOfMeetings: "Distribution of Meetings",
                    distributionOfRequests: "Distribution of Requests",
                    distributionOfScoreRates: "Distribution of Score rates",
                    topMembers: "TOP MEMBERS",
                    meetings: "meetings",
                    requests: "requests",
                    asAvgScore: "as avg. score"
                },
                faq: {
                    title: "Manage FAQ",
                    description: "Edit the FAQ content shown on the /faq page per language.",
                    contentLabel: "FAQ content",
                    saved: "FAQ saved",
                    saveError: "Failed to save FAQ",
                    saving: "Saving...",
                    save: "Save FAQ",
                },
                conferenceButtons: {
                    title: "Telegram: conference buttons",
                    description: "Configure extra Telegram bot buttons for conference mode.",
                    hint: "Up to 6 buttons. Always fill in RU and EN — a user's Telegram language may differ from the community language. Bold, italic, links, and line breaks are supported.",
                    buttonTitle: "Button {n}",
                    addButton: "Add button",
                    removeButton: "Remove",
                    idLabel: "Button ID",
                    labelField: "Button label",
                    descriptionField: "Description for /start and /info",
                    descriptionHint: "Short line shown in welcome and Info messages. Format: «Label — description».",
                    descriptionPlaceholder: "conference speakers list",
                    contentField: "Button text",
                    editorHint: "You can use bold text, links, and lists. Unsupported tags are removed before sending.",
                    telegramLengthHint: "Telegram message length",
                    saved: "Conference buttons saved",
                    saveError: "Failed to save conference buttons",
                    saving: "Saving...",
                    save: "Save buttons",
                },
                chats: {
                    title: "Chats",
                    description: "Moderate intro requests and configure intro chats.",
                    queue: "Intro queue",
                    queueHint: "Approve or reject a request before a chat opens.",
                    conversations: "Conversations",
                    conversationsHint: "Review, lock, or moderate existing chats.",
                    settings: "Chat settings",
                    settingsHint: "Scenarios, intro templates, bot profile, and manager notifications.",
                },
                notifications: {
                    title: "Notifications",
                    individual: "Individual",
                    general: "General",
                    email: "Email",
                    telegram: "Telegram",
                    sms: "SMS",
                    send: "Send",
                    preview: "Preview",
                    subject: "Subject",
                    message: "Message",
                    recipients: "Recipients",
                    allParticipants: "All Participants",
                    selectedParticipants: "Selected Participants",
                    byLocation: "By Location",
                    byStatus: "By Status",
                    byTags: "By Tags",
                    template: "Template",
                    custom: "Custom",
                    loading: "Loading notifications...",
                    sending: "Sending...",
                    success: "Notifications sent successfully",
                    error: "Error sending notifications",
                    confirmSendTitle: "Send this notification?",
                    confirmSendBody: "Recipients will get this message. It will show up in the send history.",
                    noPermission: "You don't have permission to send notifications",
                    selectParticipant: "Select participant",
                    selectTemplate: "Select template",
                    enterMessage: "Enter message",
                    enterSubject: "Enter subject",
                    viewBy: "View by",
                    channelType: "Channel type",
                    messageType: "Message type",
                    emailMessages: "Email Messages",
                    telegramMessages: "Telegram Messages",
                    groupChatNotifications: "Group Chat Notifications",
                    generalCommunityNotification: "General community notification",
                    generalDescription: "Send notification to all community members in free format",
                    generalEventNotification: "General event notification",
                    generalEventDescription: "Send notification to event participants based on status",
                    selectEventStatus: "Select participant status",
                    confirmedAndPending: "Confirmed + Pending",
                    selectEventFirst: "Select an event to choose participant status",
                    participantsPreview: "Participants preview",
                    selectEventToPreview: "Select an event to preview participants",
                    selectStatusToPreview: "Select a status to preview participants",
                    noParticipantsForStatus: "No participants for selected status",
                    removeParticipant: "Remove participant from newsletter",
                    loadingParticipants: "Loading participants...",
                    recommendContacts: "Recommend contacts",
                    recommendDescription: "Recommend several participants to all community members",
                    individualNotification: "Individual notification",
                    individualDescription: "Send a notification to selected participants via email or Telegram. They will receive it even if their profile is disabled. An image can be attached for Telegram.<br/><b>Note:</b> If the participant has unsubscribed from the channel, we will be unable to deliver the notification.",
                    groupChatDescription: "Send notification to connected groups in Telegram. Image is optional.<br/>For text formatting use html, <a href=\"https://core.telegram.org/bots/api#html-style\" target=\"_blank\">more details</a>",
                    selectedLocations: "Selected locations:",
                    titleLabel: "Title",
                    textLabel: "Text",
                    signatureLabel: "Signature",
                    placeholderHelp: "You can use placeholders for personalization: <code>{firstName}</code>, <code>{lastName}</code>, <code>{fullName}</code>. They will be automatically replaced with each recipient's data.",
                    selectedParticipantsLabel: "Selected participants:",
                    searchByName: "Search by name",
                    upToParticipants: "participants",
                    selectAtLeast: "Select at least 1 participant",
                    noImageChosen: "No image chosen",
                    chooseImage: "Choose image",
                    captionLabel: "Caption",
                    sendNotification: "Send notification",
                    all: "ALL",
                    image: "Image",
                    caption: "Caption",
                    signature: "Signature",
                    saveDraft: "Save draft",
                    mailingJournal: "Mailing journal",
                    drafts: "Drafts",
                    sends: "Sends",
                    openAsNew: "Open as new",
                    skipped: "Skipped",
                    sent: "Sent",
                    photo: "Photo",
                    characterLimit: "Character limit exceeded",
                    telegramPhotoHint: "Optional: one photo. Caption limit is 1024 with a photo, 4096 without.",
                    delete: "Delete",
                    noDrafts: "No drafts",
                    noSends: "No sends",
                    channel: "Channel",
                    sentAt: "Date",
                    login: "Login",
                    fullName: "Full name",
                    searchByLogin: "Search by login",
                    previous: "Previous",
                    next: "Next",
                    cancel: "Cancel",
                    deleteDraftTitle: "Delete this draft?",
                    deleteDraftConsequences: "The draft will disappear from the journal. Sends already made stay. Unused images from this draft may be deleted from storage. This cannot be undone.",
                    deleteSendTitle: "Delete this send?",
                    deleteSendConsequences: "This send snapshot and its recipient list will disappear. Messages already delivered are not recalled. Unused images from this send may be deleted from storage. This cannot be undone.",
                }
            },
            welcome: {
                title: "Start networking with community members",
                description:
                    "We will find the most relevant contact in the community respecting your interests and requests and send you an offer for a 1:1 online meeting via email or messenger",
                button: "Start networking",
                about: {
                    mainLink: "Main",
                    aboutLink: "About service",
                    politicsLink: "Privacy Policy",
                    launchLink: "Launch your own community",
                    contactUs: "Contact us",
                    runBy: "Run by",
                    rightsReserved: "All Rights Reserved",
                    volee: "This application",
                    description1:
                        " – a community platform to create and manage all community activities and data in one place.",
                    description2:
                        "Find the most relevant contacts for their promotion, networking or business developments.",
                },
                shortLanding: {
                    iconBlockTitle: "The community will help you",
                    howItWorks: "How it works",
                    community: "Community"
                }
            },
            Auth: {
                email: "E-mail",
                password: "Password",
                passwordHint: "At least 8 characters",
                repeatedPassword: "Confirm Password",
                emailPlaceholder: "Enter your email",
                passwordPlaceholder: "********",
                googleButtonText: "Continue with Google",
                orContinueWith: "or continue with",
                or: "or",
                shortAuthButton: "Get started"
            },
            login: {
                title: "Welcome back",
                subtitle: "Log in to continue",
                button: "Sign in",
                accountQuestion: "Don't have an account yet? ",
                link: "Register now",
                recoveryQuestion: "Forgotten password? ",
                recovery: "Reset",
                communityMismatchError: "You are already registered in another community.",
                telegramNotLinkedError: "Telegram account is not linked. Log in with email to continue.",
                openCommunityLink: "Open your community",
            },
            Registration: {
                title: "Let's get started",
                subtitle: "Create an account",
                button: "Register",
                accountQuestion: "Have an account already? ",
                link: "Login now",
                agreePolicy: ["I agree to the ", " and to the "],
                termsOfUse: "Terms of Use",
                privacyPolicy: "Privacy Policy",
                error: {
                    "Duplicate email": "This email already exists",
                },
            },
            Recovery: {
                title: "Reset password",
                button: "Reset",
                accountQuestion: "Remember? ",
                link: "Sign in",
                successText: (email) =>
                    `We've sent you an email with instructions on how to reset your password to ${email}`,
            },
            ConfirmRecovery: {
                title: "Enter new password",
                button: "Recover",
                accountQuestion: "Changed your mind? ",
                link: "Sign in",
                successText: "Fine! Now You can sign in with the new password",
            },
            OneTimeCode: {
                title: "We have sent the code",
                subtitle: "Enter the code to confirm logging in with ",
                button: "Confirm",
                label: "Code",
                resendAfter: (time) => `Resend in 00:${time}`,
                resend: "Resend code",
                invalidCode: "Invalid code",
                rateLimitResend: (seconds) => `Too many OTP requests. Try again in ${seconds} seconds.`,
                rateLimitValidate: (seconds) => `Too many OTP validation attempts. Try again in ${seconds} seconds.`,
                validateBlocked: (seconds) => `Code verification is temporarily blocked. Try again in ${seconds} seconds.`,
                sendCode: "Send code",
                changeEmail: "Change email",
                changeEmailDescr: "Please, enter your email to receive one time code"
            },
            MyCommunities: {
                title: "Main",
                menuText: "Community",
                description:
                    "Here you can find new clients or partners. Share the experience and speak about entrepreneurship challenges in COVID times",
                nocontent:
                    "Please, ask your community manager to provide an invitation link",
                nocontentBtn: "Reload",
                successText: "Your new request saved",
                successSubtitle: "You will get more relevant recommendations",
                successButton: "Got it",
                changeSearchForText: "Change search criteria",
                changeSearchForButton: "Save",
                searchForPlaceholder: "Enter your request to the community",
                lastMeetingsTitle: "How was your recent meeting",
                lastMeetingsScore: "Score",
                lastMeetingsNote: "Meeting notes (optional)",
                lastMeetingsNoMeeting: "I haven't met this person",
                lastMeetingsPopupTitle: "Thanks for your feedback",
                lastMeetingsSumbit: "Submit",
                criteriaTitle: (longVersion) =>
                    "How community can help you? Your request will help us to find the right people for you",
                criteriaTip:
                    "The list below will change some time after you change your request",
                members: "people",
                mapShowParticipants: "People",
                mapShowEvents: "Events",
                mapShowEventTitles: "Event titles",
                toggleActiveText: {
                    firstPart: "Notifications about events and meetings.",
                    secondPart: "Also, you can find relevant contacts on",
                    link: '"All\xa0members"\xa0page.',
                    discordSecondPart: "Join our",
                    discordLink: "Discord community",
                },
                toggleDisabledText: {
                    firstPart:
                        "Start to get new connections in the community via email",
                    or: " or ",
                },
                recommended: "Recommended contacts",
                recommendationsLoading: "Calculating the most relevant contacts for you...",
                noRecommendations: "You've seen all recommended contacts. New recommendations will appear soon",
                noRecommendationsBtn: "All members",
                moreContacts: "More contacts",
                interestedSuccessTitle: "We delivered your message",
                interestedSuccessContent: (likedName) => `Please, wait for the answer from ${likedName} to schedule a meeting`,
                notInterestedSuccessTitle: "Thanks for your feedback",
                notInterestedSuccessContent: "This contact was hidden from your recommendations",
                outOfCredits: "Out of Credits",
                bookmarked: "Added to <a href='/contacts/bookmarks'>bookmarks</a>",
                unbookmarked: "Removed from bookmarks",
                tryAgainIn: (timeLeft) => `Try again in ${timeLeft}`,
                recommendedTab: "Recommended",
                requestsTab: "Requests",
                myRequest: "My Request",
            },
            Onboarding: {
                profileFormTitle: "Participant form",
                aboutYouTitle: "About you",
                linkedInTitle: "Connect LinkedIn",
                linkedInDescription: "Specify LinkedIn profile to auto-fill your details and simplify the onboarding process",
                locationTitle: "Location",
                locationForDescription: "Knowing your location helps us connect you with people who truly matter",
                searchForTitle: "Your request",
                searchForDescription:
                    "Describe the people and expertise you are looking for: position, background, skills, personal qualities, interests. Your recommendations will be updated according to the request.",
                contactsTitle: "Contacts",
                socialNetworkTitle: "Social networks",
                yourPhotoTitle: "Your photo",
                searchForButtonText: "No specific expectations",
                searchForDefaultText: "No specific expectations",
                buddy: {
                    survey: "Great start! A couple of questions first and we'll find the best contacts in the community to match your business needs",
                    aboutYou:
                        "The more you tell the community about yourself, the more relevant connections you'll make",
                    searchFor:
                        "Help us to help you find the right connections for you and your business",
                    contacts:
                        "List your social profiles so that community members can contact you there",
                },
            },
            LastStep: {
                activeIndexText: "Last Step",
                nextButtonText: "Skip",
                stepTitle: "Confirm your email",
                resendRecoveryEmail: "Resend",
                resendSuccessText: (minutes, seconds) =>
                    `Email with confirmation has been sent successfully. You can resend again in ${minutes}:${seconds}`,
            },
            AccountDeleted: {
                activeIndexText: "Account deleted",
                nextButtonText: "Continue",
                text: (communityName) =>
                    `Your account has been deleted from ${communityName}, but you can always join community.`,
            },
            Confirmed: {
                activeIndexText: "Confirmed",
                nextButtonText: "Continue",
                stepTitle: "Your email confirmed",
                text: "Congratulations! You successfully confirmed your email. You will be redirected to your communities page or to login page in 5 seconds.",
            },
            EventDetail: {
                CreateEvent: {
                    createEventTitle: "Create event",
                    editEventTitle: "Edit event",
                    title: "Title",
                    description: "Description",
                    titleTranslations: "Title Translations",
                    descriptionTranslations: "Description Translations",
                    slug: "URL Slug",
                    slugPlaceholder: "event-url-slug",
                    slugAvailable: "Slug is available",
                    slugTaken: "Slug is already taken",
                    slugInvalidFormat: "Slug can only contain lowercase letters (a-z), digits (0-9), and hyphens (-)",
                    slugHelp: "This will be used in the event URL. Only letters, numbers, and hyphens are allowed.",
                    date: "Date",
                    startDate: "Start date",
                    startTime: "Start time",
                    endDate: "End date",
                    endTime: "End time",
                    endDateOptional: "Leave empty if same day",
                    timeZone: "Time zone",
                    locationSection: "Location",
                    addressLine: "Address line",
                    latitude: "Latitude",
                    longitude: "Longitude",
                    googleMapsLink: "Google Maps link",
                    country: "Country",
                    region: "Region/State",
                    city: "City",
                    postalCode: "Postal code",
                    locationVisibility: "Location visibility",

                    // Location visibility enum options
                    locationVisibilityFull: "Full address",
                    locationVisibilityNoAddressLine: "Without street (only postal code, city, country)",
                    locationVisibilityCountryAndCity: "Country + city",
                    locationVisibilityCityOnly: "City only",
                    locationVisibilityCountryOnly: "Country only",
                    locationVisibilityAddressOnly: "Street only",
                    locationVisibilityRegionAndCity: "Region + city",
                    locationVisibilityPostalAndCity: "Postal code + city",
                    locationVisibilityNone: "Show nothing",
                    typeAndPayment: "Type & Payment",
                    eventType: "Event type",
                    onlineMeetingLink: "Online meeting link",
                    paid: "Paid",
                    price: "Price",
                    paymentLink: "Payment link",
                    participationAndVisibility: "Participation & Visibility",
                    visibility: "Visibility",
                    linkOnly: "Link only",
                    linkOnlyHint: "The event is hidden from the feed, search, and map. People reach it via the link. Organizers and confirmed participants still see it in the list.",
                    approvalRequired: "Approve required",
                    approvalRequiredHint: "Participants will need approval to join the event",
                    organizerMessagesCustom: "Custom status set",
                    organizerMessagesCustomHint: "An empty set hides Write buttons on this event only",
                    organizerMessagesInherit: "Use community settings",
                    enableOnboarding: "Enable Onboarding",
                    enableOnboardingHint: "Enable onboarding process for participants",
                    enableLiveInteraction: "Live Interaction",
                    enableLiveInteractionHint: "Q&A and polls during the event",
                    presentAccess: "Projector access",
                    presentAccessPublic: "No login",
                    presentAccessAuthenticated: "Login required",
                    questionPremoderation: "Question premoderation",
                    questionPremoderationHint: "New questions wait for Approve before the room sees them",
                    showPostJoinMessage: "Post-join message",
                    showPostJoinMessageHint: "Show a welcome message once after a participant joins the event",
                    postJoinMessageLabel: "Message text",
                    postJoinMessageHint: "Shown once to the participant after joining the event",
                    postJoinMessageRequired: "Fill in the message text for all community languages",
                    maxParticipants: "Max participants",
                    hideParticipantsUntilDate: "Hide participants until a date",
                    hideParticipantsUntilDateHint: "Participants will not see each other until the date below. Organizers always see the full list.",
                    participantsVisibleDate: "Participants visible from (date)",
                    participantsVisibleTime: "Participants visible from (time)",
                    participantsVisibleDateRequired: "Reveal date is required",
                    participantsVisibleTimeRequired: "Reveal time is required",
                    maxPhotosAmount: "Max photos amount",
                    photoVisibility: "Photo Visibility",
                    photoVisibilityAll: "All (everyone can see)",
                    photoVisibilityOnlyAuthenticated: "Only authenticated users",
                    photoVisibilityOnlyRegistered: "Only registered on event",
                    maxPhotosForUnauthenticatedUsers: "Max photos for unauthenticated users",
                    maxPhotosForUnauthenticatedUsersHint: "If set to 0, unauthenticated users will see only the sign-in message and no photos.",
                    organizerContact: "Organizer contact",
                    create: "Create",
                    saveChanges: "Save changes",
                    saving: "Saving…",

                    // Additional translations for form sections and fields
                    basicInformation: "Basic information",
                    dateAndTime: "Date and time",
                    titlePlaceholder: "Enter event title",
                    descriptionPlaceholder: "Enter event description",
                    endTimeOptional: "End time (optional)",
                    addressLinePlaceholder: "Street and house number",
                    cityPlaceholder: "Enter city",
                    regionPlaceholder: "Enter region/state",
                    countryPlaceholder: "Enter country",
                    postalCodePlaceholder: "Enter postal code",
                    organizerContactPlaceholder: "Email or phone",

                    // Event type options
                    eventTypeOnline: "Online",
                    eventTypeOffline: "Offline",

                    // Visibility options
                    visibilityPublic: "Public",
                    visibilityPrivate: "Private",

                    // Location visibility options (legacy)
                    locationVisibilityPublic: "Public",
                    locationVisibilityPrivate: "Private",

                    extractCoordinates: "Extract coordinates",
                    coordinatesExtracted: "Coordinates extracted from link",
                    coordinateExtractionError: "Error extracting coordinates",

                    // Event responsibles section
                    eventResponsibles: "Event organizers",
                    searchParticipants: "Search participants",
                    searchParticipantsPlaceholder: "Type to search…",
                    removeConfirmTitle: "Remove this organizer?",
                    removeConfirmDescription: "They will no longer be able to manage this event.",
                    searchResults: "Search results",
                    currentResponsibles: "Current organizers",
                    noResponsiblesYet: "No organizers yet",
                    noResponsiblesDescription: "Find and add participants to manage this event",
                    add: "Add",
                    remove: "Remove",

                    // Event image section
                    eventCoverImage: "Event cover image",
                    noImageYet: "No image yet",
                    noImageDescription: "You can upload a cover image after saving the event",

                    // Error messages
                    pleaseFillRequiredFields: "Please fill in all required fields",

                    // Loading states
                    loading: "Loading...",
                    creatingEvent: "Creating event...",
                    updatingEvent: "Updating event...",

                    // Form validation
                    invalidLatitude: "Invalid latitude",
                    invalidLongitude: "Invalid longitude",
                    invalidPrice: "Invalid price",
                    invalidMaxParticipants: "Invalid number of participants",
                    invalidDate: "Invalid date",
                    invalidTime: "Invalid time",
                    endTimeBeforeStartTime: "End time must be after start time",

                    // Required field messages
                    cityRequired: "City is required",
                    countryRequired: "Country is required",

                    // Success messages
                    eventCreatedSuccessfully: "Event created successfully!",
                    eventUpdatedSuccessfully: "Event updated successfully!",
                    eventDeletedSuccessfully: "Event deleted successfully!",
                    deleteEvent: "Delete Event",
                    deleteEventConfirmation: "Are you sure you want to delete this event?",
                    deleteEventWarning: "This action cannot be undone.",
                    confirmDelete: "Yes, Delete",
                    cancelDelete: "Cancel",

                    // Event Image Upload
                    changePhoto: "Change Photo",
                    uploadPhoto: "Upload Photo",
                    uploadPhotoDescription: "Choose an image for the event",
                    selectFile: "Select File",
                    cancel: "Cancel",
                    cropImage: "Crop Image",
                    cropImageDescription: "Adjust the size and save",
                    rotate: "Rotate",
                    save: "Save",
                    back: "Back",

                    // Additional required field messages
                    titleRequired: "Title is required",
                    descriptionRequired: "Description is required",
                    dateRequired: "Date is required",
                    timeRequired: "Time is required",
                    endDateRequired: "End date is required",
                    endTimeRequired: "End time is required",
                    timeZoneRequired: "Time zone is required",
                    organizerContactRequired: "Organizer contact is required",
                    priceRequired: "Price is required and must be greater than 0 for paid events",
                    paymentLinkRequired: "Payment link is required for paid events",
                    onlineMeetingLinkRequired: "Online meeting link is required for online events",
                },
                ParticipationButton: {
                    eventHasEnded: "Event has ended",
                    loadingStatus: "Loading status...",
                    youAreGoing: "You are going",
                    cancelling: "Cancelling...",
                    cancelParticipation: "Cancel participation",
                    errorLoadingStatus: "Error loading status",
                    pending: "Pending",
                    joining: "Joining...",
                    joinAgain: "Join again",
                    askToJoin: "Ask to join",
                    startOnboarding: "Start Onboarding",
                    continueOnboarding: "Continue Onboarding",
                    completeOnboarding: "Complete Onboarding",
                    rejected: "Rejected",
                    joinOnline: "Join Online",
                    payToJoin: "Pay to Join",
                    payToRegister: "Pay to Register",
                    loginToPayAndJoin: "Login to Pay and Join",
                    paymentNote: "Payment status may take some time to update. Contact event organizers if you have questions.",
                },
                aboutEvent: "About event",
                EventDescription: {},
                EventPhotosGallery: {
                    title: "Event Photos",
                    hidden: "Hidden",
                    closePreview: "Close (Esc)",
                    previousPhoto: "Previous (←)",
                    nextPhoto: "Next (→)",
                    guestSeeAllMessage: "To see all photos from this event, please <a href=\"/login\">sign in</a> or <a href=\"/registration\">register</a>.",
                    onlyRegisteredMessage: "Sorry, only registered event participants can see photos from this event.",
                },
                dateTbc: "Date TBC",
                dayTbc: "Day TBC",
                eventDetails: "Event details",
                hostName: "Host Name",
                hostOfTheEvent: "Host of the event",
                locationTbc: "Location TBC",
                exactLocationAfterJoining: "Exact location available after joining",
                viewOnGoogleMaps: "View on Google Maps",
                joinOnline: "Join Online",
                addToCalendar: "Add to Calendar",
                dateTimeTbc: "Date & Time TBC",
                eventTitle: "Event Title",
                participants: "Participants",
                participantCount: (count) => `${count} ${count === 1 ? 'participant' : 'participants'}`,
                noConfirmedParticipants: "No confirmed participants yet.",
                participantsVisibleAfter: (dateStr) => `You will see the list of participants after ${dateStr}`,
                noParticipants: "No participants yet",
                eventResponsibles: "Organizers",
                noEventResponsibles: "No organizers assigned.",
                eventNotFound: "Event not found",
                locationAlt: "Location",
                eventAlt: "Event image",
                online: "Online",
                paid: "PAID",
                filterByStatus: "Filter by status",
                exportCSV: "Export Excel",
                notificationsTitle: "Notifications",
                liveInteraction: "Live Interaction",
                manageLive: "Manage Live",
                liveNowJoin: "Live now — Join interaction",
                liveNowSubtitle: "Q&A and polls",
                enableLiveInteraction: "Live Interaction",
                enableLiveInteractionHint: "Q&A and polls during the event",
                presentAccess: "Projector access",
                presentAccessPublic: "No login",
                presentAccessAuthenticated: "Login required",
                questionPremoderation: "Question premoderation",
                questionPremoderationHint: "New questions wait for Approve before the room sees them",
                notificationsForbiddenTitle: "Access denied",
                notificationsForbidden: "You do not have permission to send notifications for this event",
                emailNotification: "Email notification",
                telegramNotification: "Telegram notification",
                loadingEvent: "Loading event...",
                normalSearch: "Normal Search",
                smartSearch: "Smart Search",
                smartSearchSubmit: "Smart Search",
                searchPlaceholder: "Search by name or expertise",
                smartSearchPlaceholder: "Describe who you want to find",
                clearSearch: "Clear search",
                searchError: "Could not load participants",
                retry: "Retry",
                searchEmpty: "No one matched this search",
                searchResultsTitle: "Search results",
                participant: "Participant",
                // Status translations for filters
                CONFIRMED: "Confirmed",
                PENDING: "Pending",
                REJECTED: "Rejected",
                CANCELLED: "Cancelled",
                confirmAction: "Confirm",
                rejectAction: "Reject",
                writeMessage: "Write",
                localTime: "Your local time",
                editEvent: "Edit event",
                manageQuestions: "Manage Questions",
                postJoinMessage: {
                    close: "Close",
                },
                onboardingStats: {
                    title: "Onboarding Statistics",
                    loading: "Loading statistics...",
                    error: "Failed to load statistics",
                    close: "Close",
                    totalParticipants: "Total Participants",
                    completedParticipants: "Completed Participants",
                    completionRate: "Completion Rate",
                    averageCompletionTime: "Average Completion Time",
                    questionStats: "Question Statistics",
                    noData: "No data available",
                    retry: "Retry"
                },
                participantsReport: {
                    title: "Participants Report",
                    loading: "Loading participants...",
                    error: "Failed to load participants",
                    close: "Close",
                    search: "Search participants...",
                    all: "All",
                    completed: "Completed",
                    pending: "Pending",
                    name: "Name",
                    login: "Login",
                    company: "Company",
                    status: "Status",
                    answers: "Answers",
                    answersCount: "Answers Count",
                    lastAnswer: "Last Answer",
                    viewAnswers: "View Answers",
                    export: "Export CSV",
                    noData: "No participants found",
                    retry: "Retry",
                    about: "About",
                    lookingFor: "Looking For",
                    utmSource: "Source",
                    utmMedium: "Medium",
                    utmContent: "Content"
                },
                utmLinkGenerator: {
                    title: "Tracking link builder",
                    sourceLabel: "utm_source",
                    sourceHint:
                        "Traffic source: telegram, linkedin, email. For Telegram channel posts use telegram. In Mini App, telegram may be detected automatically; for channel posts include it in the URL.",
                    mediumLabel: "utm_medium",
                    mediumHint: "Placement type: channel, post, newsletter, story. Optional.",
                    contentLabel: "utm_content",
                    contentHint: "Different posts in the same channel: announce, reminder-24h. Optional.",
                    latinHint: 'Latin letters, digits and hyphens only; spaces become "-".',
                    generatedLink: "Generated link",
                    copy: "Copy",
                    copied: "Link copied",
                    close: "Close",
                    sourceRequired: "utm_source is required (e.g. telegram)",
                },
                participantAnswers: {
                    title: "Participant Answers",
                    loading: "Loading answers...",
                    error: "Failed to load answers",
                    close: "Close",
                    question: "Question",
                    answer: "Answer",
                    answeredAt: "Answered At",
                    noAnswers: "No answers found",
                    retry: "Retry",
                    participant: "Participant"
                },
            },
            EventPhotosManager: {
                title: "Manage Photos",
                backToEvent: "Back to Event",
                event: "Event",
                photosUploaded: "photos uploaded",
                slotsAvailable: "slot(s) available",
                uploadPhotos: "Upload Photos",
                uploading: "Uploading...",
                selectUpTo: "Select up to",
                photo: "photo(s)",
                maximumReached: "Maximum photos reached",
                selectAll: "Select All",
                deselectAll: "Deselect All",
                selected: "selected",
                makeVisible: "Make Visible",
                hide: "Hide",
                deleteSelected: "Delete Selected",
                noPhotos: "No photos uploaded yet",
                noPhotosDescription: "Click \"Upload Photos\" to add photos to this event",
                hidePhoto: "Hide photo",
                showPhoto: "Show photo",
                deletePhoto: "Delete photo",
                delete: "Delete",
                hidden: "Hidden",
                confirmDelete: "Are you sure you want to delete this photo?",
                confirmDeleteMultiple: "Are you sure you want to delete",
                photos: "photo(s)",
                deleteSuccess: "Photo deleted successfully",
                deleteMultipleSuccess: "photo(s) deleted successfully",
                deleteError: "Failed to delete photo",
                deleteMultipleError: "Failed to delete photos",
                uploadSuccess: "photo(s) uploaded successfully",
                uploadError: "Failed to upload photos",
                uploadLimitError: "You can only upload",
                morePhotos: "more photo(s). Maximum is",
                visibilityToggleSuccess: "Photo",
                madeVisible: "made visible",
                hiddenStatus: "hidden",
                visibilityToggleError: "Failed to toggle visibility",
                visibilityToggleMultipleSuccess: "photo(s) successfully",
                loadError: "Failed to load photos",
                eventLoadError: "Failed to load event data",
                pleaseSelectPhotos: "Please select photos to delete",
                pleaseSelectPhotosVisibility: "Please select photos to toggle visibility",
                dragDropTitle: "Drag and drop photos here",
                dragDropSubtitle: "or click the button below",
                dropHere: "Drop photos here",
                dropOnlyImages: "Please drop only image files",
                closePreview: "Close (Esc)",
                previousPhoto: "Previous (←)",
                nextPhoto: "Next (→)",
            },
            EventQuestionManager: {
                title: "Question Manager",
                backToEvent: "Back to Event",
                newQuestion: "New Question",
                questionsList: "Questions List",
                noQuestions: "No questions found",
                createFirstQuestion: "Create your first question to get started with event onboarding",
                createFirstQuestionButton: "Create First Question",
                order: "Order",
                questionText: "Question Text",
                type: "Type",
                visible: "Visible",
                actions: "Actions",
                view: "View",
                edit: "Edit",
                delete: "Delete",
                confirmDelete: "Are you sure you want to delete this question?",
                deleteSuccess: "Question deleted successfully",
                deleteError: "Failed to delete question",
                createQuestion: "Create Question",
                editQuestion: "Edit Question",
                questionTextPlaceholder: "Enter your question...",
                questionOrder: "Order",
                translationKey: "Translation Key",
                translationKeyPlaceholder: "Click 'Generate' to create a unique key...",
                isVisible: "Visible to participants",
                isRequired: "Required question",
                save: "Save",
                cancel: "Cancel",
                createSuccess: "Question created successfully",
                updateSuccess: "Question updated successfully",
                generateTranslationKey: "Generate Key",
                translationKeyGenerated: "Translation key generated",
                translationKeyHint: "💡 Auto-generated UUID for translation management. This helps organize translations by community and prevents conflicts.",
                translations: "Translations",
                englishTranslation: "English",
                russianTranslation: "Russian",
                englishPlaceholder: "Enter English translation...",
                russianPlaceholder: "Enter Russian translation...",
                translationHelp: "Enter translations for both languages. They will be saved automatically when you finish typing.",
                enterTranslationKey: "Enter a translation key above to manage translations",
                // Answer Management
                answersTab: "Answers",
                viewAnswers: "View Answers",
                noAnswers: "No answers found",
                noAnswersForQuestion: "No answers for this question yet",
                participant: "Participant",
                answer: "Answer",
                answeredAt: "Answered At",
                viewAnswer: "View Answer",
                deleteAnswer: "Delete Answer",
                confirmDeleteAnswer: "Are you sure you want to delete this answer?",
                deleteAnswerSuccess: "Answer deleted successfully",
                deleteAnswerError: "Failed to delete answer",
                answerDetails: "Answer Details",
                question: "Question",
                answerText: "Answer Text",
                answerType: "Answer Type",
                close: "Close",
                // Additional UI strings
                updateQuestionDetails: "Update question details and settings",
                addNewQuestion: "Add a new question to your event onboarding",
                manageOnboardingQuestions: "Manage onboarding questions for",
                questionsConfigured: "questions configured",
                questionConfigured: "question configured",
                clickActionsToManage: "Click actions to manage",
                viewAndManageResponses: "View and manage participant responses",
                createQuestionsFirst: "Create questions first to view participant answers",
                // Answer Options Management
                answerOptions: "Answer Options",
                addAnswerOption: "Add Answer Option",
                answerOptionText: "Answer Option Text",
                answerOptionOrder: "Order",
                answerOptionVisible: "Visible",
                answerOptionActive: "Active",
                answerOptionCategory: "Category",
                answerOptionType: "Answer Option Type",
                predefined: "Predefined",
                text: "Text",
                pleaseSpecify: "Please specify...",
                removeAnswerOption: "Remove Answer Option",
                noAnswerOptions: "No answer options",
                addFirstAnswerOption: "Add first answer option",
                addQuestionTextFirst: "Please add question text first to enable answer options",
                textQuestionNoAnswers: "Text questions do not require predefined answer options",
                answerOptionsHelp: "Add answer options for RADIO and CHECKBOX question types",
                answerOptionsWillAppear: "Answer options for this question type can be added after saving",
                manageAnswerOptions: "Manage Answer Options",
                unsavedChanges: "You have unsaved changes. Are you sure you want to close?",
                newAnswer: "New answer",
                editAnswerOption: "Edit Answer Option",
                configureAnswerOption: "Configure answer option details and translations",
                answerOptionTextRequired: "Answer text is required",
                answerOptionUpdated: "Answer option updated successfully",
                answerOptionCreated: "Answer option created successfully",
                answerOptionsUpdated: "Answer options updated successfully",
                saveError: "Failed to save question option",
                answerOptionTextPlaceholder: "Enter answer option text",
                categoryPlaceholder: "Optional category",
                saving: "Saving...",
                update: "Update",
                create: "Create",
                answerOptionGroup: "Group",
                answers: "Answers",
                noKey: "No key",
                key: "Key",
                // Breadcrumb translations
                events: "Events",
            },
            Event: {
                title: "Community",
                menuText: "Community",
            },
            Notifications: {
                title: "Notifications",
                menuText: "Notifications",
            },
            Profile: {
                title: "Profile",
                menuText: "Profile",
                editProfile: "Edit profile",
                tabMainInfo: "Main info",
                tabNotifications: "Notifications",
                tabAppearance: "Appearance",
                appearanceAuto: "Auto",
                appearanceLight: "Always light",
                appearanceDark: "Always dark",
                appearanceError: "Could not save appearance. Try again.",
                successText: "Changes saved",
                invitedBy: "Invited by ",
                createdAt: "Profile opened ",
                fillProfileWarning: "To receive more relevant contacts, please fill in ",
                privacySettingsLabel: "Privacy Settings",
                contactTypesToHideLabel: "Hide these contact types",
                privacyOptions: {
                    NONE: "Visible to everyone",
                    PRIVATE: "Hide all contacts",
                    CUSTOM: "Custom visibility",
                },
                languageSettings: {
                    title: "Language Settings",
                    description: "Choose your preferred language for this community",
                    successMessage: "Language preference updated successfully",
                    note: "This setting applies to this community only. You can have different language preferences for different communities."
                },
                moderationBanner: {
                    thankYou: "Thank you for registering!",
                    underModeration: "Your profile is under moderation. We will inform you about the review result shortly.",
                    contactModerators: "For any questions, you can contact:"
                },
                rejectionBanner: {
                    title: "Profile temporarily disabled",
                    intro: "Your profile has been temporarily disabled by a moderator and sent for additional review. This may be due to insufficient information in your profile or other moderation reasons.",
                    checklistIntro: "To speed up activation, we recommend reviewing and, if needed, completing your profile:",
                    checklistItems: [
                        "Provide your current first and last name",
                        "Fill in the \"Company, position\" field",
                        "Complete the \"About me\" section in detail: what you do, your experience, interests, and what contacts or opportunities you are looking for in the community",
                    ],
                    photoRecommendation: "We also recommend adding a profile photo (it helps build trust in the community).",
                    afterUpdate: "After you update your profile, it will be reviewed again by a moderator.",
                    contactModerators: "If you have questions, contact the moderator:",
                },
                contactTypes: {
                    EMAIL: "Email",
                    PHONE: "Phone",
                    FACEBOOK: "Facebook",
                    INSTAGRAM: "Instagram",
                    LINKEDIN: "LinkedIn",
                    VK: "VK",
                    MAX: "MAX",
                    TELEGRAM: "Telegram",
                    GITHUB: "GitHub",
                    TWITTER: "Twitter",
                    SLACK: "Slack",
                    DISCORD: "Discord",
                    CALENDLY: "Calendly",
                },
                form: {
                    title: "Profile",
                    firstName: {
                        label: "First name",
                        placeholder: "Alex",
                    },
                    lastName: {
                        label: "Last name",
                        placeholder: "Morgan",
                    },
                    phone: {
                        label: "Phone",
                        placeholder: "+79991234567",
                    },
                    company: {
                        label: "Company, position",
                        placeholder: "Acme, designer",
                    },
                    about: {
                        label: "About me",
                        placeholder:
                            "Tell us about yourself, your skills and interests",
                    },
                    lookingFor: {
                        label: "Looking for",
                        textareaLabel: "Enter your request",
                        placeholder:
                            "Seeking an individual with expertise in...",
                        examples: [
                            "Employment in the field of",
                            "Business partners to develop",
                            "Like-minded individuals passionate about"
                        ],
                        options: [
                            "I'm looking for...",
                            "I can help with...",
                            "I need help with...",
                            "I'm looking to meet new people ",
                            "Open to any suggestions ",
                            "Other"
                        ],
                    },
                    location: {
                        label: "City",
                        placeholder: "Search for city",
                        question: "Share my location with others",
                        tip: "Other participants will see your city. You\u00a0can always change this setting in Profile",
                        autodetectError: "Failed to detect location. Please, enter manually.",
                        autodetectButtonLabel: "Detect",
                    },
                    goal: {
                        label: "What is your goal in this community?",
                    },
                    contact: {
                        placeholder: "Link to your profile, https://...",
                    },
                    email: {
                        label: "Email",
                        placeholder: "example@mail.com",
                    },
                    telegram: {
                        label: "Telegram",
                        placeholder: "@username",
                    },
                    instagram: {
                        label: "Instagram",
                        placeholder: "https://instagram.com/username",
                    },
                    linkedin: {
                        label: "LinkedIn",
                        placeholder: "https://www.linkedin.com/in/your-username",
                        tip: "Leave the field blank if you wish to skip this step",
                        profileUrl: "<a href='https://www.linkedin.com/in/edit/contact-info/' target='_blank'>Find your Linkedin profile url</a>",
                        errorTip: "The link should start with 'https://www.linkedin.com/in/' followed by your username",
                        loadingTitle: "Loading LinkedIn profile",
                        errorTitle: "Failed to load LinkedIn profile",
                        errorRetryButton: "Try again",
                        errorManuallyButton: "Fill manually"
                    },
                    facebook: {
                        label: "Facebook",
                        placeholder: "https://facebook.com/username",
                    },
                    github: {
                        label: "GitHub",
                        placeholder: "https://github.com/username",
                    },
                    twitter: {
                        label: "Twitter",
                        placeholder: "https://x.com/username",
                    },
                    slack: {
                        label: "Slack",
                        placeholder: "",
                    },
                    vk: {
                        label: "VK",
                        placeholder: "https://vk.com/username",
                    },
                    max: {
                        label: "MAX",
                        placeholder: "https://max.ru/username",
                    },
                    calendly: {
                        label: "Calendly",
                        placeholder: "https://calendly.com/username",
                    },
                    socialTip2: (num, socials) =>
                        `Please, specify at least ${num} of ${socials.join(
                            " or "
                        )} links`,
                    unsavedChanges: "You have unsaved changes",
                    additionalSocialTip: "Additional (optional)",
                    connectBot: "Connect bot",
                    botConnected: "Bot connected",
                    confirmBot: "Please confirm the bot",
                    telegramTip: "If you want to receive notifications on Telegram, please connect the bot.",
                    linkedInConnection: "LinkedIn Connection",
                    linkedInConnectionHeader: "You are about to be redirected to the LinkedIn community page. Once there, please click on the 'Connect' button to\u00a0complete\u00a0the\u00a0process",
                    linkedInConnectionNote: "Note that the 'Connect' button can be found in two different locations (see images above). If you have completed the connection previously or the 'Connect' button could not be found, just skip this step.",
                    linkedInConnectionBtn: "Proceed to LinkedIn",
                    avatar: "Change photo",
                    removeAvatar: "Remove photo",
                    removeAvatarConfirmation: "Remove?",
                    save: "Save",
                    updateAvatarModal: {
                        titleFileUpload: "Upload new photo",
                        descriptionFileUpload:
                            "A picture helps people to recognise you and lets you know when you’re signed in to your account. We support JPG and PNG files.",
                        selectFile: "Upload photo",
                        cancel: "Cancel",
                        error: "Uploading error. Try to use another photo",
                        titleCropper: "Change profile photo",
                        descriptionCropper:
                            "Please select an area for your profile picture.You can rotate the image to position it properly.",
                        save: "Save and continue",
                        back: "Back",
                        rotate: "Rotate",
                    },
                    deleteAvatarModal: {
                        title: "Warning",
                        description:
                            "Are you sure you want to delete this photo?",
                        delete: "Delete",
                        cancel: "Cancel",
                    },
                    deleteModal: {
                        title: "Delete account?",
                        description:
                            "This action is irreversible. Confirm by entering password",
                        delete: "Delete account",
                        cancel: "Cancel",
                    },
                    error: {
                        avatar: "Uploading error. Try to use another photo",
                        exists: (field) =>
                            `The ${field} section requires an answer`,
                        minMaxChars: (field, min, max) =>
                            `${field} might be between ${min} and ${max} chars`,
                        maxChars: (max) => `Should be less than ${max} chars`,
                        emailNotExists:
                            "Unfortunately, something went wrong. Please reload your page",
                        contactNotConnectedTitle: (contact) =>
                            `${contact} is not connected`,
                        contactNotConnectedContent: (contact) =>
                            `Go to Profile and connect ${contact}`,
                        socialNetworkRequired: (socialNetwork) =>
                            `Required to specify ${socialNetwork} profile link`,
                        socialNetworkFormat: (socialNetwork) =>
                            `Invalid format of ${socialNetwork} profile link`,
                        socialNetworkExists: (socialNetwork) =>
                            `This ${socialNetwork} contact already exists`,
                        requiredContacts: (
                            requiredContactsMin,
                            requiredContacts
                        ) =>
                            `Required to specify at least ${requiredContactsMin} of ${requiredContacts.join(
                                " or "
                            )} links`,
                        roleInCommunity: "Don't forget to complete all required fields *",
                    },
                    hideSocialSettings: "Hide social networks settings",
                    showSocialSettings: "Social networks settings",
                    hideNotificationSettings: "Hide notification settings",
                    showNotificationSettings: "Notification settings",
                    notificationTip: "Choose your notification channels",
                    chatNotifications: {
                        title: "Unread chat reminders",
                        tip: "Unread chat reminders",
                        hint: "How often to remind you about chats you have not read.",
                        email: "Email",
                        telegram: "Telegram",
                        newMessages: "New messages",
                        pushScope: "Push",
                        digestMode: "Unread reminders",
                        everyMessage: "Every message",
                        introOnly: "Intros only",
                        instant: "Instant",
                        daily: "1 time per day",
                        weekly: "1 time per week",
                        periodic: "Every 3 hours",
                        off: "Off"
                    },
                    matchmakingTitle: "1-on-1 Introductions",
                    matchmakingLabel: "Enable 1-on-1 Introductions",
                    matchmakingHint: "When off, you won't receive 1-on-1 introductions or notifications on your selected channels."
                }
            },
            Questions: {
                nocontent:
                    "Please, ask your community manager to provide an invitation link",
                nocontentBtn: "Reload",
                back: "Back",
                next: "Next",
                close: "Close",
                skipToProfile: "Skip questions — go to profile (events only)",
                skipToProfileConfirm: "If you skip onboarding, you will not be able to participate in networking or make new connections. You will only have access to events and FAQ. Continue?",
            },
            Contacts: {
                title: "Matches",
                menuText: "My matches",
            },
            EventOnlyOnboardingModal: {
                message: "To view contacts, get recommendations, participate in networking and make new friends and connections you need to complete onboarding. Until then you have access to:",
                eventsLink: "Events",
                faqLink: "FAQ",
                profileLink: "Profile",
                button: "Go to questions",
            },
            AdminNotifications: {
                messages: {
                    general: {
                        subject: (communityTitle) => `New notification from ${communityTitle}`,
                        signature: (communityTitle) => `<b>Your community manager,<br/>${communityTitle}</b>`
                    },
                    recommend: {
                        subject: (communityTitle) => `Meet interesting members in the ${communityTitle}`,
                        text: (communityUrl) => `Today, we have decided to dedicate the newsletter to: <b>TOPIC</b>.<br/>Let's connect, unite, and share experiences.<br/><br/>Here are some relevant contacts with whom you might want to engage in conversations about this topic:`,
                        signature: (communityTitle, communityUrl, membersCount) => `Additionally, on our community platform <a href="${communityUrl}" target="_blank">${communityUrl}</a>, there are already <b>${membersCount}</b> participants. You can customize your preferences to discover even more suitable matches based on your personality and requests by connecting with the top three most relevant members on the main page.<br/><br/><b>Your community manager,<br/>${communityTitle}</b>`
                    },
                    individual: {
                        subject: (communityTitle) => `New notification from ${communityTitle}`,
                        title: () => `Hello, `,
                        signature: (communityTitle) => `<b>Your community manager,<br/>${communityTitle}</b>`
                    }
                }
            },
            Chats: {
                title: "Chats",
                menuText: "Chats",
                searchPlaceholder: "Search",
                noSearchResults: "No chats found",
                newChat: "New chat",
                createChat: "Create chat",
                noChatsYet: "No chats yet",
                emptyHint: "Request an intro from a participant profile — the conversation will appear here after approval.",
                createFirstChat: "Create your first chat",
                selectChat: "Select a chat to start chatting",
                selectChatDescription: "Select a chat from the sidebar to view messages",
                loadMore: "Load more",
                limitedConnectivity: "Limited connectivity",
                noMessagesYet: "No messages yet",
                startConversation: "Start the conversation by sending the first message",
                typePlaceholder: "Type a message...",
                peerDeletedBanner: "This participant was deleted. You can no longer send them messages.",
                startChat: "Start chat",
                startChatWith: (name) => `Start chat with ${name}`,
                requestIntro: "Request intro",
                openChat: "Open chat",
                requestSent: "Request sent",
                requestSentHint: "A moderator will review it soon.",
                alreadyRequested: "Intro already requested",
                alreadyRequestedHint: "A request for this pair is already waiting for review.",
                muteForever: "Mute notifications",
                unmuteNotifications: "Enable notifications",
                hideChat: "Hide",
                hideConfirmTitle: "Hide this chat?",
                hideConfirm: "The history will be removed only for you.",
                leaveIntro: "Leave intro",
                leaveIntroTitle: "Leave this intro?",
                leaveIntroConfirm: "You will no longer see this chat.",
                leftIntro: (name) => `${name} left the intro`,
                block: "Block",
                back: "Back",
                close: "Close",
                andYou: "and you",
                connectionTitle: (a, b) => `Connection: ${a} & ${b}`,
                actions: "Actions",
                copy: "Copy",
                reply: "Reply",
                edit: "Edit",
                edited: "edited",
                originalDeleted: "Original message deleted",
                deleteMessage: "Delete",
                deleteConfirmTitle: "Delete this message?",
                cancel: "Cancel",
                messageDeleted: "Message deleted",
                today: "Today",
                yesterday: "Yesterday",
                pin: "Pin",
                unpin: "Unpin",
                pinned: "Pinned",
                sending: "Sending",
                sent: "Sent",
                read: "Read",
                reactions: "Reactions",
                insertEmoji: "Insert emoji",
                moreReactions: "More reactions",
                emojiSmileys: "Smileys",
                emojiGestures: "Gestures",
                emojiHearts: "Hearts",
                emojiNature: "Nature",
                emojiObjects: "Objects",
                member: "Member",
                personal: "Personal",
                personalChats: "Personal",
                intro: "Intro",
                all: "All",
                write: "Write",
                messagePlaceholder: "Message",
                isTyping: (name) => `${name} is typing...`
            },
            ManageChats: {
                menuText: "Intro queue",
                queueTitle: "Intro queue",
                conversations: "Conversations",
                settings: "Settings",
                bulkApprove: "Approve all",
                showArchived: "Show archived",
                archive: "Archive",
                unarchive: "Unarchive",
                archivedBadge: "Archived",
                cooldownDays: "Cooldown days",
                organizerMessages: "Organizer messages",
                participantWritesOrganizer: "Participant writes organizer",
                organizerWritesParticipant: "Organizer writes participant",
                approve: "Approve",
                reject: "Reject",
                rejectComment: "Rejection comment",
                queueEmpty: "No pending intros. Connect shows up here only if Chat settings have REQUEST enabled and approval is MODERATOR (not AUTO). The default template is the intro text after approve, not this list.",
                queueEmptyArchived: "No archived intros.",
                requesterMessagePlaceholder: "User message",
                icebreakerPlaceholder: "Icebreaker",
                translateIcebreaker: "Translate",
                translatingIcebreaker: "Translating…",
                introLangBadge: "Intro {lang}",
                previewIntro: "Preview",
                previewingIntro: "Generating preview…",
                previewIntroError: "Could not generate preview",
                search: "Search by name or email",
                previous: "Previous",
                next: "Next",
                pageOf: "Page {current} of {total}",
                clearFilter: "Clear",
                scenarios: "Scenarios",
                templates: "Templates",
                bot: "Bot",
                notifications: "Notifications",
                digestDaily: "1 time per day",
                digestWeekly: "1 time per week",
                botPhoto: "photo",
                uploadBotPhoto: "Upload photo",
                cropBotPhoto: "Crop photo",
                cropBotPhotoHint: "Choose the area for the bot photo. You can rotate the image.",
                changePhoto: "Change",
                uploadPhoto: "Upload",
                chooseBotPhoto: "Choose an image for the bot photo",
                selectFile: "Select file",
                cancel: "Cancel",
                rotate: "Rotate",
                savePhoto: "Save",
                back: "Back",
                anyRatio: "Any ratio",
                squareRatio: "1:1 square",
                firstName: "Name",
                lastName: "Last name",
                enabled: "Enabled",
                enabledHint: "If off, a moderator writes the intro.",
                saveBot: "Save bot",
                botCardHint: "Participants see this name and photo in intro chats.",
                firstNameRequired: "Enter a name",
                lastNameRequired: "Enter a last name",
                templatesEmpty: "There are no intro templates yet. Create one to set the bot's first message.",
                addTemplate: "Create template",
                templateHint: "This text is the bot's first message in an intro chat. Click a tag to insert it.",
                introTemplates: "Intro message",
                acceptedTemplates: "Accepted notification",
                rejectedTemplates: "Rejected notification",
                acceptedHint: "Email, Telegram, in-app and web push when a moderator accepts a request. Subject is used for email.",
                rejectedHint: "Email, Telegram, in-app and web push when a moderator rejects a request. Subject is used for email.",
                acceptedEmpty: "No accepted templates yet. Create one to notify the requester.",
                rejectedEmpty: "No rejection templates yet. Create one to notify the requester.",
                templateSubject: "Email subject",
                templateSubjectPlaceholder: "Email subject",
                saveTemplate: "Save",
                saved: "Changes saved",
                saveError: "Failed to save",
                previewTemplate: "Preview",
                previewing: "Generating preview…",
                templateBody: "Text",
                tagGroupAlways: "Always filled",
                tagGroupOptional: "May be empty — put these on their own line",
                previewFor: "Generated for",
                previewAnd: "and",
                previewAiUsed: "AI used",
                aiTitle: "AI for intro templates",
                aiHint: "Fills recommendations, shared interests, and an icebreaker when the matching pair has no ready text.",
                aiEnabled: "Enabled",
                aiProvider: "Provider",
                aiModel: "Model",
                aiTemperature: "Temperature",
                aiMaxTokens: "Max tokens",
                saveAi: "Save AI settings",
                help: {
                    exampleLabel: "Example",
                    overview: {
                        title: "Chats for managers",
                        description: "Moderate intro requests and configure how the community opens conversations. Members do not message each other directly: an intro request is created first, and a chat opens only after approval (by you or automatically).",
                        example: "Anna taps Request intro on Boris's profile. If REQUEST is MODERATOR_BOT, the card appears in the queue. Approve opens a chat and the bot posts the first message. In MODERATOR you join as the third person and write the intro.",
                        tip: "Start with the intro queue, then check scenarios. Templates, bot, and notifications matter once the queue is clear.",
                        sections: [
                            {
                                title: "Intro queue",
                                summary: "Incoming requests waiting for your decision.",
                                bullets: [
                                    "Approve opens a chat and sends the ACCEPTED notification.",
                                    "Reject does not open a chat, sends REJECTED, and puts the pair on cooldown."
                                ]
                            },
                            {
                                title: "Conversations",
                                summary: "Chats that are already open.",
                                bullets: [
                                    "Lock stops members from sending messages.",
                                    "Delete removes the conversation from lists."
                                ]
                            },
                            {
                                title: "Chat settings",
                                summary: "Scenarios, templates, the bot profile, and your queue notifications.",
                                bullets: [
                                    "Scenarios decide which intros can happen and whether they need review.",
                                    "Templates are the bot's first message and the accept/reject emails."
                                ]
                            }
                        ]
                    },
                    queueSection: {
                        title: "Intro queue",
                        description: "Requests with status PENDING. There is no chat yet. Each card is a pair, a scenario (REQUEST, MATCH, or EVENT), and a reason.",
                        example: "Anna · Boris · REQUEST · profile. You read the AI draft, click Approve. In MODERATOR_BOT the chat opens with the bot's first message; in MODERATOR you join as the third person.",
                        tip: "Keys: j / k move to the next or previous card, a approves, r rejects.",
                        sections: [
                            {
                                title: "Where requests come from",
                                summary: "All three scenarios share this queue when approval is MODERATOR or MODERATOR_BOT.",
                                bullets: [
                                    "REQUEST — a member tapped Request intro on a profile.",
                                    "MATCH — matching created a pair.",
                                    "EVENT — both confirmed the same event."
                                ]
                            },
                            {
                                title: "What happens after you decide",
                                summary: "Approve opens a DIRECT chat. Reject starts a cooldown (usually 7 days) before that pair can request again.",
                                bullets: [
                                    "AUTO in scenario settings skips the queue entirely."
                                ]
                            }
                        ]
                    },
                    conversationsSection: {
                        title: "Conversations",
                        description: "Every community chat that is already open. Search by name, lock a thread, or delete it.",
                        example: "A heated thread after an intro. Lock — nobody can send. Unlock — sending works again. Delete — the chat disappears for everyone.",
                        tip: "A LOCKED chat cannot be re-opened via Request intro: the system sees an existing closed conversation.",
                        sections: [
                            {
                                title: "Statuses",
                                summary: "ACTIVE is a normal chat. LOCKED is read-only. DELETED is hidden and does not appear here.",
                                bullets: [
                                    "blocked next to the status means one member blocked the other."
                                ]
                            }
                        ]
                    },
                    settingsSection: {
                        title: "Chat settings",
                        description: "Four tabs: scenarios (when intros are created and whether they need review), templates (copy), bot (name and photo in chat), and manager notifications.",
                        example: "MATCH on AUTO — after a matching round, chats open by themselves. REQUEST stays MODERATOR_BOT so profile requests land in the queue and the bot writes the intro.",
                        tip: "If the bot is off, AUTO and MODERATOR_BOT cannot run: nobody can post the first message. The request falls back to the MODERATOR queue.",
                        sections: [
                            {
                                title: "Setup order",
                                summary: "Scenarios first, then the bot, then templates, then notifications.",
                                bullets: [
                                    "A disabled scenario hides intro actions for members.",
                                    "Templates fill names, profile links, and matching tags."
                                ]
                            }
                        ]
                    },
                    approveAll: {
                        title: "Approve all",
                        description: "Approves every PENDING request currently listed. Each one opens a chat and sends ACCEPTED.",
                        example: "After a matching round the queue has 12 MATCH cards. Approve all opens 12 chats at once.",
                        tip: "This cannot be undone. If some pairs look wrong, approve them one by one."
                    },
                    rowScenario: {
                        title: "Request scenario",
                        description: "Why this request exists: REQUEST (profile button), MATCH (matching pair), EVENT (shared event).",
                        example: "Anna · Boris · EVENT · Demo Day — both confirmed Demo Day, and EVENT is MODERATOR.",
                        tip: "The scenario is fixed on the request. Changing AUTO/MODERATOR in settings only affects new requests."
                    },
                    rowReason: {
                        title: "Reason",
                        description: "Short context for the request. MATCH is usually “match”, EVENT is the event title, REQUEST is where they clicked. It can fill the {reason} tag in templates.",
                        example: "shared event or Demo Day 12 May.",
                        tip: "An empty reason is fine — not every scenario has a human-readable prompt."
                    },
                    requesterMessage: {
                        title: "User message",
                        description: "The note the requester wrote. Edit it before approve — the INTRO template uses the edited text as {requestMessageA}.",
                        example: "The note is “hi wanna connect”. You change it to “Hi, I’d like to connect” and click Approve.",
                        tip: "The edit is saved only when you approve. Reject leaves the original note."
                    },
                    icebreaker: {
                        title: "Icebreaker",
                        description: "Opening question for the pair. It fills {icebreaker} in the INTRO template. For multilingual communities, edit each language. Translate fills empty languages from the one you wrote. On approve, the version matching the intro language is posted.",
                        example: "You rewrite the English question, click Translate, then Approve. If the intro language is English, the chat gets the English wording.",
                        tip: "If the two people have different languages, the community default language is used."
                    },
                    introLang: {
                        title: "Intro language",
                        description: "The INTRO template and icebreaker language that will be posted for this pair. Same supported language for both people uses that language; otherwise the community default. Editing the other language box does not change this badge.",
                        example: "Both prefer Russian in a bilingual community — badge “Intro RU”, and the Russian icebreaker is posted.",
                        tip: "The badge is computed from the pair’s languages, not from which box you are editing."
                    },
                    previewIntro: {
                        title: "Preview",
                        description: "Shows the bot’s first message for this pair: the INTRO template with names, reason, and your unsaved user-message and icebreaker edits. Nothing is saved until you Approve.",
                        example: "You change the icebreaker and user message, click Preview, and the modal shows the HTML as it will appear in chat.",
                        tip: "The italic AI draft on the card can be stale. Preview is the accurate view of the current edits."
                    },
                    aiSuggestion: {
                        title: "AI suggestion",
                        description: "A short snippet assembled for the pair: shared interests or a recommendation when there is no icebreaker. It is a hint for you, not the message that will be posted.",
                        example: "Both write Python and are looking for a co-founder. You decide whether that is enough to approve.",
                        tip: "If the line is missing, AI could not fill it or is disabled. You can still approve or reject."
                    },
                    aiDraft: {
                        title: "Intro draft",
                        description: "Preview of the bot's first message for this pair: the INTRO template with names and tags filled. After approve, a similar text is posted in the chat.",
                        example: "Anna, meet Boris — you both went to Demo Day. Shared interest: climate tech.",
                        tip: "To change the tone for everyone, edit the INTRO template under Templates, not a single card."
                    },
                    approve: {
                        title: "Approve",
                        description: "Opens a chat for the pair, posts the bot's first message (if the bot is on), and sends the requester the ACCEPTED notification (email, Telegram, in-app, web push).",
                        example: "Approve on Anna · Boris. Both see a new chat with the bot's intro.",
                        tip: "If this pair already has a chat, the request is still marked approved and a second chat is not created."
                    },
                    reject: {
                        title: "Reject",
                        description: "No chat is opened. The requester gets REJECTED. The pair is on cooldown (default 7 days) before they can request again. You are asked for a comment; it fills {comment} in the template.",
                        example: "You reject and type Already met offline. Anna gets an email with that comment.",
                        tip: "Cooldown is per pair, not per person. Either of them can still request intros with other members."
                    },
                    shortcuts: {
                        title: "Queue shortcuts",
                        description: "When focus is not in an input: j next card, k previous card, a approve the selected card, r reject it. The selected card has a ring.",
                        example: "Open the queue, press j twice, then a — the third request is approved without the mouse.",
                        tip: "Shortcuts are ignored while the cursor is in an input or textarea, so typing a reject comment cannot approve by accident."
                    },
                    search: {
                        title: "Search conversations",
                        description: "Filters the list by chat title and member display names. Case does not matter.",
                        example: "Type anna — only chats whose names include Anna remain.",
                        tip: "Search runs on the list already loaded, not a new server query."
                    },
                    conversationStatus: {
                        title: "Conversation status",
                        description: "ACTIVE — members can send. LOCKED — sending is blocked, history stays. blocked may appear if one member blocked the other.",
                        example: "Anna · Boris · LOCKED · blocked — a moderator locked the chat and a block is in place.",
                        tip: "DELETED conversations do not show in this list."
                    },
                    lock: {
                        title: "Lock and Unlock",
                        description: "Lock forbids new messages. Unlock sets status back to ACTIVE. Members see a frozen chat; history is kept.",
                        example: "A tone complaint. Lock while you look, then Unlock if you decide not to delete.",
                        tip: "While LOCKED, Request intro is unavailable for this pair: the closed conversation still exists."
                    },
                    deleteConversation: {
                        title: "Delete conversation",
                        description: "Marks the chat deleted. It disappears from member lists and from this table. There is no restore in the UI.",
                        example: "A spam chat after a bad intro. Delete — neither member sees it anymore.",
                        tip: "If you only need to stop sending, use Lock. Delete when the chat should not exist."
                    },
                    scenariosTab: {
                        title: "Scenarios",
                        description: "Three ways to create an intro. The switch is whether that kind of request can be created. AUTO, MODERATOR, or MODERATOR_BOT is whether the chat opens immediately, waits in the queue with your intro, or waits in the queue with a bot intro.",
                        example: "REQUEST on + MODERATOR_BOT, MATCH on + AUTO, EVENT off. Members request by hand, matching opens chats alone, events create no intros.",
                        tip: "AUTO and MODERATOR_BOT require an enabled bot. Otherwise the request is not created — nobody can post the first message.",
                        sections: [
                            {
                                title: "REQUEST",
                                summary: "A member taps Request intro on someone else's profile.",
                                bullets: [
                                    "The usual manual path.",
                                    "Keep MODERATOR if you want to filter random requests."
                                ]
                            },
                            {
                                title: "MATCH",
                                summary: "A matching round created a pair — the system queues or opens an intro.",
                                bullets: [
                                    "AUTO is convenient if you trust the matching threshold.",
                                    "MODERATOR if you want to glance at pairs and write the intro yourself.",
                                    "MODERATOR_BOT if you want to glance at pairs and let the bot write the intro."
                                ]
                            },
                            {
                                title: "EVENT",
                                summary: "Both confirmed the same event — an intro is created with every other confirmed attendee.",
                                bullets: [
                                    "A large event fills the queue fast — prefer AUTO or turn the scenario off.",
                                    "The card reason is the event title."
                                ]
                            }
                        ]
                    },
                    scenarioEnabled: {
                        title: "Scenario enabled",
                        description: "A disabled scenario creates no requests. Request intro is unavailable for REQUEST. MATCH and EVENT also stop creating intros.",
                        example: "Turn EVENT off before a 400-person conference so the queue does not explode.",
                        tip: "Disabling does not touch chats that are already open or cards already in the queue."
                    },
                    scenarioApproval: {
                        title: "AUTO, MODERATOR, or MODERATOR_BOT",
                        description: "AUTO opens the chat immediately, skips the queue, and the bot writes the intro. MODERATOR parks the request until someone Approves or Rejects; on approve you join as the third person and write the intro. MODERATOR_BOT also uses the queue, but after approve the bot writes the intro and you stay out of the chat.",
                        example: "MATCH = AUTO: after Find matches, pairs get chats on their own. REQUEST = MODERATOR_BOT: profile requests pile up in the queue, and the bot writes the intro.",
                        tip: "The mode applies to new requests. Cards already in the queue stay until you handle them."
                    },
                    templatesTab: {
                        title: "Templates",
                        description: "Three kinds of copy. INTRO is the bot's first chat message. ACCEPTED and REJECTED notify the requester (email, Telegram, in-app, web push). Subject is used only for ACCEPTED and REJECTED email.",
                        example: "INTRO: {firstNameA}, meet {firstNameB}. ACCEPTED subject: Your request was approved. REJECTED: We cannot intro you to {firstNameB} yet.",
                        tip: "Curly-brace tags are filled at send time. Optional tags on their own line disappear when empty.",
                        sections: [
                            {
                                title: "INTRO",
                                summary: "Posted by the bot as the first message when the chat opens.",
                                bullets: [
                                    "Both members see it in the chat.",
                                    "This is where {recommendationA}, {commonInterests}, and {icebreaker} belong."
                                ]
                            },
                            {
                                title: "ACCEPTED and REJECTED",
                                summary: "Sent only to the requester after your decision.",
                                bullets: [
                                    "Subject is for email.",
                                    "{comment} is the text you type in the reject prompt."
                                ]
                            },
                            {
                                title: "AI",
                                summary: "The card at the top fills empty matching tags when the pair has no stored text.",
                                bullets: [
                                    "With AI off, those tags stay empty and optional lines are dropped."
                                ]
                            }
                        ]
                    },
                    aiEnabled: {
                        title: "AI for intro templates",
                        description: "When on, a model fills recommendation, shared interests, and icebreaker if the matching pair has no stored text. That text is substituted into INTRO tags and shown in the queue as a hint.",
                        example: "A pair with no saved interests. AI writes an icebreaker about the same city — {icebreaker} in the template is filled.",
                        tip: "Turn it off if you do not want model calls. Templates still work with profile tags."
                    },
                    aiProvider: {
                        title: "AI provider",
                        description: "Which connected provider to call. The list comes from the server. Changing provider fills its default model.",
                        example: "Pick OpenAI — the model field becomes gpt-4o-mini until you override it.",
                        tip: "The provider must be configured on the server. An empty list means AI is not available in this environment."
                    },
                    aiModel: {
                        title: "Model",
                        description: "Model name for the selected provider. Keep the default or type another name the proxy accepts.",
                        example: "gpt-4o-mini for short icebreakers; a larger model if recommendations feel generic.",
                        tip: "A bad model name only breaks AI tag filling, not intro creation."
                    },
                    aiTemperature: {
                        title: "Temperature",
                        description: "Randomness from 0 to 2. Lower is shorter and more predictable. Higher is more varied and more likely to drift from the profile.",
                        example: "0.3 for business intros. 0.8 if icebreakers feel canned.",
                        tip: "For template substitution, 0.2–0.5 is usually enough."
                    },
                    aiMaxTokens: {
                        title: "Max tokens",
                        description: "Cap on the model reply (50–2000). This is not your template length — it is how much text AI may generate for tags.",
                        example: "400 covers a few sentences of recommendation and icebreaker. 100 is one short line.",
                        tip: "A very high cap costs more and is unused: only tagged text reaches the chat."
                    },
                    templateIntro: {
                        title: "Intro message",
                        description: "The first chat message after approve or AUTO. AUTO and MODERATOR_BOT post it as the bot; MODERATOR posts it as you. Both members see it. Create one version per community language.",
                        example: "Hi {firstNameA} and {firstNameB}! You are both in {communityName}. {icebreaker}",
                        tip: "Put optional tags on their own line — an empty value drops the whole line instead of leaving {icebreaker}."
                    },
                    templateAccepted: {
                        title: "Accepted notification",
                        description: "Email, Telegram, in-app, and web push to the requester after you click Approve. Subject is for email. This text is not posted in the chat — INTRO is.",
                        example: "Subject: You were introduced to {firstNameB}. Body: Open Chats — the thread is waiting.",
                        tip: "Keep it short: this is the “you can write now” mail, not the introduction itself."
                    },
                    templateRejected: {
                        title: "Rejected notification",
                        description: "Message to the requester when the request is rejected. {comment} is the reject-prompt text. No chat is created.",
                        example: "We cannot intro you to {firstNameB} yet. {comment} Try again later or request someone else.",
                        tip: "Without a REJECTED template the requester may not understand why no chat appeared."
                    },
                    templateLanguage: {
                        title: "Template language",
                        description: "Language code for this variant (EN, RU, …). The member's language is preferred, then a fallback. Options are the community languages.",
                        example: "Two INTRO rows: RU and EN. A member with RU in the profile gets the Russian first message.",
                        tip: "Avoid two templates of the same kind for the same language — it is unclear which one is used."
                    },
                    templateSubject: {
                        title: "Email subject",
                        description: "Email subject for ACCEPTED and REJECTED. Not shown in Telegram, in-app, or web push. INTRO has no subject — the bot posts only the body in chat.",
                        example: "{communityName}: your intro request was approved",
                        tip: "Tags work in the subject the same way as in the body."
                    },
                    templateBody: {
                        title: "Template text",
                        description: "Message body. Click a tag below to insert a placeholder. At send time, tags are replaced with the pair's data.",
                        example: "{firstNameA}, meet {firstNameB} from {companyB}. {commonInterests}",
                        tip: "Save, then Preview — you will see substitutions instead of raw {tags}."
                    },
                    tagsAlways: {
                        title: "Tags that are always filled",
                        description: "Names, profile URLs, community name, manager first name. Safe on any line — they are not empty when profile data exists.",
                        example: "{firstNameA} is the requester or first in the pair, {firstNameB} the other. {profileUrlA} links to the profile.",
                        tip: "ACCEPTED/REJECTED have a shorter set: no recommendations or icebreaker, but they include {comment} and {profileCardB} — B's avatar and about preview."
                    },
                    tagsOptional: {
                        title: "Optional tags",
                        description: "Recommendations, interests, icebreaker, companies, reason. They may be empty. Put such a tag on its own line: if the value is missing, the whole line is hidden.",
                        example: "A line with only {icebreaker}. No AI text — members see neither a blank line nor {icebreaker}.",
                        tip: "Do not mix an optional tag with normal words on the same line: an empty value drops the neighboring text too."
                    },
                    templatePreview: {
                        title: "Preview",
                        description: "Renders the template for two sample community members: fills tags and may call AI. Nothing is saved or sent.",
                        example: "Preview INTRO → Generated for Anna and Boris · OpenAI / gpt-4o-mini · AI used, plus the HTML body.",
                        tip: "With fewer than two members, preview may reuse one person or a placeholder — that is enough to check layout."
                    },
                    botTab: {
                        title: "Community bot",
                        description: "Name and photo members see on the first intro message. If the bot is off, AUTO and MODERATOR_BOT cannot run, and in MODERATOR a moderator is treated as the introducer.",
                        example: "Name Joinee Bot, square community logo. The first chat message comes from that profile.",
                        tip: "Turn the bot on before you set scenarios to AUTO or MODERATOR_BOT."
                    },
                    botPhoto: {
                        title: "Bot photo",
                        description: "Circle avatar shown next to the intro in the chat list. Upload an image — it is cropped to a circle in chat.",
                        example: "Community logo on a light background — easy to recognize in the chat list.",
                        tip: "Without a photo a default placeholder is shown. Intros still work."
                    },
                    botName: {
                        title: "Bot name",
                        description: "Name of the intro sender. Members see it on the message header.",
                        example: "Maria from Community — the chat shows Maria from Community.",
                        tip: "This is not a live manager account. Personal replies come from your own profile if you join the chat."
                    },
                    botEnabled: {
                        title: "Bot enabled",
                        description: "On — the bot posts INTRO and AUTO and MODERATOR_BOT can run. Off — those requests are not created (nobody can post the first message); MODERATOR requests can still be approved.",
                        example: "Turn the bot off while you rewrite templates. MATCH+AUTO stops creating intros until you turn it back on.",
                        tip: "Check this switch if the queue is empty right after matching ran."
                    },
                    notificationsTab: {
                        title: "Manager notifications",
                        description: "How you are told about new queue requests. This is not member notification settings (those live on the profile). INSTANT / DIGEST / OFF plus Email and Telegram channels.",
                        example: "DIGEST + Telegram, once a day: you get 8 intro requests are waiting, not a ping per card.",
                        tip: "Telegram only works if your participant has Telegram linked and the channel is allowed.",
                        sections: [
                            {
                                title: "Why this is separate",
                                summary: "Members get ACCEPTED/REJECTED and unread reminders. This tab is only the manager and the queue.",
                                bullets: [
                                    "INSTANT — as soon as a PENDING request appears.",
                                    "DIGEST — a count of how many are waiting, once a day or week.",
                                    "OFF — admin badge only."
                                ]
                            }
                        ]
                    },
                    requestEmailMode: {
                        title: "INSTANT, DIGEST, or OFF",
                        description: "How often to notify the manager about the intro queue.",
                        example: "INSTANT: every new MATCH pings Telegram. DIGEST: a summary 12 requests are waiting, once a day or week. OFF: you only watch the queue.",
                        tip: "DIGEST is sent no more often than the chosen period, even though the job ticks every 5 minutes.",
                        sections: [
                            {
                                title: "INSTANT",
                                summary: "Right after a PENDING request is created: A new intro request is waiting for review.",
                                bullets: [
                                    "Best when volume is low.",
                                    "Noisy on a large event."
                                ]
                            },
                            {
                                title: "DIGEST",
                                summary: "A periodic count of how many PENDING requests are in the queue.",
                                bullets: [
                                    "One message instead of a dozen.",
                                    "Not sent when the queue is empty."
                                ]
                            },
                            {
                                title: "OFF",
                                summary: "No email or Telegram about the queue.",
                                bullets: [
                                    "The admin badge and the queue itself still work."
                                ]
                            }
                        ]
                    },
                    digestPeriod: {
                        title: "How often to send DIGEST",
                        description: "Interval for the intro-queue summary: once a day or once a week. Shown only when DIGEST is selected.",
                        example: "DIGEST + 1 time per day + Telegram: at most one message per day while the queue has requests.",
                        tip: "If the queue is empty, nothing is sent and the period does not advance."
                    },
                    notifEmail: {
                        title: "Manager email",
                        description: "Whether INSTANT/DIGEST is sent to your participant email. Subjects look like New intro request or Intro queue.",
                        example: "Email on, Telegram off, INSTANT — each new PENDING arrives as email.",
                        tip: "Needs a confirmed email. This switch does not change member ACCEPTED/REJECTED mail."
                    },
                    notifTelegram: {
                        title: "Manager Telegram",
                        description: "The same INSTANT or DIGEST, delivered to Telegram if the community bot is linked to you.",
                        example: "DIGEST + Telegram: 8 intro requests are waiting for review.",
                        tip: "If nothing arrives, check Telegram linking on your profile and that the mode is not OFF."
                    },
                    unreadReminders: {
                        title: "Unread chat reminders",
                        description: "How you are told about chats you have not opened. Push is the instant browser ping. Email and Telegram are where the reminder and full message copy go. Unread reminders is how often the unread count goes out.",
                        example: "Boris writes while you are away. Push = Every message gives a browser ping right away. If the chat stays unread, New messages emails the text about 5 minutes later.",
                        tip: "These are your member settings. They do not change manager emails about the intro queue."
                    },
                    chatNotifEmail: {
                        title: "Email",
                        description: "Whether full new-message copies and unread-chat reminders go to your email.",
                        example: "New messages on + Email: if the chat stays unread, about 5 minutes later you get an email with Boris's text.",
                        tip: "Needs a confirmed email. Turning this off does not stop browser push."
                    },
                    chatNotifTelegram: {
                        title: "Telegram",
                        description: "The same unread reminders, delivered in Telegram if the community bot is linked to you.",
                        example: "1 time per day + Telegram: once a day you get a message like You have 3 unread chats.",
                        tip: "If nothing arrives, link Telegram in your profile and keep Unread reminders other than Off."
                    },
                    chatMessageCopy: {
                        title: "New messages",
                        description: "Send the full text of a new message to Email and Telegram if you do not open the chat for about 5 minutes. This is not the unread count.",
                        example: "Boris writes Hi. If the chat stays closed, about 5 minutes later you get an email with that text and View message.",
                        tip: "Opening the chat cancels it. Email or Telegram above must stay on."
                    },
                    chatPushScope: {
                        title: "Push",
                        description: "A browser or in-app ping when a new message arrives and you are not looking at that chat. Independent from Email and Telegram reminders.",
                        example: "Every message: each reply from Boris pings you. Intros only: ping when the intro chat opens, not on later replies. Off: no push.",
                        tip: "Push still fires even if Unread reminders is Off. It does not use Email or Telegram.",
                        sections: [
                            {
                                title: "Every message",
                                summary: "A ping for any new message in a chat that is not open."
                            },
                            {
                                title: "Intros only",
                                summary: "A ping when a new intro chat opens. Ordinary replies in an existing chat do not push."
                            },
                            {
                                title: "Off",
                                summary: "No browser or in-app push. Email and Telegram reminders are configured separately."
                            }
                        ]
                    },
                    chatUnreadDigest: {
                        title: "Unread reminders",
                        description: "How often to email or Telegram a count of chats that are still unread. Daily and weekly send a count. Off sends none. Full new-message copies are the separate toggle.",
                        example: "1 time per day + Email: if three chats stay unread, you get one email that day, not three.",
                        tip: "Opening the chat cancels the reminder. Push is the separate setting above.",
                        sections: [
                            {
                                title: "1 time per day / week",
                                summary: "One message with the unread count for the chosen period."
                            },
                            {
                                title: "Off",
                                summary: "No unread-count email or Telegram. Push and full new-message copies are configured separately."
                            }
                        ]
                    }
                }
            },
            AdminSettings: {
                menuText: 'Settings',
            }
        },
        errors: {
            emailFormat: "Email is in the wrong format",
            serverError: "Server side error",
            repeatedPassword: "Passwords don't match",
            passwordLength:
                "Length of your password should be between 8 and 128 symbols.",
            errorTitle: "Error",
            tryAgainLater: "Please try again later",
            code: "There is not a recovery code. Could you please use link from letter again.",
            policy: "Confidentiality agreement required",
            1005: "Account not found",
            1011: "Invalid login or password",
            1014: "Invalid password",
        },
        warnings: {
            emailNotConfirmed: (email, communityName, senderEmail) =>
                `Congratulations, now you are in the <span>${communityName}</span> community!<br><br>
                 We have already sent a message from <span>${senderEmail || "community@volee.space"
                }</span> to your email <span>${email}</span>.<br><br>
                 If the email is in Spam or in Promotions, please add our email to your contact list and mark "Not spam". Otherwise, you may miss new relevant contacts from <span>${senderEmail || "community@volee.space"
                }</span>.`,
        },
        components: {
            EventOnboarding: {
                title: "Event Onboarding",
                loading: "Loading questions...",
                retry: "Retry",
                noQuestions: "No onboarding questions available.",
                continue: "Continue",
                progress: "Question",
                of: "of",
                answered: "answered",
                textPlaceholder: "Enter your answer...",
                previous: "Previous",
                next: "Next",
                cancel: "Cancel",
                submitting: "Submitting...",
                complete: "Complete Onboarding",
                key: "Key",
                questionConfigured: "question configured",
                questionsConfigured: "questions configured",
                clickActionsToManage: "Click actions to manage",
                manageOnboardingQuestions: "Manage onboarding questions for",
                answerOptionsWillAppear: "Answer options for this question type can be added after saving",
                addNewQuestion: "Add a new question to your event onboarding",
                updateQuestionDetails: "Update question details and settings",
                resuming: "Resuming onboarding...",
                question: "Question",
                completeText: "Complete",
                saving: "Saving...",
                requiredQuestion: "Required question",
                requiredQuestionError: "This question is required. Please provide an answer before proceeding.",
                saveError: "Failed to save answer. Please try again."
            },
            loader: {
                text: "Loading...",
            },
            logout: {
                alreadyMember: "Already a member?",
                out: "Logout",
                in: "Log In",
            },
            participant: {
                matchingDate: "Matching date",
                online: "online",
                addNote: "Your note",
                save: "Save",
                successText: "Changes saved",
                about: "About",
                lookingFor: "Looking for",
                editProfile: "Edit profile",
                activeNow: "Active now",
                activeMinutesAgo: (n) => `Active ${n}m ago`,
                activeHoursAgo: (n) => `Active ${n}h ago`,
                activeDaysAgo: (n) => `Active ${n}d ago`,
                tags: "Tags",
                contacts: "Contacts",
                companyLabel: "Company, position",
                noCompany: "Company not specified",
                noLocation: "City is hidden",
                relevanceLabel: "Relevance level",
                relevanceCalculating: "Calculating match",
                sharedEventUpcoming: (name, event) =>
                    `You will both attend «${event}» with ${name}`,
                sharedEventPast: (name, event) =>
                    `You both attended «${event}» with ${name}`,
                relevanceTooltip:
                    "The level of common interests, background and goals. If it's high we recommend you to make the meeting with community member",
                bottomNoteText:
                    "Outcomes of the meetings, such as possible topics and offers to the partner. Visible only to you.",
                choiceSaved: "Your choice was saved",
                whyNotInterested: (fullName) =>
                    `Why ${fullName} is not relevant?`,
                notInterested: "Not interested",
                alreadyKnow: "Already know",
                other: "Other",
                clickHereIf: "Click if",
                connectFirst: "Want to see this contact?",
                connectFirstHint: "Connect first to unlock it.",
                interested: "Connect",
                pending: "Pending",
                cancelRequest: "Cancel request",
                cancelRequestConfirm: "Cancel this intro request?",
                keepRequest: "Keep",
                rejectedByModerator: "Rejected by moderator",
                remainingDays: (n) => `${n} days until Connect`,
                openChat: "Open chat",
                interestedMap: {
                    introMessage: (firstName, lastName) =>
                        `We will introduce you to ${firstName} ${lastName}`,
                    introInputLabel: "Write a personal welcome message (optional)",
                    done: "Send",
                    cancel: "Cancel",
                    privacyWarningEN: "This user has hidden their contacts. If you want to get in touch, send your intro message to our moderator at <a href='mailto:community@joinee.io'>community@joinee.io</a>",
                },
                introMessageMap: {
                    introMessage: (firstName, lastName) =>
                        `Your contact for this week ${firstName} ${lastName}
                    <p>Now you can write to your partner directly.
                    Don't be shy to contact your partner first :)</p>`,
                    defaultMessage: (firstName) =>
                        `Hello, ${firstName}!\n\nMatching bot has connected us\nLet's have a call this Wednesday at any desirable time\n\nHere are my contacts:\n\n`,
                    introInputLabel: "Your intro message",
                    done: "Send",
                    cancel: "Skip",
                    introSuccessTitle: "We delivered your message",
                },
                cancel: "Cancel",
                no: "Not",
                fillProfile: (url) => `Complete <a href='/${url}'>profile</a> to see contacts`,
                whyDisabled: "Why is this disabled?",
                connectBlockedTitle: "Fill in your profile first",
                connectBlockedBody: (name, fields) => fields
                    ? `To connect with ${name}, fill in ${fields} first.`
                    : `To connect with ${name}, fill in your profile first.`,
                connectBlockedAction: "Fill in profile",
                profileFieldLabels: {
                    FIRST_NAME: "first name",
                    LAST_NAME: "last name",
                    COMPANY: "company",
                    ABOUT: "about",
                    COMMUNICATION_CHANNELS: "contact channels",
                    CONTACTS: "contacts",
                    AVATAR: "photo",
                    LOCATION: "location",
                },
                createdAt: "Joined",
                invitedBy: "Invited by",
                report: "Report profile",
                messageAlreadySent: "You have already sent an Intro to this person",
                profileLinkCopied: "Profile link copied",
                copied: "Copied",
                buttonTitles: {
                    connect: "Connect",
                    share: "Share",
                    bookmark: "Bookmark",
                    report: "Report",
                    editOnboarding: "Edit onboarding",
                }
            },
            ParticipantAvatars: {
                noParticipantsRegistered: "No participants registered",
                participantAlt: "Participant",
            },
            search: {
                placeholder: "Search for person or expertise",
                showAllCities: "Show all cities",
                cityNames: CITY_NAMES.EN
            },
            commandSearch: {
                search: "Search",
                placeholder: (name) => `Search ${name}...`,
                hint: ({ members = true, events = true, jobs = true } = {}) => {
                    const parts = [
                        members && "members",
                        events && "events",
                        jobs && "jobs",
                    ].filter(Boolean);
                    return parts.length
                        ? `Type to search ${parts.join(", ")}`
                        : "Type to search";
                },
                searching: "Searching...",
                noResults: (query) => `No results found for "${query}".`,
                membersError: "Could not load members. Try again.",
                members: "Members",
                events: "Events",
                career: "Career",
                palette: "Navigation palette",
                press: "Press",
                toClose: "to close",
            },
            question: {
                prompt: (strs, num) =>
                    `You can select ${num === 1 ? "one option" : `from 1 to ${num} options`
                    }`,
                promptInput: "Enter your answer (less than 256 chars)",
                promptSelect: "Select one option",
                promptYearInput: "Select year",
                promptInputPlaceholder: "Enter your answer",
                searchPlaceholder: "Search for options",
                enterYourOption: "Enter your option",
                nocontent: (hasCustomAnswer) =>
                    "No options found" + (hasCustomAnswer ? ".<br/>Please refine your search or enter your own" : ""),
            },
            note: {
                cancel: "Cancel",
                save: "Save",
                more: "more",
                less: "less",
            },
            header: {
                donate: "Support Us",
                support: "Support Community",
                viewProfile: "View Profile",
                settings: "Settings & Preferences",
                adminPanel: "Community Admin Panel",
                adminBadge: "Admin",
                navigation: "Navigation",
                logOut: "Log out",
                signOut: "Sign Out",
                supportText: "Thank you for supporting our community! Your contribution helps us keep the platform running.",
                invite: "Invite",
                copy: "Copy",
                copied: "Link copied",
                invitationTitle: "Invite friends to the community with your personal link",
            },
            notifications: {
                notifications: "Notifications",
                options: "Options",
                settings: "Settings",
                selectAll: "Select all",
                deselectAll: "Deselect all",
                dismiss: "Delete",
                new: "New",
                previously: "Previously",
                confirmEmail: "Please, confirm your email",
                confirmEmailUrl: "Confirm now",
                fillProfile: "Please, continue filling your profile",
                fillProfileUrl: "Go to Profile",
                grantPermissions: "Enable notifications to instantly connect with new contacts",
                grantPermissionsUrl: "Turn on notifications",
                grantPermissionsTitle: "Stay in the loop!",
                rateMeeting: "Rate meeting",
                nocontent: "Nothing new for now",
                close: "Close",

            },
            tour: {
                controls: {
                    back: "Back",
                    close: "Close",
                    last: "Finish",
                    next: "Next",
                    open: "Open the dialog",
                    skip: "Skip"
                },
                communityCard: "Welcome to the Community! Let's quickly show you around.",
                searchForInput: "Drop your request for specific expertise here. Our algorithm uses it to calculate recommended contacts.",
                settingButton: "Use this to change your onboarding answers. For more settings, check out your Profile page.",
                networkButton: "Manage your meeting participation here. Keep it on to get weekly contact recommendations.",
                requestsTab: "Check out what other people are currently looking for at the Requests tab",
                interestedButtons: "Hit 'Connect' to instantly reach out or 'X' to dismiss a recommendation."
            },
            requests: {
                title: "Requests",
                allRequests: "View all requests",
                nocontent: "There are no requests matching your interests yet, but they will appear soon",
                answerOnRequest: ["Answer", "on request"],
                match: "Match",
                answerDefaultText: (firstName, communityTitle) => `\nHi ${firstName},\nI've found your request in the ${communityTitle}!\n\nThis is how I can help you: \n\n\n`,
            },

        },
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
    },

}

export default locals;
